module.exports = {
	"nl": {
		"moet-core": {
			"select_language": {
				"title": "Selecteer uw taal",
				"paragraph": "Dit wordt de standaardtaal",
				"submit": "Oké"
			},
			"products": {
				"mandatory": "Altijd inbegrepen",
				"kco": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Bied al onze betaalmethoden aan."
					},
					"options": {
						"kco-pay-now": {
							"name": {
								"default": "Nu betalen"
							},
							"description": {
								"default": "Bied directe betalingen aan via kaart of bankoverschrijving."
							}
						},
						"kco-pay-later": {
							"name": {
								"default": "Betalen in 30 dagen"
							},
							"description": {
								"default": "Betalen in 30 dagen aanbieden. Geen rente."
							}
						},
						"kco-slice-it": {
							"name": {
								"default": "Financiering"
							},
							"description": {
								"default": "Betalen in 6-36 maanden aanbieden.",
								"DE": "Betalen in 6-24 maanden aanbieden",
								"AT": "Betalen in 6-24 maanden aanbieden."
							}
						},
						"kco-slice-it-in-3": {
							"name": {
								"default": "Afbetalingstermijnen"
							},
							"description": {
								"default": "3 rentevrije afbetalingstermijnen aanbieden.",
								"GB": "3 rentevrije afbetalingstermijnen aanbieden."
							}
						},
						"kco-slice-it-in-4": {
							"name": {
								"default": "Slice it in 4",
								"US": "Afbetalingstermijnen",
								"AU": "Betaal in 4 delen"
							},
							"description": {
								"default": "4 rentevrije afbetalingstermijnen aanbieden.",
								"GB": "4 rentevrije afbetalingstermijnen aanbieden."
							}
						}
					}
				},
				"kp": {
					"name": {
						"default": "Betaalmethoden"
					},
					"description": {
						"default": "Haal meer uit onze losstaande betaaloplossingen. Kies er één of combineer meerdere. Eenvoudige, eenmalige integratie, ongeacht wat je kiest."
					},
					"options": {
						"kp-pay-now": {
							"name": {
								"default": "Nu betalen"
							},
							"description": {
								"default": "Bied directe betalingen aan via kaart of bankoverschrijving."
							}
						},
						"kp-pay-later": {
							"name": {
								"default": "Betalen in 30 dagen"
							},
							"description": {
								"default": "Betalen in 30 dagen aanbieden. Geen rente."
							}
						},
						"kp-slice-it": {
							"name": {
								"default": "Financiering"
							},
							"description": {
								"default": "Betalen in 6-36 maanden aanbieden.",
								"DE": "Betalen in 6-24 maanden aanbieden",
								"AT": "Betalen in 6-24 maanden aanbieden."
							}
						},
						"kp-slice-it-in-3": {
							"name": {
								"default": "Afbetalingstermijnen"
							},
							"description": {
								"default": "3 rentevrije afbetalingstermijnen aanbieden.",
								"GB": "3 rentevrije afbetalingstermijnen aanbieden."
							}
						},
						"kp-slice-it-in-4": {
							"name": {
								"default": "Slice it in 4",
								"US": "4 Betalingen",
								"CA": "4 betalingen",
								"AU": "Betaal in 4 delen"
							},
							"description": {
								"default": "4 rentevrije afbetalingstermijnen aanbieden.",
								"GB": "4 rentevrije afbetalingstermijnen aanbieden.",
								"US": "Bestellingen van $35 tot $1000 kunnen worden opgesplitst in 4 rentevrije betalingen, die elke 2 weken moeten worden voldaan.",
								"CA": "Bestellingen van € 35 tot € 1000 kunnen worden opgesplitst in 4 rentevrije betalingen, elke 2 weken te voldoen."
							}
						}
					}
				},
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Vervang de betaalomgeving van uw winkel door Klarna’s complete betaalservices."
					},
					"description_expanded": {
						"default": "Vervang de betaalomgeving van uw winkel door Klarna’s complete betaalservices."
					}
				},
				"kp_one": {
					"name": {
						"default": "Betaalmethode"
					},
					"description": {
						"default": "Voeg Klarna betaalmethoden toe aan uw betaalomgeving"
					},
					"description_expanded": {
						"default": "Door Klarna-betaalmethoden aan te bieden, stijgt de conversie tot gemiddeld 30%, de AOV 41% en de aankoopfrequentie 36%."
					}
				}
			}
		},
		"products-fe": {
			"error_messages": {
				"validation": {
					"required": "Dit veld is vereist om verder te gaan",
					"generic": "De opgegeven waarde is ongeldig",
					"required_suffix": "is vereist om door te gaan",
					"generic_suffix": "is ongeldig",
					"min_one": "U moet ten minste één element selecteren",
					"min": "U moet ten minste {min} elementen selecteren",
					"max": "U kunt niet meer dan {max} elementen selecteren",
					"given_name": "Voornaam ontbreekt",
					"family_name": {
						"general": "Achternaam ontbreekt",
						"too_short": "Voer een geldige achternaam in"
					},
					"date_of_birth": {
						"general": {
							"default": "Voer een geldige geboortedatum in (DD/MM/JJJJ)",
							"US": "Voer een geldige geboortedatum in (MM/DD/JJJJ)"
						},
						"too_young": "Alle belanghebbenden moeten ouder zijn dan 16 jaar",
						"too_young_eighteen": "U moet ouder zijn dan 18 jaar"
					},
					"street_address": "Voer een adres in",
					"street_address2": "Voer een geldige adresregel 2 in",
					"postal_code": "Voer een postcode in",
					"country": "Voer een land in",
					"region": "Voer een regio in",
					"state": "Voer een staat/provincie in",
					"iban": "Voer een rekeningnummer in (IBAN)",
					"companyName": "Voer een bedrijfsnaam in",
					"email": "Voer een geldig e-mailadres in",
					"contact_email": "Voer een geldig e-mailadres voor contact in",
					"support_email": "Voer een geldig e-mailadres van de klantenservice in",
					"support_phone": "Voer een geldig telefoonnummer van uw support in",
					"selling_countries": "U moet ten minste één land selecteren",
					"store_category": "U moet een van de opties selecteren",
					"name": "Voer een winkelnaam in",
					"legal_form": "Kies een van de beursgenoteerde bedrijfstypen",
					"generic_toggle_undefined": "Selecteer een van de opties",
					"website": "Voer een geldige website-URL in",
					"bankAccounts": "Voer ten minste één bankrekening in",
					"product": "Selecteer een product",
					"platform": "Selecteer een platform",
					"password": "Maak een sterk wachtwoord aan",
					"currency_code": "Voer een valutacode in",
					"account_holder": "Voer een bankrekeninghouder in",
					"account_type": "Voer een bankrekeningtype in",
					"routing_number": "Voer een geldig routingnummer in",
					"account_number": {
						"first": "Voer een geldig rekeningnummer in voor de standaard bankrekening",
						"second": "Voer een geldig rekeningnummer in voor de eerste extra bankrekening",
						"third": "Voer een geldig rekeningnummer in voor de tweede extra bankrekening",
						"fourth": "Voer een geldig rekeningnummer in voor de derde extra bankrekening",
						"general": "Voer een geldig rekeningnummer in"
					},
					"role": "Voer een functie in",
					"address": "Voer een adres in",
					"political_exposed_person": "Voer PEP-informatie in",
					"pep_position": "Voer functie-informatie in",
					"pep_relationship": "Voer informatie over de relatie tot de PEP-persoon in",
					"goodsCategory": "Voer een goederencategorie in",
					"registered": "Voer informatie over uw bedrijfsregistratie in",
					"subjectToVat": "Voer een btw-nummer in",
					"registrationCourt": "Voer een handelsregister in",
					"registrationId": {
						"general": {
							"default": "Voer een geldig registratienummer in",
							"AT": "Voer een geldig registratienummer in",
							"AU": "Voer een geldige ACN in",
							"ES": "Voer een geldig NIF/NIE/DNI van het bedrijf in",
							"GB": "Voer een geldig organisatienummer in",
							"GR": "Voer een geldig G.E.MI.-nummer in (Γ.Ε.ΜΗ.)",
							"CA": "Voer een geldig ondernemingsnummer in",
							"NZ": "Voer een geldig ondernemingsnummer in",
							"US": "Voer een geldig Werkgeversidentificatienummer in"
						},
						"missing_leading_0_GB": "Voer een 8-cijferig organisatienummer in. Uw organisatienummer mist mogelijk een eerste 0 (bijv. 03452678)",
						"invalid": {
							"default": "Voer een geldig registratienummer in",
							"AT": "Registratienummer moet uit 5 tot 11 tekens bestaan. Let op: dit is niet uw btw-nummer of uw handelaars-ID.",
							"AU": "Registratienummer moet uit 9 cijfers bestaan, geen spatie toegestaan. Bijv.: 123456789",
							"BE": "Registratienummer moet uit 10 cijfers bestaan. Bijv.: 1234567890",
							"CA": "Ondernemingsnummer moet uit 9 cijfers bestaan. Bijv.: 123456789",
							"CZ": "Registratienummer moet uit 8 cijfers bestaan. Bijv.: 12345678",
							"DE": "Registratienummer moet uit 6 tot 11 tekens bestaan en moet beginnen met HRA of HRB, gevolgd door een spatie. Let op: dit is niet uw btw-nummer of uw handelaars-ID.",
							"ES": "NIF/NIE/DNI moet 8 of 9 tekens lang zijn, beginnend met 1 letter/cijfer gevolgd door 6 of 7 cijfers en 1 letter/cijfer",
							"FI": "Registratienummer moet uit 8 cijfers met een streepje voor het laatste cijfer bestaan, geen spatie toegestaan. Bijv.: 1234567-8",
							"FR": "Het registratienummer moet 9 cijfers lang zijn, b.v. 123 456 789 of 123456789 (SIREN), of 14 cijfers lang, b.v. 123 456 789 12345 of 12345678912345 (SIRET).",
							"IE": "Het registratienummer moet bestaan uit 2 letters gevolgd door 6 cijfers of alleen 6 cijfers als u een eenmanszaak heeft (bv. AB123456).",
							"IT": "Het registratienummer moet bestaan uit 11 cijfers (bv. 01234567890) of een combinatie van 16 cijfers en hoofdletters (bv. ABCABC12A12A123A)",
							"GB": "Organisatienummer moet uit 8 cijfers bestaan. Bijvoorbeeld: 12345678, of twee letters gevolgd door 6 cijfers (SC123456), of 1 letter gevolgd door 7 cijfers (S1234567)",
							"GR": "Een G.E.MI.-nummer moet uit 12 cijfers bestaan, bijv. 012345678901",
							"NL": "Registratienummer moet uit 8 cijfers bestaan. Bijv.: 12345678",
							"NO": "Registratienummer moet uit 9 cijfers bestaan, geen spatie toegestaan. Bijv.: 123456789",
							"NZ": "Ondernemingsnummer moet uit 13 cijfers bestaan. Bijv.: 1234567890123",
							"PL": "Registratienummer moet uit 10 cijfers bestaan, geen spatie toegestaan. Bijv: 1234561234",
							"PT": "Het registratienummer moet uit 9 cijfers bestaan, geen spatie toegestaan. Bijv.: 123123123",
							"SE": "Registratienummer moet uit 10 cijfers met een streepje bestaan, geen spatie toegestaan. Bijv.: 123456-1234",
							"US": "Het Werkgeversidentificatienummer moet 9 cijfers lang zijn met een \"-\" na de eerste twee. Bijvoorbeeld: 12-3456789",
							"MX": "RFC moet 12 tekens lang zijn, te beginnen met de initialen van het bedrijf, de oprichtingsdatum van 6 cijfers en de controlewaarde. Bijvoorbeeld: ABC921010H20"
						}
					},
					"tocLink": "Er is iets misgegaan met de algemene voorwaarden. Probeer het later opnieuw of neem contact op met onze klantenservice via {supportEmail}",
					"vat": {
						"general": {
							"default": "Voer een geldig btw-nummer in",
							"AU": "Voer een geldig ABN in",
							"ES": "Voer een geldig NIF/NIE/DNI van het bedrijf in",
							"NZ": "Voer een geldig GST-nummer in"
						},
						"invalid": {
							"default": "Ongeldig btw-nummer",
							"AT": "Btw-nummer moet ATU zijn, gevolgd door 8 cijfers. Bijv.: ATU12345678",
							"AU": "ABN moet uit 11 cijfers bestaan.",
							"CZ": "Het btw-nummer moet CZ zijn, gevolgd door 8, 9 of 10 cijfers. Bijv.: CZ123456789",
							"GR": "Het BTW-nummer moet 9 cijfers lang zijn en beginnen met EL. Bijvoorbeeld: EL123456789",
							"DE": "Het btw-nummer moet DE zijn, gevolgd door 9 cijfers. Bijv.: DE123456789",
							"ES": "NIF/NIE/DNI moet 8 of 9 tekens lang zijn, beginnend met 1 letter/cijfer gevolgd door 6 of 7 cijfers en 1 letter/cijfer",
							"FR": "Het BTW-nummer moet FR zijn, gevolgd door 2 letters/cijfers en 9 cijfers (SIREN), bijv. FRXX123456789",
							"GB": "Btw-nummer moet uit 6 tot 15 tekens bestaan.",
							"IE": "Het btw-nummer moet IE zijn, gevolgd door 8 of 9 tekens, waaronder 1 of 2 letters. Bijv: IE1234567WA, IE1234567A",
							"IT": "Het BTW-nummer moet IT zijn, gevolgd door 11 cijfers. Bijvoorbeeld: IT12345678912",
							"NL": "Btw-nummer moet NL zijn, gevolgd door 9 cijfers en vervolgens door B en 2 cijfers. Bijv.: NL123456789B12",
							"NZ": "GST-nummer moet uit 8 cijfers bestaan (12345678) of 9 cijfers, met of zonder koppeltekens om de 3 cijfers (123-123-123 of 123123123)",
							"PL": "Het BTW-nummer moet PL zijn, gevolgd door 10 cijfers. Bijvoorbeeld: PL1234567890",
							"PT": "Het btw-nummer moet PT zijn, gevolgd door 9 cijfers. Bijv.: PT123123123",
							"MX": "RFC moet beginnen met de initialen van het bedrijf, de oprichtingsdatum van 6 cijfers en de controlewaarde. Bijv.: ABC921010H20"
						}
					},
					"personal_id": {
						"US": {
							"general": "Voer de laatste 4 cijfers van uw BSN in",
							"format": "Voer de laatste 4 cijfers van uw BSN in"
						},
						"US_FULL_SSN": {
							"general": "Geef het volledige BSN op (9 cijfers).",
							"format": "Vul uw volledige BSN in (9 cijfers)"
						},
						"CA": {
							"general": "Voer een geldig verzekeringsnummer of paspoortnummer in",
							"format": "Verzekeringsnummer: XXX-XXX-XXX / Passpoortnummer: ABXXXXXX"
						},
						"SE": {
							"general": "Voer een geldig Persoonlijk Identificatienummer in (PNO)",
							"format": "Voer PNO met het volgende formaat in: JJJJMMDD-XXXX"
						},
						"FI": {
							"general": "Voer een geldige Persoonlijke Identificatiecode in (HETU)",
							"format": "Voer HETU met het volgende formaat in: DDMMYYSXXXX"
						},
						"NO": {
							"general": "Voer een geldig Persoonsgebonden Nummer in",
							"format": "Voer het volgende formaat in: DDMMYYXXXX"
						},
						"DK": {
							"general": "Voer een geldig Persoonlijk Identificatienummer in (CPR)",
							"format": "Voer CPR met het volgende formaat in: DDMMYY-XXXX"
						},
						"IT": {
							"general": "Voer een geldig fiscaal nummer in",
							"format": "Voer het fiscaal nummer in het volgende formaat in: CLDNRG84L58H501R"
						},
						"ES": {
							"general": "Voer een geldig persoonlijk identificatienummer in (PIN)",
							"format": "Voer de PIN in, bijv. 12345678A"
						},
						"PL": {
							"general": "Voer een geldige persoonlijke identificatiecode (PESEL) in",
							"format": "Voer de PESEL in de volgende indeling in: YYMMDDZZZXQ"
						},
						"default": {
							"general": "Voer een geldig paspoortnummer in"
						}
					},
					"store_name": "Voer een winkelnaam in"
				},
				"errors_keys": {
					"correlationIdLabel": "Correlation ID: {correlationId}",
					"decisionTaken": "Pre-beoordelingsbeslissing is al genomen. Laat de pagina opnieuw.",
					"maintenanceMode": "Onze app is momenteel niet beschikbaar wegens onderhoud. Kom later terug",
					"validation": {
						"storeName": {
							"invalidType": "Voer een geldige winkelnaam in."
						},
						"email": {
							"invalidType": "Voer een geldig e-mailadres in."
						},
						"goodsCategory": {
							"invalidType": "Voer een goederencategorie in."
						},
						"website": {
							"invalidType": "Voer een geldige website in."
						}
					}
				}
			},
			"general": {
				"yes": "Ja",
				"no": "Nee",
				"encrypted_text": "*******",
				"pricing_link_eu": "Alle prijzen per land bekijken",
				"pricing_link_us": "Prijzen weergeven",
				"formFieldOptional": "optioneel",
				"buttons": {
					"next": "Volgende",
					"back": "Terug",
					"continue": "Verder",
					"submit_application": {
						"default": "Begin nu",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Aan de slag"
					},
					"add_aditional_item": "+ Extra item toevoegen"
				},
				"unknown_step_title": "Verstrek de vereiste informatie",
				"selected": "Geselecteerd",
				"clear_all": "Alles wissen"
			},
			"errors": {
				"general": "Er is een fout opgetreden. Neem contact op met onze ondersteuning.",
				"salesforce": "Probeer de pagina te vernieuwen. Als de fout blijft bestaan, stuur dan het fout-ID naar het #smooothforce-support-ondersteuningskanaal en wij zullen u helpen.",
				"managed_kyc": "Probeer de pagina te vernieuwen. Als de fout blijft bestaan, neem dan contact op met onze webwinkelsupport of uw salescontact.",
				"copy": "Kopiëren",
				"noTermsAccepted": "Lees en accepteer al onze vermelde overeenkomsten",
				"termsAlreadyAccepted": "U hebt alle vermelde overeenkomsten reeds aanvaard",
				"mandatoryField": " is vereist"
			},
			"options": {
				"entity_types": {
					"SOLE_TRADER": "Zelfstandige handelaar",
					"PARTNERSHIP": "Partnerschap",
					"PUBLIC_LISTED_COMPANY": "Beursgenoteerd bedrijf",
					"PRIVATE_COMPANY": "Privébedrijf"
				},
				"organization_entity_types": {
					"C_CORP": "C-bedrijf",
					"S_CORP": "S-bedrijf",
					"PARTNERSHIP": "Partnerschap",
					"TRUST_ESTATE": "Trust/nalatenschap",
					"INDIVIDUAL": "Individu",
					"SOLE_PROPRIETORSHIP": "Eenmanszaak",
					"SOLE_TRADER": "Zelfstandige handelaar",
					"LIMITED_LIABILITY_COMPANY": "Naamloze vennootschap",
					"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Naamloze vennootschap met enkel lid"
				},
				"goods_categories": {
					"ADULT_SHOES_AND_CLOTHING": "Kleding en schoenen - Schoenen en kleding voor volwassenen",
					"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Automobielproducten - Auto-onderdelen en accessoires",
					"BAGS_AND_WALLETS": "Sieraden en accessoires - Tassen en portemonnees",
					"BODY_AND_HAIR_CARE": "Gezondheid en schoonheid - Lichaams- en haarverzorging",
					"BOOK_AND_MAGAZINES": "Entertainment - Boeken en tijdschriften",
					"CANDY": "Voedsel en drank - Snoep",
					"CAR_ELECTRONICS": "Elektronica - Auto-elektronica",
					"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Kinderproducten - Kinderkleding en verzorgingsproducten",
					"CHILDREN_TOYS": "Kinderproducten - Speelgoed voor kinderen",
					"CLEANING_AND_SANITARY": "Huis en tuin - Schoonmaak en hygiëne",
					"COLLECTIBLES": "Vrije tijd, sport en hobby - Verzamelobjecten",
					"CONCEPT_STORES_AND_MISCELLANEOUS": "Vrije tijd, sport en hobby - Conceptwinkels en diverse",
					"COSMETICS": "Gezondheid en schoonheid - Cosmetica",
					"COSTUMES_AND_PARTY_SUPPLIES": "Vrije tijd, sport en hobby - Kostuums en feestspullen",
					"DATING_SERVICES": "Immateriële producten - Datingservices",
					"DECORATION_AND_ART": "Huis en tuin - Decoratie en kunst",
					"DIETARY_SUPPLEMENTS": "Gezondheid en schoonheid - Voedingssupplementen",
					"DIGITAL_SERVICES": "Immateriële producten - Digitale diensten",
					"DIVERSIFIED_CHILDREN_PRODUCTS": "Kinderproducten - Diverse kinderproducten",
					"DIVERSIFIED_ELECTRONICS": "Elektronica - Diverse elektronica",
					"DIVERSIFIED_ENTERTAINMENT": "Entertainment - Divers entertainment",
					"DIVERSIFIED_EROTIC_MATERIAL": "Erotische materialen - Divers erotisch materiaal",
					"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Gezondheid en schoonheid - Diverse gezondheids- en schoonheidsproducten",
					"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Huis en tuin - Diverse huis- en tuinproducten",
					"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Sieraden en accessoires - Diverse juwelen en accessoires",
					"EDUCATION": "Immateriële producten - Onderwijs",
					"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Elektronica - Elektronische apparatuur en bijbehorende accessoires",
					"EROTIC_CLOTHING_AND_ACCESSORIES": "Erotische materialen - Erotische kleding en accessoires",
					"EVENT_TICKETS": "Immateriële producten - Evenementtickets",
					"FOOD_AND_BEVERAGE": "Voedsel en drank - Voedsel en drank",
					"FRAGRANCES": "Gezondheid en schoonheid - Geuren",
					"FURNITURE": "Huis en tuin - Meubilair",
					"GENERAL_SHOES_AND_CLOTHING": "Kleding en schoenen - Algemene schoenen en kleding",
					"HOBBY_ARTICLES": "Vrije tijd, sport en hobby - Hobby-artikelen",
					"HOUSEHOLD_ELECTRONICS": "Elektronica - Elektronica voor in huis",
					"JEWELRY_AND_WATCHES": "Sieraden en accessoires - Sieraden en horloges",
					"KITCHENWARE": "Huis en tuin - Keukengerei",
					"MARKETPLACES": "Immateriële producten - Marktplaatsen",
					"MUSIC_AND_MOVIES": "Entertainment - Muziek en films",
					"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Vrije tijd, sport en hobby - Muziekinstrumenten en apparatuur",
					"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Sieraden en accessoires - Zonnebrillen en lenzen zonder recept",
					"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Elektronica - Kantoormachines en bijbehorende accessoires",
					"OTHER_SERVICES": "Immateriële producten - Overige diensten",
					"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Gezondheid en schoonheid - Persoonlijke verzorging en lichaamsverbetering",
					"PET_SUPPLIES": "Huis en tuin - Huisdierbenodigdheden",
					"PHARMACEUTICAL_PRODUCTS": "Gezondheid en schoonheid - Farmaceutische producten",
					"PLANTS_AND_FLOWERS": "Huis en tuin - Planten en bloemen",
					"PRESCRIPTION_OPTICS": "Gezondheid en schoonheid - Voorgeschreven optica",
					"PRINTS_AND_PHOTOS": "Vrije tijd, sport en hobby - Prints en foto's",
					"SAFETY_PRODUCTS": "Huis en tuin - Veiligheidsproducten",
					"SEX_TOYS": "Erotische materialen - Seksspeeltjes",
					"SPORTS_GEAR_AND_OUTDOOR": "Vrije tijd, sport en hobby - Sportuitrusting en outdoor",
					"TOBACCO": "Voedsel en drank - Tabak",
					"TOOLS_AND_HOME_IMPROVEMENT": "Huis en tuin - Gereedschap en doe-het-zelven",
					"TRAVEL_SERVICES": "Immateriële producten - Reisdiensten",
					"UNDERWEAR": "Kleding en schoenen - Ondergoed",
					"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Entertainment - Videogames en bijbehorende accessoires",
					"WHEELS_AND_TIRES": "Automobielproducten - Wielen en banden",
					"WINE_BEER_AND_LIQUOR": "Voedsel en drank - Wijn, bier en drank",
					"YOUTHFUL_SHOES_AND_CLOTHING": "Kleding en schoenen - Schoenen en kleding voor jongeren",
					"GAMBLING_BETTING_CASINOS_AND_LOTTERY": "Leeftijdsbeperkingen - gokken, wedden, casino's en Loterij",
					"CHARITIES_AND_NGO": "Immateriële producten - goede doelen en NGO-diensten",
					"EROTIC_SERVICES": "Erotische materialen - erotische diensten",
					"FINANCIAL_SERVICES_CRYPTO": "Financiële diensten - cryptogerelateerde activiteiten",
					"FINANCIAL_SERVICES_MSB": "Financiële diensten - geldtransactiekantoor",
					"FINANCIAL_SERVICES_E_WALLETS": "Financiële diensten - e-wallets",
					"FINANCIAL_SERVICES_TRADING": "Financiële diensten - trading",
					"SOCIAL_PLATFORMS_COMMUNITIES": "Immateriële producten - sociale platformgemeenschappen",
					"TRAVEL_AIR_TRAVEL_AND_CRUISE_OPERATORS": "Reizen - Luchtvaart en Cruise-operators",
					"TRAVEL_BROKER_AND_AGENCIES": "Reizen - Bureaus en agentschappen",
					"TRAVEL_GROUND_TRANSPORTATION": "Reizen - Vervoer over land",
					"TRAVEL_ACCOMMODATION_AND_RESORTS": "Reizen - Accommodaties en resorts",
					"EVENT_ORGANIZER": "Evenement - Organisator",
					"EVENT_BROKER_AND_AGENCIES": "Evenement - Bureaus en agentschappen"
				},
				"us_states": {
					"AL": "Alabama",
					"AK": "Alaska",
					"AZ": "Arizona",
					"AR": "Arkansas",
					"CA": "Californië",
					"CO": "Colorado",
					"CT": "Connecticut",
					"DC": "District of Columbia",
					"DE": "Delaware",
					"FL": "Florida",
					"GA": "Georgië",
					"HI": "Hawaï",
					"ID": "Idaho",
					"IL": "Illinois",
					"IN": "Indiana",
					"IA": "Iowa",
					"KS": "Kansas",
					"KY": "Kentucky",
					"LA": "Louisiana",
					"ME": "Maine",
					"MD": "Maryland",
					"MA": "Massachusetts",
					"MI": "Michigan",
					"MN": "Minnesota",
					"MS": "Mississippi",
					"MO": "Missouri",
					"MT": "Montana",
					"NE": "Nebraska",
					"NV": "Nevada",
					"NH": "New Hampshire",
					"NJ": "New Jersey",
					"NM": "New Mexico",
					"NY": "New York",
					"NC": "North Carolina",
					"ND": "North Dakota",
					"OH": "Ohio",
					"OK": "Oklahoma",
					"OR": "Oregon",
					"PA": "Pennsylvania",
					"RI": "Rhode Island",
					"SC": "South Carolina",
					"SD": "South Dakota",
					"TN": "Tennessee",
					"TX": "Texas",
					"UT": "Utah",
					"VT": "Mont",
					"VA": "Virginia",
					"WA": "Washington",
					"WV": "West Virginia",
					"WI": "Wisconsin",
					"WY": "Wyoming"
				},
				"stakeholder": {
					"types": {
						"PERSON": "Persoon",
						"COMPANY": "Bedrijf"
					},
					"roles": {
						"OWNER": "Eigenaar",
						"ULTIMATE_BENEFICIAL_OWNER": "Uiteindelijke begunstigde eigenaar",
						"CONTROL_OVER_MANAGEMENT": "Controle over management",
						"APPLICANT": "Gemachtigde ondertekenaar",
						"SOLE_TRADER": "Zelfstandige handelaar",
						"PARTNER": "Partner"
					}
				},
				"payment_intervals": {
					"DAILY": "Dagelijks",
					"WEEKLY": "Wekelijks"
				},
				"business_concepts": {
					"TRADITIONAL_SALE_OF_GOODS": {
						"label": "Traditionele verkoop van goederen",
						"description": "De handelaar verkoopt producten of diensten op een traditionele manier: de goederen worden geacht volledig te worden gebruikt wanneer ze voor het eerst worden geleverd en er is doorgaans geen verlengde periode tussen bestelling en levering."
					},
					"VOUCHER": {
						"label": "Voucher",
						"description": "Meer dan 10% van de verkoop bestaat uit vouchers en/of cadeaubonnen"
					},
					"MEMBERSHIP": {
						"label": "Lidmaatschap",
						"description": "Meer dan 10% van de verkoop bestaat uit lidmaatschappen"
					},
					"SUBSCRIPTION": {
						"label": "Abonnement",
						"description": "Meer dan 10% van de verkoop bestaat uit abonnementen"
					},
					"PHARMACIES": {
						"label": "Apotheken",
						"description": "Handelaar verkoopt geneesmiddelen die niet of wel op recept verkrijgbaar zijn"
					},
					"US_PHARMACIES": {
						"label": "Apotheken in de VS",
						"description": "Webwinkel verkoopt geneesmiddelen op recept of zonder recept in de VS"
					},
					"MEDICAL_SERVICES": {
						"label": "Medische diensten",
						"description": "Webwinkel verkoopt medische diensten zoals testen, onderzoeken, verpleegkundige verzorging"
					},
					"MARKETPLACES": {
						"label": "Marktplaatsen",
						"description": "Verkoper heeft een relatie als sub-handelaar"
					},
					"FIREARM_DEALERS": {
						"label": "Wapenhandelaar",
						"description": "Handelaar verkoopt wapens, munitie waar vergunning voor vereist is"
					},
					"AUCTIONS": {
						"label": "Veilingen",
						"description": "Handelaar is een veilinghuis"
					},
					"ALCOHOL": {
						"label": "Alcohol",
						"description": "Handelaar verkoopt alcohol"
					},
					"TOBACCO": {
						"label": "Tabak",
						"description": "Handelaar verkoopt tabak met of zonder nicotine of handelaar verkoopt e-sigaretten"
					},
					"HEMP_CBD_THC": {
						"label": "Hennep, CBD of THC",
						"description": "Handelaar verkoopt producten die Hennep, CBD of THC bevatten"
					},
					"DONATIONS_CHARITY": {
						"label": "Donaties en liefdadigheidsinstellingen",
						"description": "De handelaar is een liefdadigheidsorganisatie of organisatie die donaties ontvangt, en die gebruik maakt van “Uitbetaling na afrekening\""
					},
					"TRAVEL": {
						"label": "Reizen",
						"description": "Meer dan 10% van de verkoop bestaat uit reizen"
					},
					"EVENTS": {
						"label": "Evenementen",
						"description": "Meer dan 10% van de verkoop bestaat uit evenementen"
					},
					"COURSES": {
						"label": "Cursussen",
						"description": "Meer dan 10% van de verkoop bestaat uit cursussen"
					},
					"EDUCATIONAL_COURSES": {
						"label": "",
						"description": ""
					},
					"FOOD_DELIVERY": {
						"label": "",
						"description": ""
					},
					"CUSTOMISED_PRE_ORDER_FURNITURE": {
						"label": "",
						"description": ""
					},
					"DIGITAL_CONTENT": {
						"label": "",
						"description": ""
					},
					"GAMING_INDUSTRY": {
						"label": "",
						"description": ""
					}
				}
			},
			"pages": {
				"select_products_page": {
					"page_header": {
						"primary_title": "Hallo, {firstName}",
						"primary_title_without_name": "Hallo,",
						"sub_title": "Meer Klarna is meer Klarna, zei Shakespeare ooit.",
						"sub_title_no_products": "Begin met uw Klarna-ervaring door hieronder een product te kiezen",
						"sub_title_kp_products": "Selecteer een ander Klarna-product",
						"sub_title_ongoing_product": "Doorgaan met het instellen van {productName}"
					},
					"sidebar_left": {
						"products": {
							"title": "Betalingsproducten",
							"text_blocks": [
								{
									"text": "Voeg een oplossing toe aan uw ingestelde opties"
								}
							]
						}
					},
					"buttons": {
						"start": "Start",
						"continue": "Verder",
						"view_summary": "Overzicht bekijken",
						"add_another_product": "Nog een product toevoegen"
					},
					"goodie_bags": {
						"playground": {
							"title": "Speeltuin",
							"text": "Schakel over naar de Speeltuin-omgeving om Test API-inloggegevens te onderzoeken en te genereren, zodat u uw platform kunt testen.",
							"link": "Speeltuin"
						},
						"marketing_assets": {
							"title": "Marketingmiddelen",
							"text": "Het gebruik van Klarna betekent smoooth afrekenen voor uw klanten. Gebruik onze marketingmiddelen om ze enthousiast te maken.",
							"link": "Middelen ophalen"
						},
						"your_application": {
							"title": "Uw aanvraag",
							"text": "Klik hier om uw instellingen te voltooien of uw aanvraaggegevens, waaronder de Algemene voorwaarden, te bekijken.",
							"link": "Open"
						},
						"invite_more_users": {
							"title": "Meer gebruikers uitnodigen",
							"text": "Nodig uw medewerkers uit voor het Handelaarsportaal. U kunt voor iedereen aangepaste toestemmingen instellen!",
							"link": "Gebruikers uitnodigen"
						}
					},
					"footer": {
						"title": "Altijd inbegrepen bij Klarna",
						"list": {
							"merchant_portal": {
								"title": "Het Handelaarsportaal",
								"text_blocks": [
									{
										"text": "Beheer alles van Klarna met volledige toegang tot de backend."
									}
								]
							},
							"global_products": {
								"title": "Wereldwijde producten, lokale gezichten",
								"text_blocks": [
									{
										"text": "Al onze producten zijn gemaakt om te voldoen aan lokale voorkeuren en wetgeving."
									}
								]
							},
							"local_support": {
								"title": "Lokale ondersteuning voor u en uw klanten",
								"text_blocks": [
									{
										"text": "We hebben duizenden mensen die klaar staan om uw klanten te helpen wanneer ze een helpende hand nodig hebben."
									}
								]
							},
							"marketing_tool": {
								"title": "Klarna als marketinghulpmiddel",
								"text_blocks": [
									{
										"text": "We geven u toegang tot Klarna-materialen die u kunt gebruiken voor uw marketinginitiatieven."
									}
								]
							},
							"single_integration": {
								"title": "Enkele integratie, automatische updates",
								"text_blocks": [
									{
										"text": "Eén integratie, geen updates. Nooit."
									},
									{
										"text": "Zodra u Klarna hebt geïntegreerd, is dat ook echt alles. Het is altijd up-to-date en u hoeft helemaal niks te doen."
									}
								]
							},
							"no_risk": {
								"title": "Geen risico voor u of uw klanten",
								"text_blocks": [
									{
										"text": "Uw uitbetalingen zijn altijd gegarandeerd en uw klanten worden gedekt door de kopersbescherming van Klarna."
									}
								]
							}
						}
					}
				},
				"credentials_page": {
					"sidebar_left": {
						"connection_key": {
							"title": "Klarna API-inloggegevens",
							"text_blocks": [
								{
									"text": "Klarna API-inloggegevens koppelen ons product aan uw winkel, zodat u direct kunt beginnen met verkopen."
								}
							]
						},
						"toc_key": {
							"title": "Algemene voorwaarden",
							"text_blocks": [
								{
									"text": "U zult uw algemene voorwaarden voor e-commerce moeten bijwerken"
								}
							]
						},
						"connect_to_your_platform": {
							"title": "Integratie-instructies",
							"text_blocks": [
								{
									"text": ""
								}
							]
						}
					},
					"main": {
						"how_to_use": {
							"title": "Hoe gebruikt u API-inloggegevens?",
							"ordered_list": {
								"one": "Genereer en download uw aanmeldgegevens",
								"two": "Plak de inloggegevens (Klarna API gebruikersnaam en wachtwoord) naar uw platform zoals uitgelegd in de onderstaande integratie-instructies"
							}
						},
						"number_of_live_keys_in_total": {
							"title": "5 Klarna API-inloggegevens in totaal",
							"text": "U kunt maximaal vijf Klarna API-aanmeldgegevens genereren. Haal de eerste hier op en maak vervolgens de rest aan in Instellingen.",
							"button": "Genereer Klarna API-inloggegevens"
						},
						"how_to_update_toc": {
							"title": "Alg. voorw. bijwerken",
							"ordered_list": {
								"one": "Bezoek de link",
								"two": "Lees de instructies en kopieer de tekst",
								"three": "Voeg deze toe aan de algemene voorwaarden van uw webwinkel"
							}
						},
						"update_toc_link": {
							"title": "",
							"text": "Vergeet niet om de tekst bij te werken met de producten waar u zich voor hebt aangemeld.",
							"linkText": "Ga naar Algemene voorwaarden bijwerken >"
						},
						"buttons": {
							"back": "Terug"
						}
					}
				},
				"whats_next_page": {
					"communication": {
						"TRANSACTIONS_REVIEW_AUTOMATED": "Uw aanvraag wordt beoordeeld…",
						"TRANSACTION_DETAILS_STARTED": "Uw aanvraag wordt beoordeeld door ons team. We zullen zo spoedig mogelijk contact met u opnemen.",
						"TRANSACTIONS_REVIEW_MANUAL": "Uw aanvraag wordt beoordeeld door ons team. We zullen zo spoedig mogelijk contact met u opnemen.",
						"TRANSACTIONS_ENABLED": "Gefeliciteerd. U bent klaar om te verkopen met Klarna.",
						"PAYOUTS_REVIEW_AUTOMATED": "Uw aanvraag voor uitbetalingen wordt beoordeeld…",
						"PAYOUTS_REVIEW_MANUAL": "Uw aanvraag voor uitbetalingen wordt beoordeeld door ons team... We zullen zo spoedig mogelijk contact met u opnemen.",
						"PAYOUTS_REVIEW_AWAITING_FIRST_TRANSACTION": "Wacht op uw eerste verkoop via Klarna...",
						"TRANSACTIONS_DISABLED": "Uw account is uitgeschakeld totdat u de stap uitbetalingen inschakelt.",
						"SUSPENDED": "Uw account is opgeschort.",
						"notice": "We hebben momenteel langere dan gemiddelde wachttijden om uw aanvraag te bekijken. Maakt u zich geen zorgen, uw aanvraag wordt bekeken en we zullen contact met u opnemen met informatie over de volgende stappen. Wij waarderen uw geduld en danken u voor uw begrip."
					},
					"statuses": {
						"pending": "In afwachting",
						"done": "Klaar"
					},
					"in_review": {
						"title": "We beoordelen uw aanvraag.",
						"subtitle": "We zijn momenteel bezig met een laatste controle van uw aanvraag bij Klarna om ervoor te zorgen dat alles in het contract klopt. Dit is een handmatig proces, dus de verwerkingstijd kan variëren, maar we handelen het zo snel mogelijk af.",
						"content": {
							"title": "Om de beoordeling zo snel mogelijk te laten verlopen, moet u ervoor zorgen dat het volgende zichtbaar is op uw website:",
							"list": {
								"default": {
									"item_1": "Uw geregistreerde bedrijfsnaam",
									"item_2": "Uw geregistreerde ondernemingsnummer",
									"item_3": "Uw geregistreerd bedrijfsadres",
									"item_4": "Retourbeleid van ten minste 14 dagen",
									"item_5": "E-mailadres of nummer van de klantenservice"
								},
								"US": {
									"item_1": "Geregistreerde bedrijfsnaam",
									"item_2": "Retourbeleid",
									"irem_3": "E-mailadres of nummer van de klantenservice"
								},
								"AU": {
									"item_1": "ABN (Ondernemingsnummer) of geregistreerde bedrijfsnaam.",
									"item_3": "Uw geregistreerd bedrijfsadres",
									"item_4": "Retourbeleid van ten minste 14 dagen",
									"item_5": "E-mailadres of nummer van de klantenservice"
								}
							}
						},
						"footer": "Wij sturen u een e-mail zodra de beoordeling is voltooid of als we aanvullende informatie van u nodig hebben."
					},
					"suspended": {
						"title": "Helaas…",
						"subtitle": "Na het controleren van uw contractgegevens, hebben we uw aanvraag moeten afwijzen. Er kunnen verschillende redenen zijn waarom uw aanvraag niet werd goedgekeurd. Hieronder volgen enkele van de meest voorkomende redenen:",
						"content": {
							"title": "",
							"list": {
								"item_1": "Uw winkel voldoet niet aan de ethische richtlijnen van Klarna.",
								"item_2": "De opgegeven contactpersoon is onbereikbaar.",
								"item_3": "Andere technische of administratieve factoren."
							}
						},
						"footer": "Bedankt voor uw interesse in Klarna. Neem contact met ons op als u vragen heeft of als u zich in de toekomst wilt aanmelden met een andere winkel."
					},
					"disabled": {
						"title": "Uw aanvraag is geblokkeerd.",
						"subtitle": "Uw account is automatisch geblokkeerd omdat er wettelijk verplichte informatie ontbreekt.",
						"content": {
							"title": "Dit gebeurt meestal wanneer Klarna u om bepaalde informatie heeft gevraagd en u niet voor de aangegeven vervaldatum heeft geantwoord."
						},
						"footer": "Als u denkt dat dit een fout is of als u de informatie opnieuw wilt indienen, neem dan contact op met Webwinkelsupport via de contactinformatie in de voettekst van deze pagina."
					},
					"ready_to_connect": {
						"title": "Koppel uw winkel",
						"subtitle": "Uw contract is voltooid en u kunt nu Klarna in uw winkel integreren. Volg de onderstaande stappen om de integratie te voltooien.",
						"status_messsage": {
							"title": "Integratie nog niet voltooid",
							"subtitle": "Volg de integratie-instructies om uw winkel te koppelen. Deze status wordt groen zodra er een transactie is gedaan met Klarna."
						},
						"content": {
							"title": "Instructies",
							"options": {
								"label_1": "Genereer uw Klarna API-inloggegevens en sla ze op.",
								"description_1": "Genereer nieuwe API-inloggegevens en download ze naar uw computer. U zult deze API-inloggegevens nodig hebben in de volgende sectie.",
								"label_2": "Klarna in uw Shopify-winkel installeren"
							}
						}
					},
					"ready_to_connect_new_ig": {
						"title": "U bent er bijna",
						"subtitle": "Nog even en u kunt uw klanten een smoooth shoppingervaring bieden! Uw contract is afgerond en uw winkel klaar voor integratie.",
						"buttons": {
							"connect": "Koppel uw winkel"
						},
						"additional_info": "Houd er rekening mee dat de integratie pas als volledig voltooid wordt gemarkeerd wanneer we de eerste aankoop ontvangen, wat even kan duren afhankelijk van uw platform."
					},
					"store_connected": {
						"title": "Uw winkel is gekoppeld",
						"subtitle": "De integratie van uw winkel met Klarna is voltooid en uw klanten kunnen nu met Klarna betalen.",
						"status_messsage": {
							"title": "Integratie geslaagd",
							"subtitle": "Er is met succes een Klarna-transactie verwerkt via uw winkel.",
							"button_text": {
								"shown": "Toon integratie-instructies",
								"hidden": "Verberg integratie-instructies"
							}
						}
					},
					"actions": {
						"view_summary": {
							"title": "Uw aanvraag",
							"subtitle": "Controleer uw aanvraaginformatie.",
							"button_text": "Bekijk samenvatting"
						},
						"connect_store": {
							"title": "Klarna API-inloggegevens",
							"subtitle": "Genereer uw Klarna API-inloggegevens om uw winkel te integreren.",
							"button_text": "Genereer Klarna API-inloggegevens"
						},
						"add_product": {
							"title": "Producten",
							"subtitle": "Klik hier als u een product wilt toevoegen voor deze instelling.",
							"button_text": "Producten toevoegen"
						}
					},
					"timeline": {
						"application": {
							"title": "Uw aanvraag",
							"alert": {
								"view_summary": "Bekijk samenvatting",
								"rejected": "We moesten uw aanvraag afwijzen.",
								"review": "Bekijk uw aanmeldgegevens door op de onderstaande link te klikken."
							}
						},
						"payouts": {
							"title": "Uitbetalingen ingeschakeld"
						},
						"integration": {
							"title": "Integratie nog niet voltooid",
							"alert": "Volg de integratie-instructies om uw winkel te koppelen."
						},
						"integration_complete": {
							"title": "Integratie voltooid!"
						}
					}
				},
				"summary_page": {
					"header": {
						"title": "Gefeliciteerd, uw instelling is voltooid!",
						"rejection": "Het spijt ons, maar we konden uw instelling niet voltooien."
					},
					"header_new": {
						"title": "Welkom, Klarna-handelaar",
						"subtitle": "Samenvatting",
						"rejection": "Aanvraag afgewezen"
					},
					"joy_section": {
						"approved": {
							"title": "Goedgekeurd!",
							"content": "Uw aanvraag is beoordeeld en goedgekeurd. Volledige toegang tot de dienst van Klarna is nu binnen handbereik. We kunnen niet wachten om met u samen te werken!",
							"button_title": "Controleer uw bestellingen",
							"link": "of onze marketingmiddelen"
						},
						"rejected": {
							"title": "Helaas...",
							"content_1": "Na het beoordelen van uw aanvraag kunnen we uw handelaarscontract niet goedkeuren.",
							"content_2": "Neem gerust contact op met ons ondersteuningsteam voor vragen."
						}
					},
					"sidebar_left": {
						"application_details": "Uw aanvraaggegevens",
						"store_details": {
							"title": "Winkelgegevens",
							"text_blocks": [
								{
									"text": "Een overzicht van uw gegevens"
								}
							]
						},
						"credentials": {
							"title": "Klarna API-inloggegevens",
							"text_blocks": [
								{
									"text": "Je Klarna API-inloggegevens"
								}
							]
						},
						"payouts": {
							"title": "Uitbetalingen",
							"text_blocks": [
								{
									"text": "Uw ingediende bankgegevens"
								}
							]
						},
						"additional_bank_accounts": {
							"title": "Extra bankrekeningen",
							"text_block": null
						},
						"business_owners": {
							"title": "Bedrijfseigenaren",
							"text_blocks": null
						},
						"material_influencers": {
							"title": "Belangrijke beïnvloeders",
							"text_blocks": null
						},
						"stakeholders": {
							"title": "Belanghebbenden",
							"text_blocks": [
								{
									"text": "Uw ingediende informatie"
								}
							]
						}
					},
					"main": {
						"store_details": {
							"business_owners": {
								"title": "Bedrijfseigenaren",
								"no_elements": "U hebt geen bedrijfseigenaren ingediend"
							}
						},
						"payouts": {
							"default_bank_accounts": {
								"title": "Standaard bankrekening",
								"no_elements": "Geen standaard bankrekening beschikbaar"
							},
							"additional_bank_accounts": {
								"title": "Extra bankrekeningen",
								"no_elements": "U hebt geen extra bankrekeningen ingediend"
							}
						},
						"stakeholders": {
							"owners": {
								"title": "Eigenaren",
								"no_elements": "U hebt geen eigenaren ingediend"
							},
							"ultimate_beneficial_owner": {
								"title": "Begunstigde eigenaren",
								"no_elements": "U hebt geen begunstigde eigenaren ingediend"
							},
							"applicant": {
								"title": "Aanvragers",
								"no_elements": "U hebt geen aanvrager ingediend"
							},
							"control_over_management": {
								"title": "Personen met controle over management",
								"no_elements": "U hebt niets ingediend over controle over de belanghebbenden van het management"
							}
						},
						"buttons": {
							"back": "Terug",
							"next_step": "Volgende"
						}
					}
				},
				"additional_products_page": {
					"sidebar_left": {
						"we_have_your_data": {
							"title": "We hebben uw gegevens al",
							"text_blocks": [
								{
									"text": "Dit is de informatie die u ons al eerder hebt gegeven."
								}
							]
						}
					},
					"main": {
						"business_ownership": {
							"no_elements": "U hebt geen bedrijfseigenaren ingediend"
						},
						"buttons": {
							"submit": "Verzenden",
							"back": "Terug"
						}
					}
				},
				"checking_page": {
					"title": "Controleren...",
					"subtitle": "Bedankt voor het indienen van de aanvraag. Even geduld, we zijn bezig met controleren..."
				},
				"success_page": {
					"title": "U kunt nu uw winkel koppelen",
					"subtitle": "Bedankt voor het indienen van de aanvraag.",
					"buttons": {
						"next": "Volgende"
					}
				}
			},
			"components": {
				"split_image_container": {
					"timeline": {
						"basics": "Basisgegevens",
						"business": "Bedrijf",
						"stakeholders": "Belanghebbenden",
						"bank_accounts": "Bankrekeningen"
					}
				},
				"app_error": {
					"title": "De Producten-app is momenteel niet beschikbaar",
					"message": "We ondervinden problemen met onze applicatie en zijn er al mee bezig. We proberen zo snel mogelijk de problemen op te lossen. Probeer het later opnieuw."
				},
				"temporarily_down": {
					"title": "We ondervinden technische problemen",
					"message": "Onze excuses voor het ongemak, en we verzekeren u dat we ons best doen om het probleem op te lossen. Kom later nog eens terug."
				},
				"maintenance_mode": {
					"title": {
						"products_app": "Er wordt momenteel onderhoud uitgevoerd aan onze Producten-app",
						"signup_app": "Er wordt momenteel onderhoud uitgevoerd aan onze Aanmeld-app"
					},
					"message": "We zijn momenteel bezig met het verbeteren van uw ervaring en hopen zo spoedig mogelijk klaar te zijn. Kom later nog eens terug."
				},
				"unknown_merchant": {
					"before_link": "Als u al een overeenkomst met ons hebt, ga dan naar",
					"link_text": "deze pagina",
					"after_link": "voor meer informatie over onze producten!"
				},
				"pre_assessment_error": {
					"title": {
						"invalid_flow_type": "Er is een fout opgetreden.",
						"invalid_token": "Deze link is verlopen"
					},
					"message": {
						"invalid_token_risk": "Neem contact op met het #smooothforce-support ondersteuningskanaal en wij zullen u helpen.",
						"invalid_token": "Neem contact op met uw salescontact.",
						"invalid_flow_type": "Het onboardingstype en de status van deze handelaar zijn niet compatibel. Als u denkt dat het een fout is, neem dan contact op met Handelaarsondersteuning."
					}
				},
				"topbar": {
					"title": "Instellingen",
					"widget_type": {
						"MANAGED_KYC": "KYC-collectie",
						"MANAGED_RISK": "Pre-beoordelingscollectie",
						"MANAGED_SME_RISK": "SME Pre-beoordelingscollectie"
					}
				},
				"product_card": {
					"incompatible_description": "Niet beschikbaar voor uw land/platform",
					"kco_footer_text": "De betaalmethoden die beschikbaar zijn in Klarna Checkout zijn afhankelijk van uw land van registratie en het land waar u aan verkoopt.",
					"products_link_text": "Meer"
				},
				"product_prices_card": {
					"title": "Producten",
					"subtitle": "{country}",
					"pricing": "Prijzen voor {country}",
					"monthly_fee": "maandelijkse kosten",
					"transaction_fee": "transactiekosten",
					"before_link": "Ik ga akkoord met Klarna",
					"link_text": "Algemene voorwaarden",
					"after_link_one_product": "voor dit product",
					"after_link_more_than_one_product": "voor deze producten",
					"product_not_available_in_your_country": "* Dit product is niet beschikbaar voor uw thuismarkt, maar het werkt wel in andere landen.",
					"edit_link": "Bewerken",
					"merchant_agreement": {
						"before_link": "Ik ga akkoord met de",
						"link_text": "Overeenkomst Webshop",
						"after_link_one_product": "voor dit product",
						"after_link_more_than_one_product": "voor deze producten"
					},
					"pricing_annex": {
						"before_link": "Ik ga akkoord met de",
						"link_text": "Prijsvoorwaarden",
						"after_link_one_product": "voor dit product"
					}
				},
				"support_footer": {
					"text": "Ondersteuning in het Engels",
					"copyright": {
						"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Alle rechten voorbehouden.",
						"ap": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579.",
						"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215."
					},
					"terms_and_conditions": "Algemene voorwaarden",
					"privacy_policy": "Privacybeleid",
					"merchant_id": "Webwinkel-ID {merchantId}",
					"email": "moa.support@klarna.com",
					"contact_number": "+46 (8) 123 45 67",
					"support_link": "Handelaarsondersteuning",
					"recaptcha": {
						"1_main_text": "Deze site is beveiligd met reCAPTCHA en de Google",
						"2_privacy_policy": "Privacybeleid van de Merchant Portal",
						"3_and": "en",
						"4_terms_of_service": "Algemene Voorwaarden",
						"5_apply": "zijn van toepassing."
					}
				},
				"global_prices_dialog": {
					"title_eu": "Prijzen voor al onze markten",
					"title_us": "Prijzen",
					"subtitle": "U betaalt alleen een vergoeding per transactie. Dat is pas smoooth!",
					"table": {
						"country": "Land",
						"price_column_heading": "Vergoeding per transactie",
						"global": "Wereldwijd",
						"title": {
							"kp": "Betaalmethoden",
							"kco": "Klarna Checkout",
							"kco_one": "Klarna Checkout",
							"kp_one": "Klarna betaalmethode"
						},
						"headers": {
							"kp_one": "Servicekosten"
						}
					},
					"buttons": {
						"back": "Terug"
					},
					"foot_notes": {
						"global_price": "* Lokale valuta van verkoper, anders "
					}
				},
				"fake_approval": {
					"first_transaction": {
						"title": "Eerste transactie",
						"content": "Voordat we uw uitbetalingsgegevens kunnen bekijken, hebben we een eerste bestelling nodig. Wilt u niet uw eigen geld verspillen? Geen probleem!",
						"button": "Doe alsof!"
					},
					"transactions": {
						"title": "Transacties goedkeuren",
						"content": "U kunt alleen de transactiegoedkeuring van de salesforce nadoen",
						"button": "Goedkeuren"
					},
					"payouts": {
						"title": "Uitbetalingen goedkeuren",
						"content": "U kunt alleen de uitbetalingsgoedkeuring van de salesforce nadoen",
						"button": "Goedkeuren"
					}
				},
				"bank_account_summary": {
					"subtitle": {
						"default": "Standaard bankrekening",
						"additional": "Extra bankrekening {index}",
						"normal": "Bankrekening {index}"
					},
					"currency_code": {
						"label": "Valuta"
					},
					"country_of_bank_account": {
						"label": "Land"
					},
					"account_number": {
						"label": {
							"default": "Rekeningnummer",
							"MX_LOCAL": "CLABE-nummer"
						}
					},
					"account_holder": {
						"label": "Naam rekeninghouder"
					},
					"routing_number": {
						"label": "Routingnummer"
					},
					"transit_number": {
						"label": "Transitnummer "
					},
					"institution_number": {
						"label": "Instellingsnummer"
					},
					"bic": {
						"label": {
							"default": "BIC",
							"AU": "BSB"
						}
					},
					"no_edit_button": "Je kunt je bankgegevens wijzigen na voltooiing van je aanmelding"
				},
				"store_details_summary": {
					"legal_company_name": {
						"label": "Wettelijke naam van het bedrijf"
					},
					"country": {
						"label": "Land"
					},
					"registrationId": {
						"label": {
							"default": "Registratienummer",
							"AT": "Registratienummer",
							"AU": "ACN",
							"CA": "Ondernemingsnummer",
							"ES": "NIF/NIE/DNI van bedrijf",
							"GB": "Organisatienummer",
							"GR": "G.E.MI.-nummer (Γ.Ε.ΜΗ.)",
							"US": "Werkgeversidentificatienummer"
						}
					},
					"organizationRegistrationAuthority": {
						"label": "Handelsregister"
					},
					"goodsCategory": {
						"label": "Goederencategorie"
					},
					"registered": {
						"label": {
							"default": "Geregistreerd bedrijf",
							"AU": "Bedrijf heeft een ACN"
						}
					},
					"subjectToVat": {
						"label": {
							"default": "Bedrijf onderworpen aan btw",
							"AU": "Bedrijf onderworpen aan ABN",
							"ES": "Bedrijf heeft een NIF/NIE/DNI"
						}
					},
					"vatId": {
						"label": {
							"default": "Btw-nummer",
							"AU": "ABN",
							"ES": "NIF/NIE/DNI van bedrijf"
						}
					},
					"storeName": {
						"label": "Naar webwinkel"
					},
					"website": {
						"label": "Website"
					},
					"email": {
						"label": "E-mail klantenservice"
					},
					"entityType": {
						"label": "Entiteitstype"
					},
					"toc_data": {
						"label": "Algemene voorwaarden",
						"toc_approval_text": {
							"before_link": "Uw",
							"link_text": "algemene voorwaarden",
							"after_link": "geaccepteerd op {date}",
							"merchant_agreement": {
								"before_link": "Uw",
								"link_text": "Overeenkomst Webshop",
								"after_link": "geaccepteerd op {date}"
							},
							"pricing_annex": {
								"before_link": "Uw",
								"link_text": "Prijsbijlage",
								"after_link": "geaccepteerd op {date}"
							}
						}
					},
					"companyName": {
						"label": "Naam partnerschap"
					},
					"registeredCompanyName": {
						"label": "Bedrijfsnaam"
					},
					"address": {
						"label": "Adres"
					},
					"operatingAddress": {
						"label": "Bedrijfsadres"
					},
					"organizationEntityType": {
						"label": "Belastingclassificatie"
					}
				},
				"api_key_dialog": {
					"title": "Klarna API-inloggegevens zijn gegenereerd",
					"subtitle": "De inloggegevens worden slechts één keer getoond. Klik op de knop hieronder om uw inloggegevens te downloaden voordat u dit venster sluit.",
					"key_box": {
						"username": {
							"label": "Klarna API-gebruikersnaam"
						},
						"password": {
							"label": "Klarna API-wachtwoord"
						},
						"file_name": "Klarna_inloggegevens"
					},
					"buttons": {
						"download": "Download als .txt"
					}
				},
				"platform_instructions": {
					"step": "Stap {current}/{max}",
					"next": "Volgende",
					"back": "Terug",
					"shopify": [
						{
							"title": "Genereer uw Klarna API-inloggegevens en sla ze op.",
							"step_instructions": [
								[
									{
										"text": "Genereer nieuwe API-inloggegevens en download het bestand naar uw computer. Open het bestand en houd het open, u zult deze API-inloggegevens nodig hebben in de volgende sectie."
									}
								]
							],
							"alternate": [
								{
									"text": "Voor meer gedetailleerde informatie over uw Shopify-integratie volgt u de"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "uitgebreide integratie-handleiding."
								}
							]
						},
						{
							"title": "Klarna in uw Shopify-winkel installeren",
							"step_instructions": [
								[
									{
										"text": "Ga naar de"
									},
									{
										"link": "https://www.klarnapayments.com/merchant_admin/guide/install_app/slice_it_pay_over_time_with_klarna/enter-your-shopify-store-name-here",
										"text": "Klarna Betaalmethoden setupwizard Shopify."
									}
								],
								[
									{
										"text": "Volg de instructies die hierin staan vermeld om de integratie te voltooien."
									}
								]
							],
							"alternate": [
								{
									"text": "Voor meer gedetailleerde informatie over uw Shopify-integratie volgt u de"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "uitgebreide integratie-handleiding."
								}
							]
						},
						{
							"title": "Plaats een testbestelling",
							"step_instructions": [
								[
									{
										"text": "Plaats een testbestelling in uw webwinkel om te verifiëren dat de integratie juist is uitgevoerd."
									}
								],
								[
									{
										"text": "Ga na het plaatsen van de bestelling naar"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Bestellingen in Merchant Portal,"
									},
									{
										"text": "zoek uw bestelling en annuleer deze, om te vermijden dat u zelf moet betalen."
									}
								],
								[
									{
										"text": "Zodra uw integratie geslaagd is, zal de banner bovenaan deze pagina groen worden en de woorden \"Integratie voltooid\" tonen."
									}
								]
							],
							"alternate": [
								{
									"text": "Voor meer gedetailleerde informatie over uw Shopify-integratie volgt u de"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "uitgebreide integratie-handleiding."
								}
							]
						}
					],
					"plentymarkets": [
						{
							"title": "Schakel de Klarna Betaalmethode plug-in voor Plentymarkets in",
							"step_instructions": [
								[
									{
										"text": "U moet gebruik maken van een systeem met Plentymarkets CERES als u de Klarna-plug-in wilt installeren. De"
									},
									{
										"link": "https://marketplace.plentymarkets.com/en/plugins/sales/online-shops/ceres_4697",
										"text": "Ceres Plugin"
									},
									{
										"text": "is te downloaden op plentyMarketplace. Hier wordt u doorgestuurd naar de"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/online-store/setting-up-ceres",
										"text": "installatie-instructies."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Volg deze link voor gedetailleerde informatie over de Klarna-integratie met Plentymarkets Ceres"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "."
									}
								]
							]
						},
						{
							"title": "Installatie en instellingen",
							"step_instructions": [
								[
									{
										"text": "De installatie van de Klarna Plugin kunt u via"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "plentyMarketplace doen."
									},
									{
										"text": "U wordt ook doorgestuurd naar de plentyMarketplace via het backend van het plentymarkets-systeem. Een"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/slp/plugins/plugins-system-hinzufuegen",
										"text": "instructies voor het installeren van plug-ins in plentymarkets"
									},
									{
										"text": "vindt u op plentyKnowledge."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Volg deze link voor gedetailleerde informatie over de Klarna-integratie met Plentymarkets Ceres"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "."
									}
								]
							]
						},
						{
							"title": "Plugin-configuratie",
							"step_instructions": [
								[
									{
										"text": "De plugin wordt direct in de betreffende set geconfigureerd. Door te klikken op de regel van de"
									},
									{
										"bold": "Klarna plug-in"
									},
									{
										"text": "de configuratiepagina wordt geopend."
									}
								],
								[
									{
										"text": "De configuratie is opgedeeld in twee gebieden:"
									},
									{
										"list": [
											[
												{
													"bold": "Authenticatie:"
												},
												{
													"text": "De modus wordt gebruikt om te bepalen of het testen of productie is. Afhankelijk van de modus, zullen de gebruikersnaam en het wachtwoord worden bewaard."
												}
											],
											[
												{
													"bold": "Algemene instellingen:"
												},
												{
													"text": "Hier kunt u het product selecteren dat u wilt gebruiken. Ofwel de individuele betaalmethodes van Klarna (Klarna Payment) of het volledige betalingssysteem van Klarna (Klarna Checkout). Als u het betalingssysteem kiest zal het betalingssysteem van de shop automatisch worden overschreven door Klarna Checkout."
												}
											]
										]
									},
									{
										"text": "U hoeft verder niets in te stellen en als u de plug-in deactiveert zal dit ongedaan worden gemaakt."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Volg deze link voor gedetailleerde informatie over de Klarna-integratie met Plentymarkets Ceres"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "."
									}
								]
							]
						},
						{
							"title": "Laatste informatie",
							"step_instructions": [
								[
									{
										"text": "De volgende systeemvereisten zijn van toepassing:"
									},
									{
										"list": [
											{
												"text": "Plentymarkets versie 7"
											},
											{
												"text": " Ceres- en IO-plug-ins geïnstalleerd "
											}
										]
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Volg deze link voor gedetailleerde informatie over de Klarna-integratie met Plentymarkets Ceres"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "."
									}
								]
							]
						}
					],
					"woocommerce_kco": [
						{
							"title": "De plug-in Klarna Checkout voor WooCommerce inschakelen",
							"step_instructions": [
								[
									{
										"text": "Zorg er eerst voor dat u de plug-in Klarna Checkout voor WooCommerce hebt geïnstalleerd. Als u de plug-in nog niet hebt, ga dan naar"
									},
									{
										"link": "https://woocommerce.com/products/klarna-checkout/#",
										"text": "deze pagina"
									},
									{
										"text": "om deze te installeren."
									}
								],
								[
									{
										"text": "Zodra u uw Klarna API-inloggegevens hebt, gaat u naar “Instellingen” en vervolgens “Afrekenen” in uw WooCommerce-paneel. Kies Klarna-betaling."
									}
								],
								[
									{
										"text": "Schakel Klarna Checkout in door het selectievakje \"Klarna-betaling inschakelen\" aan te vinken."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw WooCommerce-integratie vindt u in hun"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "uitgebreide handleiding."
									}
								]
							]
						},
						{
							"title": "Uw instellingen configureren",
							"step_instructions": [
								[
									{
										"text": "Configureer de instellingen voor uw Klarna Checkout. Let op: het veld “Titel” wordt gebruikt om de titel in te stellen voor de betaalmethode die wordt weergegeven in uw afrekenings- en bestelbevestigingse-mails (d.w.z. Klarna-betaling)."
									}
								],
								[
									{
										"text": "Vink het selectievakje “Testmodus” aan als u bestellingen wilt aanmaken met behulp van de testaanmeldgegevens."
									}
								],
								[
									{
										"text": "Hierna gaat u de landinstellingen invullen. Als u in Europa bent gevestigd, klikt u op \"uitvouwen\" in de sectie Europa. Als u in de VS bent gevestigd, klikt u op \"uitvouwen\" in de sectie Verenigde Staten."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw WooCommerce-integratie vindt u in hun"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "uitgebreide handleiding."
									}
								]
							]
						},
						{
							"title": "Voeg uw Klarna API-inloggegevens toe",
							"step_instructions": [
								[
									{
										"text": "Voeg uw Klarna API-inloggegevens toe in de velden API-gebruikersnaam en Klarna API-wachtwoord."
									}
								],
								[
									{
										"text": "Bewaar uw instellingen."
									}
								],
								[
									{
										"text": "Het laatste dat u moet doen is Klarna Checkout instellen als standaard betalingsmethode. Ga naar “Instellingen” en vervolgens “Betalingen” in uw WooCommerce-paneel. Zoek de sectie “Betaalmethoden” en stel Klarna-betaling in als standaard betaalmethode."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw WooCommerce-integratie vindt u in hun"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "uitgebreide handleiding."
									}
								]
							]
						},
						{
							"title": "Laatste stappen",
							"step_instructions": [
								[
									{
										"text": "Zorg ervoor dat u"
									},
									{
										"link": "https://codex.wordpress.org/Using_Permalinks",
										"text": "die mooie permalinks"
									},
									{
										"text": "in uw WordPress-installatie inschakelt. Anders zullen de callbacks van Klarna naar uw winkel niet werken en zullen bestellingen niet worden bijgewerkt met de juiste bestelstatus/-informatie."
									}
								],
								[
									{
										"text": "Als u uw Klarna-bestelling rechtstreeks in WooCommerce wilt bewerken, moet u de"
									},
									{
										"link": "https://wordpress.org/plugins/klarna-order-management-for-woocommerce/",
										"text": "plug-in Klarna-bestelbeheer"
									},
									{
										"text": "installeren."
									}
								],
								[
									{
										"text": "Controleer of Klarna Checkout wordt weergegeven zoals verwacht door een artikel toe te voegen aan uw winkelmand en naar de kassa te gaan (plaats de bestelling niet daadwerkelijk)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw WooCommerce-integratie vindt u in hun"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "uitgebreide handleiding."
									}
								]
							]
						}
					],
					"woocommerce_kp": [
						{
							"title": "Genereer uw Klarna API-inloggegevens en sla ze op.",
							"step_instructions": [
								[
									{
										"text": "Genereer nieuwe API-inloggegevens en download het bestand naar uw computer. Open het bestand en houd het open, u zult deze API-inloggegevens nodig hebben in de volgende sectie."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Voor meer gedetailleerde informatie over uw WooCommerce-integratie raadpleegt u de"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "uitgebreide integratiehandleiding."
									}
								]
							]
						},
						{
							"title": "Installeer en activeer de Klarna Betaalmethode plug-in",
							"step_instructions": [
								[
									{
										"text": "Installeer de"
									},
									{
										"link": "https://woocommerce.com/products/klarna-payments/",
										"text": "De Klarna Betaalmethode plug-in voor WooCommerce."
									}
								],
								[
									{
										"text": "Ga in uw WooCommerce account naar"
									},
									{
										"bold": "Instellingen → Betalingen → Klarna Betaalmethode."
									}
								],
								[
									{
										"text": "Schakel Klarna Betaalmethode in door het selectievakje Klarna Betaalmethode inschakelen aan te vinken."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Voor meer gedetailleerde informatie over de WooCommerce-integratie volgt u de"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "uitgebreide integratie-handleiding."
									}
								]
							]
						},
						{
							"title": "Configureer uw landinstellingen",
							"step_instructions": [
								[
									{
										"text": "Vul de landinstellingen in. Elk Klarna-land heeft zijn eigen landspecifieke instellingen. Door het toevoegen van webshopreferenties voor een specifiek land activeert u ook Klarna Betaalmethode als een beschikbare betaalmethode voor dat land."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Voor meer gedetailleerde informatie over de WooCommerce-integratie volgt u de"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "uitgebreide integratie-handleiding."
									}
								]
							]
						},
						{
							"title": "Voer uw Klarna API-aanmeldgegevens in",
							"step_instructions": [
								[
									{
										"text": "Voeg uw Klarna API-inloggegevens toe in de velden API-gebruikersnaam en Klarna API-wachtwoord."
									}
								],
								[
									{
										"text": "Bewaar uw instellingen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Voor meer gedetailleerde informatie over de WooCommerce-integratie volgt u de"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "uitgebreide integratie-handleiding."
									}
								]
							]
						},
						{
							"title": "Plaats een testbestelling",
							"step_instructions": [
								[
									{
										"text": "Plaats een testbestelling in je webwinkel om te verifiëren dat de integratie juist is uitgevoerd."
									}
								],
								[
									{
										"text": "Ga na het plaatsen van de bestelling naar"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Bestellingen in Merchant Portal,"
									},
									{
										"text": "zoek uw bestelling en annuleer deze, om te vermijden dat u zelf moet betalen."
									}
								],
								[
									{
										"text": "Zodra uw integratie geslaagd is, zal de banner bovenaan deze pagina groen worden en de woorden \"Integratie voltooid\" tonen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Voor meer gedetailleerde informatie over de WooCommerce-integratie volgt u de"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "uitgebreide integratie-handleiding."
									}
								]
							]
						}
					],
					"magento_kco": [
						{
							"title": "Configureer uw instellingen om Klarna Checkout in te schakelen",
							"step_instructions": [
								[
									{
										"text": "Zorg er eerst voor dat u de module Klarna-betaling voor Magento hebt geïnstalleerd. Als u de module nog niet hebt, ga dan naar"
									},
									{
										"link": "https://marketplace.magento.com/klarna-m2-checkout.html",
										"text": "deze pagina"
									},
									{
										"text": "om deze te installeren."
									}
								],
								[
									{
										"text": "Open uw Magento-paneel zodra u uw Klarna API-inloggegevens hebt. Ga naar \"Winkels\" → \"Configuratie\" → \"Verkoop\" → \"Betaalmethoden\" → \"Klarna\" → \"Klarna API\"."
									}
								],
								[
									{
										"text": "Vouw de sectie “Klarna API” uit en vul uw API-versie, Klarna API-gebruikersnaam en Klarna API-wachtwoord in. Zorg ervoor dat u de testmodus uitschakelt als u klaar bent om uw site live te laten gaan."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Magento-integratie vindt u in hun"
									},
									{
										"link": "https://marketplace.magento.com/media/catalog/product/klarna-m2-checkout-6-2-0-ce/user_guides.pdf",
										"text": "uitgebreide handleiding."
									}
								]
							]
						},
						{
							"title": "Laatste stappen",
							"step_instructions": [
								[
									{
										"text": "Wanneer uw instellingen zijn geconfigureerd, moet u controleren of Klarna-betaling is ingeschakeld in uw afrekenopties."
									}
								],
								[
									{
										"text": "Ga naar “Winkels” → ”Configuratie” → ”Verkoop” → ”Afrekenen” → ”Klarna-betaling-opties”, in uw Magento-paneel."
									}
								],
								[
									{
										"text": "Klarna Checkout zou standaard ingeschakeld moeten zijn. Zo niet, wijzig het dan naar"
									},
									{
										"bold": "Ingeschakeld"
									},
									{
										"text": "onder “Klarna Checkout inschakelen”."
									}
								]
							]
						}
					],
					"magento_kp": [
						{
							"title": "Genereer uw Klarna API-inloggegevens en sla ze op.",
							"step_instructions": [
								[
									{
										"text": "Genereer nieuwe API-inloggegevens en download het bestand naar uw computer. Open het bestand en houd het open, u zult deze API-inloggegevens nodig hebben in de volgende sectie."
									}
								]
							]
						},
						{
							"title": "Installeer en activeer de Klarna Betaalmethode Module",
							"step_instructions": [
								[
									{
										"text": "Bezoek de"
									},
									{
										"link": "https://docs.magento.com/user-guide/payment/klarna-setup.html#set-up-klarna-payments-in-magento",
										"text": "Klarna instellen op Magento Gebruikershandleiding"
									},
									{
										"text": "en volg de instructies die hierin staan vermeld om de module in uw Magento-account te installeren en configureren."
									}
								]
							]
						},
						{
							"title": "Plaats een testbestelling",
							"step_instructions": [
								[
									{
										"text": "Plaats een testbestelling in je webwinkel om te verifiëren dat de integratie juist is uitgevoerd."
									}
								],
								[
									{
										"text": "Ga na het plaatsen van de bestelling naar"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Bestellingen in Merchant Portal,"
									},
									{
										"text": "zoek uw bestelling en annuleer deze, om te vermijden dat u zelf moet betalen."
									}
								],
								[
									{
										"text": "Zodra uw integratie geslaagd is, zal de banner bovenaan deze pagina groen worden en de woorden \"Integratie voltooid\" tonen."
									}
								]
							]
						}
					],
					"shopware_kp": [
						{
							"title": "Schakel de Klarna Betaalmethode plug-in voor Shopware in",
							"step_instructions": [
								[
									{
										"text": "Zorg er eerst voor dat u de plug-in Klarna Betaalmethode voor Shopware hebt geïnstalleerd. Als u de plug-in nog niet hebt, ga dan naar"
									},
									{
										"link": "https://store.shopware.com/en/besti13231874259f/klarna-payments.html",
										"text": "deze pagina"
									},
									{
										"text": "om deze te installeren."
									}
								],
								[
									{
										"text": "In de volgende stap moet u de Klarna Betaalmethode plug-in importeren in Shopware door te klikken op"
									},
									{
										"bold": "Configuratie → Plug-in-manager → Geïnstalleerd → Plug-in uploaden."
									},
									{
										"text": "Klik"
									},
									{
										"bold": "Selecteer"
									},
									{
										"text": "en selecteer het zipbestand van de Klarna Betaalmethode plug-in. Bevestig door te klikken op"
									},
									{
										"bold": "Plug-in uploaden."
									},
									{
										"text": "De plug-in is nu aanwezig in de plug-in-manager."
									}
								],
								[
									{
										"text": "Installeer de plug-in door op het"
									},
									{
										"bold": "groene “+”-pictogram"
									},
									{
										"text": "te klikken."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						},
						{
							"title": "De Klarna Betaalmethode plug-in voor Shopware configureren",
							"step_instructions": [
								[
									{
										"text": "Navigeer naar de plug-in-instellingen door te klikken op"
									},
									{
										"bold": "Configuratie → Basisinstellingen → Zoek naar Klarna Betaalmethode"
									}
								],
								[
									{
										"text": "Voer uw Klarna API-inloggegevens in de velden"
									},
									{
										"bold": "Klarna API-gebruikersnaam"
									},
									{
										"text": "en"
									},
									{
										"bold": "Klarna API-wachtwoord"
									},
									{
										"text": "en sla uw wijzigingen op."
									}
								],
								[
									{
										"text": "Zorg ervoor dat u de live-modus en uw Klarna API-inloggegevens gebruikt."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						},
						{
							"title": "Configureer uw Klarna Betaalmethode-gateway(s)",
							"step_instructions": [
								[
									{
										"text": "Voordat u Klarna gebruikt, moet u uw Klarna Betaalmethode-gateway(s) activeren. U kunt deze vinden door te klikken op"
									},
									{
										"bold": "Configuratie → Betaalmethoden"
									}
								],
								[
									{
										"text": "Standaard worden alle Klarna Betaalmethode-gateways geïnstalleerd. Open de Klarna Betaalmethode-gateways waar u zich voor hebt ingeschreven en activeer ze door"
									},
									{
										"bold": "het vakje"
									},
									{
										"text": "Geactiveerd aan te vinken. Sla uw wijzigingen op."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						},
						{
							"title": "Uw verzendkosten configureren",
							"step_instructions": [
								[
									{
										"text": "Configureer uw verzendkosten voor uw Klarna Betaalmethode-gateway(s) door te klikken op"
									},
									{
										"bold": "Configuratie → Verzendkosten"
									}
								],
								[
									{
										"text": "Selecteer de verzendmethoden die beschikbaar moeten zijn voor Klarna door op het"
									},
									{
										"bold": "potloodpictogram te klikken."
									}
								],
								[
									{
										"text": "Selecteer het tabblad betaalmethodeselectie en verander uw Klarna Betaalmethode-gateway(s) van"
									},
									{
										"bold": "Beschikbaar"
									},
									{
										"text": "naar"
									},
									{
										"bold": "Geselecteerd."
									},
									{
										"text": "Bewaar uw instellingen"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						},
						{
							"title": "Uw Klarna Betaalmethode plug-in activeren",
							"step_instructions": [
								[
									{
										"text": "Vervolgens moet u de Klarna Betaalmethode plug-in activeren. Klik op"
									},
									{
										"bold": "Configuratie → Plug-in-manager → Geïnstalleerd"
									},
									{
										"text": "om naar de Plug-in-manager te gaan."
									}
								],
								[
									{
										"text": "Activeer de plug-in door op het"
									},
									{
										"bold": "rode \"X\"-icoontje"
									},
									{
										"text": "te klikken."
									}
								],
								[
									{
										"text": "U wordt gevraagd of u de cache wilt legen. Klik op"
									},
									{
										"bold": "Ja."
									},
									{
										"text": "Let op: telkens wanneer u iets verandert in de module-instellingen of betaalmethoden voor Klarna moet u de cache wissen en thema's compileren."
									}
								],
								[
									{
										"text": "Om de Klarna Betaalmethode plug-in volledig te activeren moet het winkelthema opnieuw worden gecompileerd. Klik op"
									},
									{
										"bold": "Thema’s compileren"
									},
									{
										"text": "wanneer dit wordt gevraagd."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						},
						{
							"title": "Laatste stappen",
							"step_instructions": [
								[
									{
										"text": "Om afrondingsfouten te voorkomen, moet u zorgen dat u de PHP-extensie bcmath op uw server heeft geïnstalleerd. Hier vindt u de handleiding"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "Hier"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Herstart uw backend om er zeker van te zijn dat alle configuraties in uw winkel beschikbaar zijn."
									}
								],
								[
									{
										"text": "Controleer of uw Klarna Payment-product(en) wordt/worden weergegeven zoals verwacht door een artikel toe te voegen aan uw winkelmand, Klarna als betaalmethode te kiezen, en naar de kassa te gaan (plaats de bestelling niet daadwerkelijk)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						}
					],
					"shopware_kco": [
						{
							"title": "De plug-in Klarna Checkout voor Shopware inschakelen",
							"step_instructions": [
								[
									{
										"text": "Controleer eerst of u de plug-in Klarna Checkout voor Shopware hebt geïnstalleerd (versie 5.2.17 en later). Als u de plug-in nog niet hebt, ga dan naar"
									},
									{
										"link": "https://store.shopware.com/en/besti56121054232f/klarna-checkout.html",
										"text": "deze pagina"
									},
									{
										"text": "om deze te installeren."
									}
								],
								[
									{
										"text": "In een volgende stap moet u de plug-in Klarna-betaling importeren in Shopware door te klikken op"
									},
									{
										"bold": "Configuratie → Plug-in-manager → Geïnstalleerd → Plug-in uploaden."
									},
									{
										"text": "Klik"
									},
									{
										"bold": "Selecteer"
									},
									{
										"text": "en selecteer het zipbestand van de plug-in Klarna Checkout. Bevestig door te klikken op"
									},
									{
										"bold": "Plug-in uploaden."
									},
									{
										"text": "De plug-in is nu aanwezig in de plug-in-manager."
									}
								],
								[
									{
										"text": "Installeer de plug-in door op het"
									},
									{
										"bold": "groene “+”-pictogram"
									},
									{
										"text": "te klikken."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						},
						{
							"title": "De plug-in Klarna Checkout voor Shopware configureren",
							"step_instructions": [
								[
									{
										"text": "Navigeer naar de plug-in-instellingen door te klikken op"
									},
									{
										"bold": "Configuratie → Basisinstellingen → Zoek naar Klarna Checkout"
									}
								],
								[
									{
										"text": "Voer uw Klarna API-inloggegevens in in de velden"
									},
									{
										"bold": "Klarna API-gebruikersnaam"
									},
									{
										"text": "en"
									},
									{
										"bold": "Klarna API-wachtwoord"
									},
									{
										"text": "en sla uw wijzigingen op."
									}
								],
								[
									{
										"text": "Zorg ervoor dat u de live-modus en uw Klarna API-inloggegevens gebruikt."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						},
						{
							"title": "Klarna Checkout gateway activeren",
							"step_instructions": [
								[
									{
										"text": "Voordat u Klarna gebruikt, moet u uw Klarna Payment-gateway activeren. U kunt deze vinden door te klikken op"
									},
									{
										"bold": "Configuratie → Betaalmethoden"
									}
								],
								[
									{
										"text": "Open de Klarna Checkout gateway en activeer dit door het"
									},
									{
										"bold": "het vakje"
									},
									{
										"text": "Geactiveerd aan te vinken. Sla uw wijzigingen op."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						},
						{
							"title": "Uw verzendkosten configureren",
							"step_instructions": [
								[
									{
										"text": "Configureer uw verzendkosten voor uw Klarna Checkout door te klikken op"
									},
									{
										"bold": "Configuratie → Verzendkosten"
									}
								],
								[
									{
										"text": "Selecteer de verzendmethoden die beschikbaar moeten zijn voor Klarna door op het"
									},
									{
										"bold": "potloodpictogram te klikken."
									}
								],
								[
									{
										"text": "Selecteer het tabblad betaalmethodeselectie en verander uw Klarna Checkout van"
									},
									{
										"bold": "Beschikbaar"
									},
									{
										"text": "naar"
									},
									{
										"bold": "Geselecteerd."
									},
									{
										"text": "Bewaar uw instellingen"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						},
						{
							"title": "Uw plug-inKlarna Checkout activeren",
							"step_instructions": [
								[
									{
										"text": "Vervolgens moet u de plug-in Klarna Checkout activeren. Klik op"
									},
									{
										"bold": "Configuratie → Plug-in-manager → Geïnstalleerd"
									},
									{
										"text": "om naar de Plug-in-manager te gaan."
									}
								],
								[
									{
										"text": "Activeer de plug-in door op het"
									},
									{
										"bold": "rode \"X\"-icoontje"
									},
									{
										"text": "te klikken."
									}
								],
								[
									{
										"text": "U wordt gevraagd of u de cache wilt legen. Klik op"
									},
									{
										"bold": "Ja."
									}
								],
								[
									{
										"text": "Om de plug-in Klarna Checkout volledig te activeren moet het winkelthema opnieuw worden gecompileerd. Klik op"
									},
									{
										"bold": "Thema’s compileren"
									},
									{
										"text": "wanneer dit wordt gevraagd."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						},
						{
							"title": "Laatste stappen",
							"step_instructions": [
								[
									{
										"text": "Om afrondingsfouten te voorkomen, moet u zorgen dat u de PHP-extensie bcmath op uw server heeft geïnstalleerd. Hier vindt u de handleiding"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "Hier"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Zorg ervoor dat \"Extra adresregel 1\" en \"Extra adresregel 2\" niet als verplicht zijn gemarkeerd."
									}
								],
								[
									{
										"text": "Herstart uw backend om er zeker van te zijn dat alle configuraties in uw winkel beschikbaar zijn."
									}
								],
								[
									{
										"text": "Controleer of uw Klarna Checkout wordt weergegeven zoals verwacht door een artikel toe te voegen aan uw winkelmand, Klarna als betaalmethode te kiezen, en naar de kassa te gaan (plaats de bestelling niet daadwerkelijk)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						}
					],
					"shopware_6_kp": [
						{
							"title": "Schakel de Klarna Betaalmethode plug-in voor Shopware in",
							"step_instructions": [
								[
									{
										"text": "U moet gebruik maken van een systeem met Shopware 6 als u de plug-in Klarna wilt installeren. De richtlijnen voor installatie vindt u"
									},
									{
										"link": "https://docs.shopware.com/en/shopware-6-en/first-steps/installing-shopware-6",
										"text": "hier."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						},
						{
							"title": "Installatie en instellingen. Er zijn verschillende manieren om de plug-in Klarna te installeren.",
							"step_instructions": [
								[
									{
										"text": "Voer eerst de Wizard uit."
									}
								],
								[
									{
										"text": "Installatie via administratie."
									}
								],
								[
									{
										"text": "Installatie via directe download uit de Community Store."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						},
						{
							"title": "De Klarna Betaalmethode plug-in activeren voor Shopware",
							"step_instructions": [
								[
									{
										"text": "Ga in de Shopware-administratie naar het overzicht van uw plug-ins. U kunt dit openen via"
									},
									{
										"bold": "Instellingen > Systeem > Plug-ins."
									}
								],
								[
									{
										"text": "Selecteer"
									},
									{
										"bold": "Installeren"
									},
									{
										"text": "via het contextmenu (\"...\"). U ontvangt een bericht van Shopware dat de plug-in succesvol is geïnstalleerd."
									}
								],
								[
									{
										"text": "Om veiligheidsredenen is de plug-in nu geïnstalleerd, maar nog niet geactiveerd. U moet deze eerst optimaliseren met uw toegangsgegevens en individuele instellingen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						},
						{
							"title": "Wizard",
							"step_instructions": [
								[
									{
										"text": "Nadat de plug-in is geactiveerd, gaat u naar het"
									},
									{
										"bold": "contextmenu (\"...\") > wizard.",
										"text": "U wordt dan doorgestuurd naar deze routine."
									}
								],
								[
									{
										"text": "De routine begeleidt u tijdens het gehele installatieproces en stelt u in staat om u bij Klarna te registreren als u nog geen dealeraccount hebt."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						},
						{
							"title": "Plugin-configuratie",
							"step_instructions": [
								[
									{
										"bold": "Verkoopkanalen."
									},
									{
										"text": "Hier bepaalt u of de volgende instellingen voor \"alle verkoopkanalen\" zijn of alleen op bepaalde individuele verkoopkanalen van toepassing zijn."
									}
								],
								[
									{
										"bold": "API-instellingen."
									},
									{
										"text": "API-gebruikersnaam en API-wachtwoord: Voer uw API-aanmeldgegevens hier in voor de live- en testmodus in de betreffende secties."
									}
								],
								[
									{
										"text": "U kunt uw Klarna API-inloggegevens testen door op de knop"
									},
									{
										"bold": "Test API-aanmeldgegevens",
										"text": "te klikken, die u in de kop kunt vinden. U ontvangt dan een succesbericht of een indicatie over welke gegevens onjuist blijken te zijn."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						},
						{
							"title": "Plug-in activeren/deactiveren",
							"step_instructions": [
								[
									{
										"text": "Als u de Klarna Betaalmethode plug-in wilt activeren/deactiveren of gewoon de huidige activeringsstatus wilt zien, gaat u naar de Shopware Admin en selecteert u"
									},
									{
										"bold": "Instellingen > Systeem > Plug-ins."
									}
								],
								[
									{
										"text": "U vindt de huidige status in de tabel onder"
									},
									{
										"bold": "\"Mijn plug-ins\"."
									}
								],
								[
									{
										"text": "U kunt de status wijzigen door op de schuifknop te klikken."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						},
						{
							"title": "Laatste stappen",
							"step_instructions": [
								[
									{
										"text": "Zorg dat u de PHP-versie >= 7.2 hebt om afrondingsfouten te voorkomen."
									}
								],
								[
									{
										"text": "Volledige installatie van Shopware"
									},
									{
										"bold": "(Storefront + Administration, niet zonder kop)."
									}
								],
								[
									{
										"text": "Het systeem moet van buitenaf toegankelijk zijn voor het bijwerken van de betaalstatus."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Meer gedetailleerde informatie over uw Shopware-integratie vindt u in hun"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "uitgebreide handleiding. (in het Duits)"
									}
								]
							]
						}
					],
					"3dcart_kp": [
						{
							"title": "Genereer uw Klarna API-inloggegevens en sla ze op.",
							"step_instructions": [
								[
									{
										"text": "Genereer nieuwe API-inloggegevens en download het bestand naar uw computer. Open het bestand en houd het open, u zult deze API-inloggegevens nodig hebben in de volgende sectie."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Voor meer gedetailleerde informatie over uw 3dcart-integratie volgt u de"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "uitgebreide integratie-handleiding."
									}
								]
							]
						},
						{
							"title": "Activeer Klarna Betaalmethode in Online Store Manager",
							"step_instructions": [
								[
									{
										"text": "Log in op uw"
									},
									{
										"link": "https://www.shift4shop.com/login-page.html",
										"text": "3dcart Online Store Manager,"
									},
									{
										"text": "en ga naar"
									},
									{
										"bold": "Instellingen → Betaling."
									}
								],
								[
									{
										"text": "Klik op de Betalingenpagina op de"
									},
									{
										"bold": "Betalingsmethoden selecteren"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "U ziet een lijst met vooraf geïnstalleerde modules. Zoek de Klarna module en activeer deze met de schakelknop."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Voor meer gedetailleerde informatie over uw 3dcart-integratie volgt u de"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "uitgebreide integratie-handleiding."
									}
								]
							]
						},
						{
							"title": "Voer uw Klarna API-inloggegevens in",
							"step_instructions": [
								[
									{
										"text": "Na het activeren van de module, voert u uw Klarna API gebruikersnaam (UID) in het daarvoor bestemde veld in. U vindt deze in het bestand met inloggegevens dat u eerder heeft gedownload."
									}
								],
								[
									{
										"text": "Klik vervolgens op de link"
									},
									{
										"bold": "Wachtwoord Wijzigen"
									},
									{
										"text": "en voer uw Klarna API-wachtwoord in in het veld."
									}
								],
								[
									{
										"text": "Onder"
									},
									{
										"bold": "Taal van het land"
									},
									{
										"text": "selecteer de taal van het land die gebruikt zal worden voor de Klarna betaalopties in de winkel."
									}
								],
								[
									{
										"text": "Boven het veld gebruikersnaam staat een selectievakje met de tekst"
									},
									{
										"bold": "\"Testmodus\"."
									},
									{
										"text": "Vink deze optie aan om de testmodus te activeren, zodat u bestellingen kunt plaatsen zonder kosten of betalingshandelingen tijdens het testen van de module."
									}
								],
								[
									{
										"text": "Als u klaar bent met het configureren van uw instellingen, klikt u rechtsboven op \"Opslaan\"."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Voor meer gedetailleerde informatie over uw 3dcart-integratie volgt u de"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "uitgebreide integratie-handleiding."
									}
								]
							]
						},
						{
							"title": "Plaats een testbestelling",
							"step_instructions": [
								[
									{
										"text": "Plaats een testbestelling in je webwinkel om te verifiëren dat de integratie juist is uitgevoerd."
									}
								],
								[
									{
										"text": "Ga na het plaatsen van de bestelling naar"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Bestellingen in Merchant Portal,"
									},
									{
										"text": "zoek uw bestelling en annuleer deze, om te vermijden dat u zelf moet betalen."
									}
								],
								[
									{
										"text": "Zodra uw integratie geslaagd is, zal de banner bovenaan deze pagina groen worden en de woorden \"Integratie voltooid\" tonen."
									}
								],
								[
									{
										"text": "Als u in de vorige stap de \"Testmodus\" heeft aangezet, vink deze dan weer uit en sla het op voordat u met uw winkel live gaat, zodat uw echte bestellingen correct worden doorgevoerd."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Voor meer gedetailleerde informatie over uw 3dcart-integratie volgt u de"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "uitgebreide integratie-handleiding."
									}
								]
							]
						}
					],
					"bigcommerce_kp": [
						{
							"title": "Genereer uw Klarna API-inloggegevens en sla ze op.",
							"step_instructions": [
								[
									{
										"text": "Genereer nieuwe API-inloggegevens en download het bestand naar uw computer. Open het bestand en houd het open, u zult deze API-inloggegevens nodig hebben in de volgende sectie."
									}
								]
							],
							"alternate": [
								{
									"text": "Voor meer gedetailleerde informatie over de BigCommerce-integratie volgt u de"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "uitgebreide integratie-handleiding."
								}
							]
						},
						{
							"title": "Uw BigCommerce-instellingen configureren",
							"step_instructions": [
								[
									{
										"text": "Ga in BigCommerce naar"
									},
									{
										"link": "http://login.bigcommerce.com/deep-links/settings/payment",
										"text": "Winkelinstellingen → Betalingen,"
									},
									{
										"text": "en klap de sectie Online Betaalmethoden uit. Klik vervolgens op"
									},
									{
										"bold": "Instellen"
									},
									{
										"text": "naast Klarna Betaalmethode."
									}
								],
								[
									{
										"text": "U gaat nu naar het tabblad Instellingen Klarna Betaalmethode. Open het API-aanmeldgegevensbestand dat u in de vorige sectie hebt opgeslagen, en kopieer de gebruikersnaam en het wachtwoord naar hun overeenkomstige velden."
									}
								],
								[
									{
										"text": "Sla uw wijzigingen op als u klaar bent."
									}
								]
							],
							"alternate": [
								{
									"text": "Voor meer gedetailleerde informatie over de BigCommerce-integratie volgt u de"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "uitgebreide integratie-handleiding."
								}
							]
						},
						{
							"title": "Plaats een testbestelling",
							"step_instructions": [
								[
									{
										"text": "Plaats een testbestelling in je webwinkel om te verifiëren dat de integratie juist is uitgevoerd."
									}
								],
								[
									{
										"text": "Ga na het plaatsen van de bestelling naar"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Bestellingen in Merchant Portal,"
									},
									{
										"text": "zoek uw bestelling en annuleer deze, om te vermijden dat u zelf moet betalen."
									}
								],
								[
									{
										"text": "Zodra uw integratie geslaagd is, zal de banner bovenaan deze pagina groen worden en de woorden \"Integratie voltooid\" tonen."
									}
								]
							],
							"alternate": [
								{
									"text": "Voor meer gedetailleerde informatie over de BigCommerce-integratie volgt u de"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "uitgebreide integratie-handleiding."
								}
							]
						}
					],
					"prestashop_kco": [
						{
							"title": "De module Klarna Checkout activeren",
							"step_instructions": [
								[
									{
										"text": "Zorg er eerst voor dat u de officiële Klarna-module voor Prestashop hebt geïnstalleerd. Als u de module nog niet hebt, ga dan naar"
									},
									{
										"link": "https://addons.prestashop.com/en/express-checkout-process/90132-klarna-checkout.html?no_cache=1",
										"text": "deze pagina"
									},
									{
										"text": "om deze te installeren."
									}
								],
								[
									{
										"text": "Helaas zullen deze plug-ins, ontwikkeld door en eigendom van Prestasworks A.B (SI), vanaf 1 januari 2023 niet langer gratis worden verspreid. Als u geïnteresseerd bent in Klarna, kunt u de plug-in kopen of wachten op plug-ins die eigendom zijn van Klarna en die naar verwachting in het tweede kwartaal van 2023 worden uitgebracht."
									}
								],
								[
									{
										"text": "Log in op uw Prestashop-adminpagina en ga naar"
									},
									{
										"bold": "Modules → Modules."
									}
								],
								[
									{
										"text": "Zoek naar Klarna in de zoekbalk om de Klarna-module van Prestaworks AB te vinden. Klik"
									},
									{
										"bold": "Configureren."
									}
								]
							]
						},
						{
							"title": "Uw Klarna-module-instellingen configureren",
							"step_instructions": [
								[
									{
										"text": "U bevindt zich nu op de pagina module-instellingen. Bovenin “Algemene instellingen” ziet u een knop met de naam"
									},
									{
										"bold": "KCO activeren in deze winkel"
									},
									{
										"text": "(Klarna Checkout V3). Kies"
									},
									{
										"bold": "Ja."
									}
								],
								[
									{
										"text": "Klik"
									},
									{
										"bold": "Opslaan"
									},
									{
										"text": "om uw instellingen te bewaren."
									}
								],
								[
									{
										"text": "Klik nu op uw verkoopland in het menu links en voer uw Klarna API-inloggegevens in onder"
									},
									{
										"bold": "Klarna API-gebruikersnaam"
									},
									{
										"text": "en"
									},
									{
										"bold": "Klarna API-wachtwoord."
									}
								],
								[
									{
										"text": "Klik"
									},
									{
										"bold": "Opslaan."
									}
								]
							]
						},
						{
							"title": "Laatste stappen",
							"step_instructions": [
								[
									{
										"text": "Controleer of de testmodus is uitgeschakeld als u klaar bent om uw site live te laten gaan. U kunt dit doen in het tabblad"
									},
									{
										"bold": "Algemene instellingen."
									},
									{
										"text": "De knop"
									},
									{
										"bold": "Proefrit"
									},
									{
										"text": "moet worden ingesteld op"
									},
									{
										"bold": "Nee."
									}
								],
								[
									{
										"text": "Als u in"
									},
									{
										"bold": "Algemene instellingen bent,"
									},
									{
										"text": "zorg ervoor dat u uw instellingen afstemt op hoe u bestellingen wilt verwerken, instellingen voor factuurafspraken, enz."
									}
								],
								[
									{
										"text": "Controleer of uw Klarna Checkout wordt weergegeven zoals verwacht door een artikel toe te voegen aan uw winkelmand en naar de kassa te gaan (plaats de bestelling niet daadwerkelijk)."
									}
								]
							]
						}
					],
					"prestashop_kp": [
						{
							"title": "Genereer uw Klarna API-inloggegevens en sla ze op.",
							"step_instructions": [
								[
									{
										"text": "Genereer nieuwe API-inloggegevens en download het bestand naar uw computer. Open het bestand en houd het open, u zult deze API-inloggegevens nodig hebben in de volgende sectie."
									}
								]
							]
						},
						{
							"title": "Installeer en activeer de Klarna Betaalmethode Module",
							"step_instructions": [
								[
									{
										"text": "Open de"
									},
									{
										"link": "https://addons.prestashop.com/en/payment-card-wallet/90140-klarna-payments.html?no_cache=1",
										"text": "Klarna Betaalmethode Prestashop instructiepagina"
									},
									{
										"text": "en volg de instructies die hier staan vermeld om de module in uw Prestashop-account te installeren en configureren."
									}
								]
							]
						},
						{
							"title": "Plaats een testbestelling",
							"step_instructions": [
								[
									{
										"text": "Plaats een testbestelling in je webwinkel om te verifiëren dat de integratie juist is uitgevoerd."
									}
								],
								[
									{
										"text": "Ga na het plaatsen van de bestelling naar"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Bestellingen in Merchant Portal,"
									},
									{
										"text": "zoek uw bestelling en annuleer deze, om te vermijden dat u zelf moet betalen."
									}
								],
								[
									{
										"text": "Zodra uw integratie geslaagd is, zal de banner bovenaan deze pagina groen worden en de woorden \"Integratie voltooid\" tonen."
									}
								]
							]
						}
					],
					"jumpseller": [
						{
							"title": "Genereer uw live Klarna-inloggegevens.",
							"step_instructions": [
								[
									{
										"text": "U hebt deze aanmeldgegevens nodig om Klarna in uw winkel te integreren."
									}
								]
							]
						},
						{
							"title": "Voeg Klarna toe als nieuwe betaalmethode.",
							"step_instructions": [
								[
									{
										"text": "Ga naar het Jumpseller Admin Panel en navigeer naar Instellingen > Betalingen, zoek 'Klarna' in de aan te vinken lijst en klik op 'Methode toevoegen'."
									}
								]
							]
						},
						{
							"title": "Configureer onze nieuwe betaalmethode.",
							"step_instructions": [
								[
									{
										"text": "In het configuratiescherm van Klarna (Jumpseller Admin Panel en navigeer naar Instellingen > Betalingen > Klarna), (i) voegt u de Klarna API-aanmeldgegevens toe die u in de eerste stap hebt gegenereerd, (ii) selecteert u de EMD-pakketten die u wilt/moet delen met Klarna, en (iii) selecteert u of u de bestellingen automatisch wilt activeren (standaardwaarde is nee)."
									}
								]
							]
						}
					],
					"lightspeed": [
						{
							"title": "Integreer Lightspeed eCom",
							"step_instructions": [
								[
									{
										"text": "Bekijk de integratiehandleiding in"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/eng.pdf",
										"text": "Engels"
									},
									{
										"text": "en in"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/nl.pdf",
										"text": "Nederlands"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"shoper": [
						{
							"title": "Shoper integreren",
							"step_instructions": [
								[
									{
										"text": "Bekijk de integratiehandleiding op"
									},
									{
										"link": "https://www.shoper.pl/help/artykul/klarna-platnosci-odroczone-konfiguracja",
										"text": "de Shoper-webiste"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"timma": [
						{
							"title": "Timma integreren",
							"step_instructions": [
								[
									{
										"text": "Bekijk de integratiehandleiding op"
									},
									{
										"link": "https://help.timma.fi/en/articles/4990994-klarna-payments",
										"text": "de Timma-website"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"smartetailing": [
						{
							"title": "Genereer uw Klarna API-inloggegevens en sla ze op.",
							"step_instructions": [
								[
									{
										"text": "Genereer nieuwe API-inloggegevens en download het bestand naar uw computer. Open het bestand en houd het open, u zult deze API-inloggegevens nodig hebben in de volgende sectie."
									}
								]
							]
						},
						{
							"title": "Integreren met SmartEtailing",
							"step_instructions": [
								[
									{
										"text": "Volg de instructies op"
									},
									{
										"link": "https://www.smartetailing.com/help/financing-with-klarna",
										"text": "de SmartEtailing-website."
									}
								]
							]
						}
					],
					"workstand": [
						{
							"title": "Genereer uw Klarna API-inloggegevens en sla ze op.",
							"step_instructions": [
								[
									{
										"text": "Genereer nieuwe API-inloggegevens en download het bestand naar uw computer. Open het bestand en houd het open, u zult deze API-inloggegevens nodig hebben in de volgende sectie."
									}
								]
							]
						},
						{
							"title": "Integreren met Workstand",
							"step_instructions": [
								[
									{
										"text": "Volg de instructies op"
									},
									{
										"link": "https://www.workstand.com/help/financing-with-klarna",
										"text": "de Workstand-website."
									}
								]
							]
						}
					],
					"jtl5_kco": [
						{
							"title": "Lees de documentatie voor onze plug-in",
							"step_instructions": [
								[
									{
										"text": "Ga naar onze"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "documentatiepagina"
									}
								]
							]
						},
						{
							"title": "Activeer de Klarna Checkout-module voor JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Zorg ervoor dat u de officiële Klarna-extensie heeft geïnstalleerd. Als u die nog niet heeft,"
									},
									{
										"text": "ga dan naar"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "deze pagina"
									},
									{
										"text": "om deze te installeren."
									}
								]
							]
						}
					],
					"jtl5_kp": [
						{
							"title": "Lees de documentatie voor onze plug-in",
							"step_instructions": [
								[
									{
										"text": "Ga naar onze"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "documentatiepagina"
									}
								]
							]
						},
						{
							"title": "Activeer de Klarna Payments-module voor JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Zorg ervoor dat u de officiële Klarna-extensie heeft geïnstalleerd. Als u die nog niet heeft,"
									},
									{
										"text": "ga dan naar"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "deze pagina"
									},
									{
										"text": "om deze te installeren."
									}
								]
							]
						}
					],
					"no_instructions": [
						{
							"title": "Dit is wat u hierna moet doen",
							"step_instructions": [
								[
									{
										"bold": "Genereer uw live Klarna-inloggegevens."
									},
									{
										"text": "U hebt deze aanmeldgegevens nodig om Klarna in uw winkel te integreren."
									}
								],
								[
									{
										"bold": "Voeg de Klarna API-inloggegevens toe aan uw backend systeem om Klarna in te schakelen."
									},
									{
										"text": "Bekijk onze"
									},
									{
										"link": "https://developers.klarna.com/",
										"text": "Ontwikkelaarsportal**"
									},
									{
										"text": "voor meer ondersteuning."
									}
								]
							]
						}
					]
				},
				"stakeholders": {
					"form": {
						"first_name": {
							"label": "Voornaam",
							"error": "Voer een voornaam in"
						},
						"last_name": {
							"label": "Achternaam",
							"error": "Voer een achternaam in"
						},
						"dateOfBirth": {
							"label": {
								"default": "Geboortedatum (DD/MM/JJJJ)",
								"without_format": "Geboortedatum",
								"US": "Geboortedatum (MM/DD/JJJJ)"
							},
							"error": "Voer een geldige datum in",
							"error_too_young": "U moet ten minste 18 jaar oud zijn om te verkopen via Klarna"
						},
						"address": {
							"label": "Woonadres",
							"error": "Voer een adres in"
						},
						"city": {
							"label": "Woonplaats",
							"error": "Voer een stad in"
						},
						"country": {
							"label": "Land",
							"error": "Selecteer een land"
						},
						"postal_code": {
							"label": {
								"default": "Postcode",
								"US": "Postcode"
							},
							"error": {
								"default": "Voer een geldige postcode in",
								"US": "Voer een geldige postcode in"
							}
						},
						"region": {
							"label": "Staat/provincie (optioneel)",
							"label_summary": "Staat/regio"
						},
						"state": {
							"label": "Staat/Provincie",
							"error": "Voer een staat/provincie in"
						},
						"role_question": {
							"OWNER": "Is deze persoon een eigenaar?",
							"BENEFICIAL_OWNER": "Heeft deze persoon controle over meer dan 25% van de aandelen of het stemrecht?",
							"ULTIMATE_BENEFICIAL_OWNER": "Deze persoon bezit of heeft controle over meer dan 25% van de aandelen of het stemrecht"
						},
						"is_person_pep": [
							{
								"text": "Is deze persoon een"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "politiek prominente persoon (PEP)"
							},
							{
								"text": ","
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "directe familie"
							},
							{
								"text": "of"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "bekende collega"
							},
							{
								"text": "van een dergelijke persoon?"
							}
						],
						"pep_relationship": {
							"label": "Relatie",
							"error": "Selecteer de relatie die deze persoon met een PEP heeft"
						},
						"pep_position": {
							"label": "PEP-functie",
							"error": "Selecteer de functie die de PEP heeft"
						},
						"personal_id_question": "Deze persoon heeft geen Persoonlijk Identificatienummer",
						"personal_id": {
							"US": {
								"label": "Burgerservicenummer (laatste 4 cijfers)",
								"label_summary": "Burgerservicenummer"
							},
							"US_FULL_SSN": {
								"label": "Burgerservicenummer",
								"label_summary": "Burgerservicenummer"
							},
							"CA": {
								"label": "Verzekeringsnummer of paspoortnummer",
								"label_summary": "Verzekeringsnummer of paspoortnummer"
							},
							"SE": {
								"label": "Persoonlijk Identificatienummer (PNO)",
								"label_summary": "Persoonlijk Identificatienummer (PNO)"
							},
							"FI": {
								"label": "Persoonlijke Identificatiecode (HETU)",
								"label_summary": "Persoonlijk Identificatienummer (HETU)"
							},
							"NO": {
								"label": "Persoonsgebonden Nummer",
								"label_summary": "Persoonsgebonden Nummer"
							},
							"DK": {
								"label": "Persoonlijk Identificatienummer",
								"label_summary": "Persoonlijk Identificatienummer (CPR)"
							},
							"IT": {
								"label": "Fiscaal nummer",
								"label_summary": "Fiscaal nummer"
							},
							"ES": {
								"label": "Persoonlijk Identificatienummer",
								"label_summary": "Persoonlijk Identificatienummer (PIN)"
							},
							"PL": {
								"label": "Persoonlijk Identificatienummer",
								"label_summary": "Persoonlijk Identificatie Nummer (PESEL)"
							},
							"default": {
								"label": "Paspoortnummer",
								"label_summary": "Paspoortnummer"
							},
							"value": "Vertrouwelijk"
						},
						"registration_number": {
							"label": "Bedrijfsidentificatienummer",
							"error": "Voer het bedrijfsidentificatienummer met het volgende formaat in: XX-XXXXXXXXXXXXX"
						},
						"company_name": {
							"label": "Naam webwinkel",
							"error": "Voer een geldige bedrijfsnaam in"
						},
						"legal_company_name": {
							"label": "Wettelijke naam van het bedrijf",
							"error_label": "Voer de wettelijke naam van het bedrijf in"
						},
						"add_person": "Persoon toevoegen",
						"remove": "Verwijderen",
						"edit": "Bewerken"
					}
				},
				"steps_headers": {
					"merchant": {
						"merchant_id": "Handelaars-ID: {merchantId}"
					}
				},
				"goodie_bags": {
					"marketing_material": {
						"title": "Marketingmateriaal",
						"text": "U maakt nu deel uit van de Klarna-familie. Hier is een pak materiaal en nog veel meer om mee te beginnen.",
						"link": "Download"
					},
					"invite_more_users": {
						"title": "Meer gebruikers uitnodigen",
						"text": "Nodig uw medewerkers uit voor het Handelaarsportaal. U kunt voor iedereen aangepaste toestemmingen instellen!",
						"link": "Gebruikers uitnodigen"
					}
				},
				"terms_and_conditions_confirmation": {
					"title": "Producten en prijzen",
					"subtitle": "{country}",
					"pricing": "Prijzen voor {country}",
					"monthly_fee": "maandelijkse kosten",
					"transaction_fee": "transactiekosten",
					"before_link": "Ik ga akkoord met Klarna",
					"link_text": "algemene voorwaarden",
					"after_link_one_product": "voor dit product",
					"after_link_more_than_one_product": "voor deze producten",
					"product_not_available_in_your_country": "* Dit product is niet beschikbaar voor uw thuismarkt, maar het werkt wel in andere landen."
				},
				"product_description": {
					"product_attributes": {
						"installed": {
							"text": "Geïnstalleerd"
						},
						"in_progress": {
							"text": "In uitvoering"
						}
					}
				},
				"phone_collection_block": {
					"title": "Heeft u problemen met uw Klarna integratie?",
					"description": "Laat je nummer hieronder achter en een van onze medewerkers zal je bellen om je te helpen bij het toevoegen van Klarna aan je e-commerce.",
					"success_banner": "Bedankt! Ons team zal zo snel mogelijk contact met je opnemen.",
					"submit": "Verzenden",
					"fields": {
						"phone": {
							"label": "Telefoonnummer",
							"tooltip": "Je moet de landcode invoeren, bijv. +1 541 754 3010",
							"errors": {
								"required": "Telefoonnummer is verplicht",
								"invalid": "Ongeldig telefoonnummer"
							}
						}
					}
				}
			},
			"containers": {
				"applicant": {
					"title": {
						"unmanaged": "Wie tekent de contracten voor uw bedrijf?",
						"managed": "Wie tekent de contracten voor het bedrijf?",
						"recollection": "Wie is bevoegd om namens uw bedrijf te tekenen?"
					},
					"subtitle": {
						"unmanaged": "Uw bedrijf staat op het punt om een contract te sluiten met Klarna. We moeten nagaan wie wettelijk bevoegd is om contracten te ondertekenen.",
						"managed": "Informeer ons over alle bevoegde ondertekenaars van uw bedrijf de overeenkomst aangaan. Wij zijn wettelijk verplicht om de ondertekeningsbevoegdheid van deze vertegenwoordigers te valideren.  Als niemand uit de lijst de overeenkomst ondertekend heeft, klikt u op \"Persoon toevoegen\" en verstrekt u de vereiste informatie.",
						"recollection": "Aangezien uw bedrijf een actieve overeenkomst heeft met Klarna, zijn wij wettelijk verplicht om informatie over al uw wettelijke vertegenwoordigers te verzamelen en te controleren."
					},
					"form_title": "Voer informatie in",
					"robot_message": {
						"unmanaged": "Dit zijn meestal de leden van de raad van bestuur of leidinggevenden zoals de CEO, de CFO of de COO. Door twee of meer personen op te geven kan de goedkeuring van het contract worden versneld.",
						"managed": "Dit zijn meestal de leden van de raad van bestuur of leidinggevenden zoals de CEO, de CFO of de COO. Door twee of meer personen op te geven kan de goedkeuring van het contract worden versneld."
					},
					"error_tooltip": {
						"too_young": "Deze persoon kan de aanvraag niet indienen omdat diegene nog geen {minAge} jaar oud is."
					},
					"alert_all_too_young": "Alle personen die de overeenkomst aangaan moeten ouder zijn dan {minAge}. Om verder te gaan, voegt u een aanvrager toe die ouder is dan {minAge} jaar.",
					"buttons": {
						"next": "Volgende",
						"back": "Terug",
						"add_person": "+ Persoon toevoegen"
					},
					"role": {
						"recollection": "Juridisch vertegenwoordiger"
					}
				},
				"application_summary": {
					"title": "Controleer en dien je aanvraag in.",
					"subtitle": {
						"unmanaged": "Bekijk uw gegevens voordat u ze indient.",
						"managed": "Bekijk de gegevens voordat u ze indient."
					},
					"stakeholders": {
						"title": "Bedrijfsmanagement",
						"subtitle": "Belanghebbende {index}"
					},
					"businessDetailsCard": {
						"title": "Bedrijfsgegevens"
					},
					"businessDetailsCardFields": {
						"companyName": "Bedrijfsnaam",
						"organizationEntityType": "Belastingclassificatie",
						"organizationRegistrationAuthority": "Handelsregister",
						"goodsCategory": "Goederencategorie",
						"registrationId": {
							"default": "Registratienummer",
							"AT": "Registratienummer",
							"AU": "ACN",
							"CA": "Ondernemingsnummer",
							"ES": "NIF/NIE/DNI van bedrijf",
							"GB": "Organisatienummer",
							"GR": "G.E.MI.-nummer (Γ.Ε.ΜΗ.)",
							"NZ": "Ondernemingsnummer",
							"US": "Werkgeversidentificatienummer"
						},
						"registered": {
							"default": "Geregistreerd bedrijf",
							"AU": "Bedrijf heeft een ACN"
						},
						"subjectToVat": {
							"default": "Bedrijf onderworpen aan btw",
							"AU": "Bedrijf onderworpen aan ABN"
						},
						"vatId": {
							"default": "Btw-nummer",
							"AU": "ABN",
							"NZ": "GST-nummer",
							"ES": "NIF/NIE/DNI van bedrijf"
						},
						"storeName": "Naar webwinkel",
						"storeName_us": "Merknaam / DBA",
						"website": "Website",
						"email": "E-mail klantenservice",
						"entityType": "Entiteitstype"
					},
					"companyRegistrationAddressCard": {
						"title": "Registratieadres bedrijf"
					},
					"companyAddressCard": {
						"title": "Bedrijfsadres"
					},
					"operatingAddressCard": {
						"title": "Operationeel bedrijfsadres"
					},
					"documentsCard": {
						"title": "Geüploade documenten"
					},
					"buttons": {
						"edit": "Bewerken",
						"back": "Terug",
						"submit": "Verzenden"
					},
					"noTermsAccepted": "Lees en accepteer de algemene voorwaarden",
					"noTermsAcceptedWithPricingAnnex": "Lees en accepteer de Webshopovereenkomst en Prijsvoorwaarden"
				},
				"artificial_ultimate_beneficial_owner": {
					"title": {
						"default": "Wie beheert het bedrijf?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Wij zijn wettelijk verplicht door de anti-witwasrichtlijn van de EU ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") wettelijk verplicht om deze informatie te verzamelen."
							}
						],
						"US": [
							{
								"text": "Als financiële instelling zijn wij wettelijk verplicht deze informatie te verzamelen."
							}
						],
						"CA": [
							{
								"text": "Als financiële instelling zijn wij wettelijk verplicht deze informatie te verzamelen."
							}
						],
						"AU": [
							{
								"text": "Als financiële instelling zijn wij wettelijk verplicht deze informatie te verzamelen."
							}
						]
					},
					"infobox": {
						"default": "Vul de persoonlijke gegevens en het woonadres van de CEO van het bedrijf in.",
						"US": "Vul de persoonlijke gegevens en het woonadres in van de meerderheidsaandeelhouder of een manager op hoog niveau, zoals de CEO, CFO of COO.",
						"CA": "Vul de persoonlijke gegevens en het woonadres in van de meerderheidsaandeelhouder of een manager op hoog niveau, zoals de CEO, CFO of COO."
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"managed_artificial_ultimate_beneficial_owner": {
					"title": "Is dit bedrijf een staatsbedrijf of volledig eigendom van een staatsbedrijf?",
					"title_stakeholder": "Wie beheert het bedrijf?",
					"subtitle": "Als financiële instelling zijn wij wettelijk verplicht deze informatie te verzamelen.",
					"subtitle_stakeholder": "Vul de persoonlijke gegevens en het woonadres van de CEO van het bedrijf in.",
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"bank_account": {
					"title": {
						"default": "Wat zijn uw bankgegevens?"
					},
					"subtitle": {
						"US": "Klarna-transacties worden naar deze bankrekening overgemaakt.",
						"default": "We zullen deze bankrekeninggegevens gebruiken om de betalingen voor uw verkoop over te dragen."
					},
					"no_more_bank_accounts": "U hebt al bankrekeningen toegevoegd voor alle ondersteunde valuta. Goed gedaan!",
					"robot_message_general": "De standaard bankrekening moet bij een bank zijn in het land waar uw bedrijf is geregistreerd. U moet ook een bankrekening hebben voor elk van de valuta die u wilt accepteren.",
					"robot_message": "IBAN staat voor International Bank Account Number (internationaal bankrekeningnummer) en uw bank verstrekt deze voor uw rekening. Bijv.: GB98 MIDL 0700 9312 3456 78",
					"robot_message_account_number": {
						"AU": "Het rekeningnummer wordt door uw bank verstrekt en bestaat uit 6 tot 10 cijfers. Bijvoorbeeld: 12345678",
						"US": "Het rekeningnummer wordt door uw bank verstrekt en bestaat uit 5 tot 17 cijfers. Bijvoorbeeld: 12345678",
						"GB": "Het rekeningnummer wordt door uw bank verstrekt en bestaat uit 8 cijfers. Bijvoorbeeld: 12345678. Sommige banken in het Verenigd Koninkrijk bieden kortere rekeningnummers (d.w.z. 7 cijfers). In dit geval voegt u nullen toe aan het begin van uw nummer om de lengte op 8 te brengen."
					},
					"robot_message_revolut": "Het IBAN dat u hebt aangeleverd kan geen binnenlandse GBP-betalingen ontvangen. U moet contact opnemen met uw bank en rekeninggegevens aanvragen die binnenlandse GBP-overdrachten ondersteunen.",
					"robot_message_local": "Het IBAN dat u heeft opgegeven is een lokaal IBAN voor uw bank, dat niet door ons wordt ondersteund. U dient contact op te nemen met uw bank en uw persoonlijke IBAN op te vragen of een andere rekening te gebruiken om te kunnen koppelen met Klarna.",
					"buttons": {
						"add_bank_account": "+ Bankrekening toevoegen",
						"skip": "Overslaan (voor nu)",
						"remove": "Verwijderen",
						"submit": "Verzenden",
						"next": "Volgende",
						"back": "Terug"
					},
					"fields": {
						"currency_code": {
							"label": "Valuta",
							"disable_reason": {
								"account_in_merchant_currency_required": "De standaardvaluta is {currency} vanwege het land waar uw bedrijf is geregistreerd."
							},
							"errors": {
								"general": "Selecteer een valuta"
							}
						},
						"country_of_bankaccount": {
							"label": "Land",
							"errors": {
								"general": "Selecteer een land"
							}
						},
						"iban_account_number": {
							"label": "Rekeningnummer (IBAN)",
							"errors": {
								"general": "Voer een bankrekeningnummer (IBAN) in"
							}
						},
						"use_as_default_bank_account": {
							"label": "Gebruik deze rekening voor niet-gespecificeerde valuta's",
							"tooltip": "Bestellingen met valuta's die niet op deze pagina vermeld staan, worden op deze rekening uitbetaald. Voor sommige valuta’s kan uw bank extra kosten aanrekenen."
						},
						"local_account_number": {
							"label": {
								"default": "Rekeningnummer",
								"MX": "CLABE-nummer"
							},
							"errors": {
								"general": {
									"default": "Voer een bankrekeningnummer in",
									"MX": "Voer een geldig CLABE-nummer in"
								}
							}
						},
						"account_holder": {
							"label": "Naam rekeninghouder",
							"errors": {
								"general": "Voer de naam van de rekeninghouder in (maximaal 70 tekens)."
							}
						},
						"transit_number": {
							"label": "Transitnummer ",
							"errors": {
								"general": "Voer een geldig transitnummer in"
							}
						},
						"institution_number": {
							"label": "Instellingsnummer",
							"errors": {
								"general": "Voer een geldig instellingsnummer in"
							}
						},
						"bic": {
							"label": {
								"AU": "BSB"
							},
							"errors": {
								"general": {
									"AU": "Voer een geldig BSB-nummer (bank state branch) in"
								}
							},
							"tooltip": {
								"AU": "De BSB-code moet uit 6 cijfers bestaan, gescheiden door een -. Bijv: 123-456"
							}
						},
						"routing_number": {
							"label": {
								"default": "Routingnummer",
								"GB": "Sort-code"
							},
							"errors": {
								"general": {
									"default": "Voer een geldig routingnummer in",
									"GB": "Voer een geldige sort-code in"
								}
							}
						}
					}
				},
				"control_over_management": {
					"title": {
						"default": "Wie beheert het bedrijf?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Wij zijn wettelijk verplicht door de anti-witwasrichtlijn van de EU ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") wettelijk verplicht om deze informatie te verzamelen."
							}
						],
						"GB": [
							{
								"text": "We zijn wettelijk verplicht om deze informatie te verzamelen. Zorg ervoor dat uw gegevens in het Companies House up-to-date zijn."
							}
						]
					},
					"infobox": "Vul de persoonlijke gegevens en het woonadres in van de personen die zeggenschap hebben over het bestuur van uw bedrijf, zoals de algemeen directeur of bestuursleden.",
					"buttons": {
						"next": "Volgende",
						"back": "Terug",
						"add_person": "+ Persoon toevoegen"
					},
					"messages": {
						"lookup": "Beheren deze mensen uw bedrijf? Kijk goed en bevestig indien juist."
					}
				},
				"de_registration_information": {
					"title": {
						"unmanaged": "Is uw bedrijf een geregistreerd bedrijf?",
						"managed": "Is het bedrijf een geregistreerd bedrijf?"
					},
					"subtitle": {
						"unmanaged": "We hebben uw bedrijfsregistratienummer nodig om uw bedrijfsgegevens te bevestigen.",
						"managed": "We hebben het bedrijfsregistratienummer nodig om de bedrijfsgegevens te bevestigen."
					},
					"question": {
						"title": {
							"unmanaged": "Voer uw registratienummer en handelsregister in",
							"managed": "Voer het registratienummer en handelsregister in"
						}
					},
					"fields": {
						"registration_number": {
							"label": "Registratienummer"
						},
						"registration_court": {
							"label": "Handelsregister",
							"errors": {
								"general": {
									"unmanaged": "Selecteer uw handelsregister",
									"managed": "Selecteer het handelsregister"
								}
							}
						}
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"documents": {
					"title": "Upload uw document(en)",
					"subtitle": "Wij vragen u ons enkele aanvullende documenten toe te zenden, zodat wij uw identiteit kunnen valideren. Upload alleen <strong>JPG-</strong>, <strong>PNG-</strong> of <strong>PDF-</strong>bestanden (maximale bestandsgrootte 10 MB).",
					"subheadline": {
						"default": "Aangezien Klarna een bank is met het hoofdkantoor in Zweden en daardoor gereguleerd wordt door de Zweedse financiële toezichthoudende autoriteit, moet Klarna voldoen aan EU-richtlijnen EU 2015/849. Klarna is verplicht informatie te verzamelen over de mensen die het bedrijf leiden, daarna kunt u beginnen met het gebruik van de diensten van Klarna. Upload alleen <strong>JPG-, PNG- of PDF-bestanden</strong> (max. bestandsgrootte 10 MB)",
						"US": "Aangezien Klarna een bank is met het hoofdkantoor in Zweden en daarom onder toezicht staat van de Zweedse financiële toezichthouder, moet Klarna voldoen aan EU-richtlijn EU 2015/849. Klarna is verplicht om informatie te verzamelen over de mensen die het bedrijf besturen, zodat u de diensten van Klarna kunt gaan gebruiken. U dienst ons de volgende documenten te verstrekken om uw identiteit te bevestigen. Upload alleen JPG-, PNG- of PDF-bestanden (maximale bestandsgrootte 10 MB).",
						"IT": "Aangezien Klarna een bank is met het hoofdkantoor in Zweden en daarom onder toezicht staat van de Zweedse financiële toezichthouder, moet Klarna voldoen aan EU-richtlijn EU 2015/849. Klarna moet informatie verzamelen over de mensen die het bedrijf besturen, zodat u de diensten van Klarna kunt gaan gebruiken. Houd er rekening mee dat uw bedrijf moet zijn ingeschreven bij de Kamer van Koophandel om door te gaan met de aanvraag. Upload alleen JPG-, PNG- of PDF-bestanden (maximale bestandsgrootte 10 MB)"
					},
					"header_title": "Documenten",
					"stakeholder": "Belanghebbende",
					"business_documents": "Bedrijfspapieren",
					"browse_files": "Bestanden doorzoeken",
					"optional": "(optioneel)",
					"upload_area": {
						"title": {
							"before_link": "Sleep uw bestanden hier of",
							"link_text": "Selecteer bestanden"
						},
						"description": "{acceptedFileFormats} - Maximaal {maxFileSizeMB} MB/bestand"
					},
					"description": {
						"APPROVAL": "Upload <strong>goedkeuring</strong>",
						"CONTRACT": "Upload <strong>contract</strong>",
						"CORRECTION_NOTE": "Upload <strong>correctienota</strong>",
						"COUNTERSIGNED_CONTRACT": "Upload <strong>mede-ondertekend contract</strong>",
						"ID_DOCUMENT": "Upload <strong>ID</strong> of <strong>paspoort</strong>",
						"LICENSE": "Upload <strong>rijbewijs</strong>",
						"PROOF_OF_ADDRESS": "Upload <strong>bewijs van adres</strong>",
						"SPECIAL_AGREEMENT": "Upload <strong>speciale overeenkomst</strong>",
						"SUPPORTING_DOCUMENT": "Upload <strong>ondersteunend document</strong>",
						"TAX_OFFICE_REGISTRATION": "Upload <strong>registratie bij het belastingkantoor</strong>"
					},
					"explanation": {
						"APPROVAL": {
							"title": {
								"default": "Goedkeuring"
							},
							"subtitle": {
								"default": null
							}
						},
						"CONTRACT": {
							"title": {
								"default": "Contract"
							},
							"subtitle": {
								"default": null
							}
						},
						"CORRECTION_NOTE": {
							"title": {
								"default": "Correctienota"
							},
							"subtitle": {
								"default": null
							}
						},
						"COUNTERSIGNED_CONTRACT": {
							"title": {
								"default": "Mede-ondertekend contract"
							},
							"subtitle": {
								"default": null
							}
						},
						"ID_DOCUMENT": {
							"title": {
								"default": "Identiteitsbewijs",
								"IT": "Identiteitskaart"
							},
							"subtitle": {
								"default": "Gelieve beide zijden van de identiteitskaart te versturen.",
								"AT": "Gelieve ons beide zijden van uw identiteitskaart te sturen. Als uw adres niet op uw identiteitsbewijs staat, hebben we aanvullende documentatie nodig om uw adres te verifiëren, bijvoorbeeld een energierekening.",
								"AU": "Voor een snellere beoordeling van uw aanvraag verzoeken wij u een geldige kopie van een identiteitsbewijs met foto, zoals een paspoort of rijbewijs, te overleggen voor de volgende personen die bij het bedrijf betrokken zijn: Eenmanszaak/vennootschap: de eigenaar(s). Bedrijf: de wettelijke vertegenwoordiger, alle directeuren en elke aandeelhouder die meer dan 25% van de aandelen bezit.",
								"BE": "Indien u een kopie van uw ID of rijbewijs stuurt, dan ontvangen wij graag een kopie van zowel de voor- als de achterkant van het legitimatiebewijs. Zorg daarnaast dat de kwaliteit van de kopie voldoende is en dat alle gegevens duidelijk leesbaar zijn.",
								"DE": "Gelieve ons beide zijden van uw identiteitskaart te sturen. Als uw adres niet op uw identiteitsbewijs staat, hebben we aanvullende documentatie nodig om uw adres te verifiëren, bijvoorbeeld een energierekening.",
								"FR": "Indien u een kopie van uw ID of rijbewijs stuurt, dan ontvangen wij graag een kopie van zowel de voor- als de achterkant van het legitimatiebewijs. Zorg daarnaast dat de kwaliteit van de kopie voldoende is en dat alle gegevens duidelijk leesbaar zijn.",
								"GB": "Stuur , als het een identiteitskaart is, de beide zijden van uw identiteitsbewijs.",
								"IT": "Een geldige identiteitskaart (voor- en achterkant) voor elk van de in de aanvraag vermelde personen. Rijbewijs, paspoort, burgerservicenummer worden niet geaccepteerd.",
								"NL": "Indien u een kopie van uw ID of rijbewijs stuurt, dan ontvangen wij graag een kopie van zowel de voor- als de achterkant van het legitimatiebewijs. Zorg daarnaast dat de kwaliteit van de kopie voldoende is en dat alle gegevens duidelijk leesbaar zijn.",
								"US": "Rijbewijs of paspoort; gelieve beide zijden van de identiteitskaart te sturen."
							}
						},
						"LICENSE": {
							"title": {
								"default": "Rijbewijs"
							},
							"subtitle": {
								"default": null
							}
						},
						"PROOF_OF_ADDRESS": {
							"title": {
								"default": "Bewijs van woonadres",
								"BE": "Bewijs van domicilie",
								"CZ": "Bewijs van woonadres",
								"ES": "Bewijs van woonadres",
								"FI": "Bewijs van woonadres",
								"FR": "Bewijs van woonadres",
								"GR": "Bewijs van woonadres",
								"IT": "Bewijs van woonadres",
								"NL": "Bewijs van woonadres",
								"PL": "Bewijs van woonadres",
								"PT": "Bewijs van woonadres"
							},
							"subtitle": {
								"default": "We accepteren de volgende documenten die niet ouder dan 3 maanden mogen zijn als bewijs van domicilie: Kopie van water/energie/gas rekening, vaste telefoon / internetrekening, huurovereenkomst of een door de overheid uitgegeven document. Mocht deze documentatie niet voorhanden zijn, upload dan alstublieft een ander document dat het woonadres bewijst gepaard met een notitie waar de rede op zichtbaar is.",
								"AU": "Overleg voor een snellere beoordeling van uw aanvraag een van de volgende documenten uit de afgelopen 90 dagen om het woonadres te verifiëren: Energierekening, internetrekening, belastingaangifte of lease-/huurovereenkomst. *Als u een paspoort verstrekt als identiteitsbewijs, of als uw huidige adres niet overeenkomt met het adres op uw verstrekte identiteitsbewijs, is deze stap verplicht.",
								"BE": "We accepteren de volgende documenten die niet ouder dan 3 maanden mogen zijn als bewijs van domicilie: Kopie van water/energie/gas rekening, vaste telefoon / internetrekening, huurovereenkomst of een door de overheid uitgegeven document. Mocht deze documentatie niet voorhanden zijn, upload dan alstublieft een ander document dat de domicilie bewijst gepaard met een notitie waar de rede op zichtbaar is.",
								"FR": "We accepteren de volgende documenten die niet ouder dan 3 maanden mogen zijn als bewijs van domicilie: Kopie van water/energie/gas rekening, vaste telefoon / internetrekening, huurovereenkomst of een door de overheid uitgegeven document. Mocht deze documentatie niet voorhanden zijn, upload dan alstublieft een ander document dat het woonadres bewijst gepaard met een notitie waar de rede op zichtbaar is.",
								"NL": "We accepteren de volgende documenten die niet ouder dan 3 maanden mogen zijn als bewijs van domicilie: Kopie van water/energie/gas rekening, vaste telefoon / internetrekening, huurovereenkomst of een door de overheid uitgegeven document. Mocht deze documentatie niet voorhanden zijn, upload dan alstublieft een ander document dat het woonadres bewijst gepaard met een notitie waar de rede op zichtbaar is.",
								"US": "Wij accepteren energierekeningen (gas, water, internet, telefoon enz.), lease of hypotheek met bewijs van adres; mag niet ouder zijn dan 90 dagen vanaf de datum van aanvraag.",
								"IT": "Als uw identiteitskaart een ander adres heeft dan uw huidige woonadres, hebben we een aanvullend document nodig om uw huidige verblijfplaats te verifiëren. Wij accepteren de volgende documenten uit de afgelopen 3 maanden als bewijs van het verblijfsadres van de in de aanvraag vermelde personen:"
							},
							"list": {
								"IT": [
									{
										"text": "Online (via SPID) of door uw woongemeente afgegeven bewijs van woonplaats"
									},
									{
										"text": "Elektriciteits- / water- / gas- / wifi-rekeningen"
									},
									{
										"text": "huurovereenkomst"
									}
								]
							}
						},
						"SPECIAL_AGREEMENT": {
							"title": {
								"default": "Speciale overeenkomst"
							},
							"subtitle": {
								"default": null
							}
						},
						"SUPPORTING_DOCUMENT": {
							"title": {
								"default": "Ondersteunend document",
								"GB": "Zelfportret"
							},
							"subtitle": {
								"default": null,
								"AU": "Als u waardevolle merkartikelen verkoopt, verstrek hier dan 2-3 leveranciersfacturen voor die producten. Zorg ervoor dat de factuur de gekochte producten bevat, de naam van de leverancier, de naam van de ontvanger en het afleveradres.",
								"GB": "Stuur een zelfportret waarbij u het identiteitsbewijs omhoog houdt."
							}
						},
						"TAX_OFFICE_REGISTRATION": {
							"title": {
								"default": "Document van inschrijving bij het belastingkantoor",
								"AT": "Document over registratie bij de belastingdienst",
								"AU": "Trustakte",
								"BE": "BTW-nummer geldig voor grensoverschrijdende transacties (VIES).",
								"DE": "Document over registratie bij de belastingdienst",
								"FR": "BTW-nummer geldig voor grensoverschrijdende transacties (VIES).",
								"IT": "BTW-nummer geldig voor grensoverschrijdende transacties (VIES).",
								"NL": "BTW-nummer geldig voor grensoverschrijdende transacties (VIES).",
								"NO": "Registratie bij het belastingkantoor",
								"US": "EIN-brief"
							},
							"subtitle": {
								"default": null,
								"AT": "Wij accepteren de volgende documenten als zakelijke documenten: Uittreksel handelsregister / vergunning eenmanszaak",
								"AU": "Als uw ABN is gekoppeld aan een trust, dient u een kopie van het trustdocument, inclusief het trustschema, mee te sturen. Houd er rekening mee dat deze stap verplicht is voor trusts.",
								"BE": "Controleer of uw btw-nummer is <link>ingeschakeld voor internationale transacties</link>. Dit is zelfs nodig als u alleen in uw eigen land handelt, aangezien Klarna een buitenlandse entiteit is. U kunt contact opnemen met uw plaatselijke belastingkantoor om een gratis VIES-activering van uw btw-nummer aan te vragen.",
								"CZ": "Wij accepteren de volgende documenten als zakelijke documenten: Bewijs van inschrijving in het openbaar register of uittreksel uit het handelsregister voor een eenmanszaak.",
								"DE": "Wij accepteren de volgende documenten als zakelijke documenten: Uittreksel handelsregister / vergunning eenmanszaak",
								"ES": "We accepteren de volgende documenten als zakelijke documenten: Oprichtingsakten voor geregistreerde bedrijven; voor eenmanszaken - Certificaat gemeenteinschrijving / Model 036 / Model 037",
								"FI": "Wij accepteren de volgende documenten als zakelijke documenten: Statuten voor eenmanszaken - Verklaring van volkstelling / Model 036 / Model 037",
								"FR": "Controleer of uw btw-nummer is <link>ingeschakeld voor internationale transacties</link>. Dit is zelfs nodig als u alleen in uw eigen land handelt, aangezien Klarna een buitenlandse entiteit is. U kunt contact opnemen met uw plaatselijke belastingkantoor om een gratis VIES-activering van uw btw-nummer aan te vragen.",
								"GR": "Wij accepteren de volgende documenten als zakelijke documenten: Registratie belastingkantoor / Bedrijfsstart / Handelsregisterdocument uitgegeven door de bevoegde dienst GEMI (Central Union of Chambers)",
								"IT": "U kunt contact opnemen met de Belastingdienst om een gratis VIES-activering van uw btw-nummer aan te vragen. Dit is zelfs nodig als u alleen in Italië handelt, aangezien Klarna een buitenlandse entiteit is.",
								"NL": "Controleer of uw btw-nummer is <link>ingeschakeld voor internationale transacties</link>. Dit is zelfs nodig als u alleen in uw eigen land handelt, aangezien Klarna een buitenlandse entiteit is. U kunt contact opnemen met uw plaatselijke belastingkantoor om een gratis VIES-activering van uw btw-nummer aan te vragen.",
								"NO": "Wij accepteren de volgende documenten als zakelijke documenten: Bedrijfsdocumenten",
								"PL": "Wij accepteren de volgende documenten als zakelijke documenten: Bewijs van inschrijving in het CEIDG-ondernemingsregister, uittreksel uit het National Court Register (KRS)",
								"PT": "We accepteren de volgende documenten als zakelijke documenten:  Certidão Permanente (verplicht), Oprichtingsakte. Voor eenmanszaken, registratie als zelfstandige (Declaração de Início de Atividade).",
								"US": "Dit is de brief van de Belastingdienst die u een EIN toewijst (IRS CP575 EIN-brief). Als uw bedrijf een eenmanszaak is en u een aanvraag indient met uw burgerservicenummer, dient u in plaats daarvan een kopie van uw identiteitskaart te verstrekken"
							},
							"link": {
								"BE": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"FR": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"NL": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"GR": "https://www.businessregistry.gr/publicity/index"
							}
						},
						"CERTIFIED_ID": {
							"title": {
								"default": "Gecertificeerd identificatiedocument"
							},
							"subtitle": {
								"default": "Wij accepteren de volgende documenten: ID-kaart, paspoort, rijbewijs. De documenten moeten aan de volgende criteria voldoen:"
							},
							"list": [
								{
									"text": "Gewaarmerkt door een bevoegde certificerende functionaris (bijvoorbeeld een notaris, eedscommissaris, advocaat, jurist en/of registeraccountant)."
								},
								{
									"text": "Ondertekend en afgestempeld. Op het stempel moeten zichtbare en verifieerbare gegevens van de certificerende instantie worden weergegeven, zoals de volledige naam, het adres en, indien van toepassing, het registratienummer."
								},
								{
									"text": "Gedagtekend: certificeringsdatum niet ouder dan 6 maanden."
								},
								{
									"text": "Geattesteerd als een waarheidsgetrouwe kopie van een origineel door duidelijk te vermelden dat het originele document is gezien."
								}
							]
						}
					},
					"modal": {
						"title": "Waarom hebben we uw documenten nodig?",
						"close": "Afsluiten",
						"content": [
							{
								"title": "Beschrijving van de procedure",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Bestandsvereisten",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Hoe scant u documenten?",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							}
						]
					},
					"errors": {
						"general": "Upload mislukt",
						"too_large_file": "Het bestand is te groot <strong>(max {maxFileSizeMB} MB)</strong>",
						"max_num_files_exceeded": "U mag maar {number} bestanden uploaden.",
						"invalid_file_format": "Ongeldig bestandsformaat. De enige geaccepteerde bestandsformaten zijn {acceptedFileFormats}",
						"duplicate_file_name": "Dubbele bestandsnaam. Alle geüploade bestanden moeten unieke namen hebben.",
						"try_again": "Probeer het opnieuw of <u>kies een ander bestand</u>"
					},
					"buttons": {
						"modal": "Waarom hebben we uw documenten nodig?",
						"next": "Volgende",
						"back": "Terug",
						"submit": "Documenten indienen"
					}
				},
				"document_upload_success": {
					"title": "Upload voltooid.",
					"message": "Bedankt! Uw documenten zijn geüpload."
				},
				"forced_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Kunt u uw registratienummer invoeren?",
							"AT": "Kunt u uw registratienummer invoeren?",
							"CA": "Kunt u uw ondernemingsnummer invoeren?",
							"GR": "Kunt u uw G.E.MI.-nummer (Γ.Ε.ΜΗ.) invoeren?",
							"NZ": "Kunt u uw ondernemingsnummer invoeren?"
						},
						"managed": {
							"default": "Kunt u het registratienummer van het bedrijf invoeren?",
							"AT": "Kunt u het registratienummer van het bedrijf invoeren?",
							"CA": "Kunt u uw ondernemingsnummer invoeren?",
							"GR": "Kunt u het G.E.MI.-nummer (Γ.Ε.ΜΗ.) van het bedrijf invoeren?",
							"NZ": "Kun je het ondernemingsnummer van het bedrijf invoeren?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "We hebben uw bedrijfsregistratienummer nodig om uw bedrijfsgegevens te bevestigen.",
							"AT": "We hebben uw bedrijfsregistratienummer nodig om uw bedrijfsgegevens te bevestigen.",
							"CA": "Wij hebben uw federale ondernemingsnummer nodig dat door de CRA (Canada Revenue Agency) aan uw bedrijf is toegekend om uw bedrijfsgegevens te verifiëren.",
							"GR": "We hebben uw G.E.MI.-nummer nodig om de bedrijfsgegevens te bevestigen.",
							"NZ": "We hebben uw ondernemingsnummer nodig om uw bedrijfsgegevens te verifiëren."
						},
						"managed": {
							"default": "We hebben het bedrijfsregistratienummer nodig om de bedrijfsgegevens te bevestigen.",
							"AT": "We hebben het bedrijfsregistratienummer nodig om de bedrijfsgegevens te bevestigen.",
							"CA": "Wij hebben uw federale ondernemingsnummer nodig dat door de CRA (Canada Revenue Agency) aan uw bedrijf is toegekend om uw bedrijfsgegevens te verifiëren.",
							"GR": "We hebben het G.E.MI.-nummer nodig om de bedrijfsgegevens te bevestigen.",
							"NZ": "We hebben het ondernemingsnummer nodig om de bedrijfsgegevens te bevestigen."
						}
					},
					"infobox": {
						"unmanaged": {
							"CA": "Houd er rekening mee dat Klarna momenteel geen betalingsdiensten kan aanbieden voor Canadese eenmanszaken. Als u doorgaat met uw aanvraag, wordt deze afgewezen."
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Registratienummer",
								"AT": "Registratienummer",
								"CA": "Ondernemingsnummer",
								"GR": "G.E.MI.-nummer (Γ.Ε.ΜΗ.)",
								"NZ": "Ondernemingsnummer"
							}
						}
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"tax_identification_number": {
					"title": {
						"unmanaged": "Wat is je belastingclassificatie?",
						"managed": "Kunt u de belastingclassificatie van de onderneming invoeren?"
					},
					"subtitle": {
						"unmanaged": "Wij zullen u om verschillende inlichtingen vragen, afhankelijk van de rechtsvorm van het bedrijf.",
						"managed": "Wij zullen u om verschillende inlichtingen vragen, afhankelijk van de rechtsvorm van het bedrijf."
					},
					"info": {
						"unmanaged": "U vindt uw WIN (Werkgeversidentificatienummer) op belastingaangiften, kredietrapporten, loonstrookjes, of licenties en vergunningen",
						"managed": "U vindt uw WIN van het bedrijf (Werkgeversidentificatienummer) op belastingaangiften, kredietrapporten, loonstrookjes, of licenties en vergunningen"
					},
					"fields": {
						"registration_number": {
							"label": "Werkgeversidentificatienummer",
							"errors": {
								"general": "Voer een geldig Werkgeversidentificatienummer in",
								"invalid": "Het Werkgeversidentificatienummer moet 9 cijfers lang zijn met een \"-\" na de eerste twee. Bijvoorbeeld: 12-3456789"
							}
						},
						"organization_entity": {
							"label": {
								"unmanaged": "Federale belastingclassificatie",
								"managed": "Soort bedrijf"
							},
							"errors": {
								"is_one_of": "Kies een van de beursgenoteerde bedrijfstypen"
							}
						}
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"forced_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Kunt u uw btw-nummer invoeren?",
							"AU": "Kunt u uw ABN invoeren?",
							"ES": "Wat is uw fiscaal nummer?",
							"NZ": "Kunt u uw GST-nummer invoeren?"
						},
						"managed": {
							"default": "Kunt u het btw-nummer invoeren?",
							"AU": "Kunt u het ABN invoeren?",
							"ES": "Wat is uw fiscaal nummer?",
							"NZ": "Kunt u het GST-nummer invoeren?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "We kunnen uw bedrijfsgegevens gemakkelijker controleren via uw btw-nummer.",
							"AU": "We kunnen uw bedrijfsgegevens gemakkelijker controleren via uw ABN.",
							"NZ": "We kunnen uw bedrijfsgegevens gemakkelijker controleren via uw GST-nummer.",
							"ES": "We kunnen uw bedrijfsgegevens gemakkelijker controleren via uw NIF, NIE of DNI-nummer."
						},
						"managed": {
							"default": "We gebruiken het btw-nummer om de bedrijfsgegevens te bevestigen.",
							"AU": "We gebruiken het ABN om de bedrijfsgegevens te bevestigen.",
							"NZ": "We gebruiken het GST-nummer om de bedrijfsgegevens te bevestigen.",
							"ES": "We gebruiken het NIF, NIE of DNI-nummer om de bedrijfsgegevens te bevestigen."
						}
					},
					"fields": {
						"vat_number": {
							"label": {
								"default": "Btw-nummer",
								"AU": "ABN",
								"NZ": "GST-nummer",
								"ES": "NIF/NIE/DNI"
							}
						}
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"legal_entity_type": {
					"title": {
						"unmanaged": "Welke soort bedrijf hebt u?",
						"managed": "Wat voor soort bedrijf is dit bedrijf?"
					},
					"subtitle": {
						"unmanaged": "We zijn verplicht bepaalde specifieke vragen te stellen op basis van uw bedrijfstype.",
						"managed": "We zijn verplicht bepaalde specifieke vragen te stellen op basis van het bedrijfstype."
					},
					"fields": {
						"legal_entity_type": {
							"label": "Type rechtspersoon",
							"errors": {
								"is_one_of": "Kies een van de beursgenoteerde bedrijfstypen"
							}
						}
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"optional_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Is uw bedrijf een geregistreerd bedrijf?",
							"AU": "Heeft uw bedrijf een ACN?",
							"ES": "Staat uw bedrijf in het Registro Mercantil?"
						},
						"managed": {
							"default": "Is het bedrijf een geregistreerd bedrijf?",
							"AU": "Heeft dit bedrijf een ACN?",
							"ES": "Staat uw bedrijf in het Registro Mercantil?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "We hebben uw bedrijfsregistratienummer nodig om uw bedrijfsgegevens te bevestigen.",
							"AT": "We hebben uw bedrijfsregistratienummer nodig om uw bedrijfsgegevens te bevestigen.",
							"AU": "Als u een ACN hebt, voer deze dan in, anders selecteert u \"nee\" en gaat u verder.",
							"ES": "Antwoord Ja als u een SL, SA, SCP, ...enz. bent. Antwoord Nee als u een autónomo, freelancer, ...enz. bent",
							"GB": "We hebben uw bedrijfsorganisatienummer nodig om uw bedrijfsgegevens te bevestigen.",
							"GR": "We hebben uw G.E.MI.-nummer nodig om de bedrijfsgegevens te bevestigen."
						},
						"managed": {
							"default": "We hebben het bedrijfsregistratienummer nodig om de bedrijfsgegevens te bevestigen.",
							"AT": "We hebben het bedrijfsregistratienummer nodig om de bedrijfsgegevens te bevestigen.",
							"AU": "Als dit bedrijf een ACN heeft, voer deze dan in, anders selecteert u \"nee\" en gaat u verder.",
							"ES": "Antwoord Ja als u een SL, SA, SCP, ...enz. bent. Antwoord Nee als u een autónomo, freelancer, ...enz. bent",
							"GB": "We hebben het bedrijfsorganisatienummer nodig om de bedrijfsgegevens te bevestigen.",
							"GR": "We hebben het G.E.MI.-nummer van het bedrijf nodig om de bedrijfsgegevens te bevestigen."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Voer uw registratienummer in",
							"AT": "Voer uw registratienummer in",
							"AU": "Voer uw ACN in",
							"ES": "Voer de NIF/NIE/DNI van uw bedrijf in",
							"GB": "Voer uw organisatienummer in",
							"GR": "Voer uw G.E.MI.-nummer (Γ.Ε.ΜΗ.) in"
						},
						"managed": {
							"default": "Voer het registratienummer in",
							"AT": "Voer het registratienummer in",
							"AU": "Voer de ACN in",
							"ES": "Voer de NIF/NIE/DNI van uw bedrijf in",
							"GB": "Voer het organisatienummer in",
							"GR": "Voer het G.E.MI.-nummer (Γ.Ε.ΜΗ.) in"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Registratienummer",
								"AT": "Registratienummer",
								"AU": "Australisch Bedrijfsnummer (ACN)",
								"ES": "NIF/NIE/DNI van bedrijf",
								"GB": "Organisatienummer",
								"GR": "G.E.MI.-nummer (Γ.Ε.ΜΗ.)"
							},
							"errors": null
						}
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"mid-selector": {
					"title": "Selecteer een winkel",
					"subtitle": "Dit e-mailadres is gekoppeld aan meerdere winkels. Selecteer een winkel om verder te gaan.",
					"mid-selector": "Webwinkel-ID / Naam winkel",
					"buttons": {
						"next": "Verder"
					}
				},
				"optional_registration_information_widget": {
					"title": {
						"unmanaged": "Is uw bedrijf een geregistreerd bedrijf?",
						"managed": "Is het bedrijf een geregistreerd bedrijf?"
					},
					"subtitle": {
						"unmanaged": {
							"default": "We hebben uw bedrijfsregistratienummer nodig om uw bedrijfsgegevens te bevestigen.",
							"AT": "We hebben uw bedrijfsregistratienummer nodig om uw bedrijfsgegevens te bevestigen."
						},
						"managed": {
							"default": "We hebben het bedrijfsregistratienummer nodig om de bedrijfsgegevens te bevestigen.",
							"AT": "We hebben het bedrijfsregistratienummer nodig om de bedrijfsgegevens te bevestigen."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Voer uw registratienummer in",
							"AT": "Voer uw registratienummer in"
						},
						"managed": {
							"default": "Voer het registratienummer in",
							"AT": "Voer het registratienummer in"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Registratienummer",
								"AT": "Registratienummer"
							}
						}
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"optional_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Is uw bedrijf geregistreerd voor btw?",
							"ES": "Heeft uw bedrijf een NIF/NIE/DNI?",
							"NZ": "Is uw bedrijf geregistreerd voor GST?"
						},
						"managed": {
							"default": "Is dit bedrijf geregistreerd voor btw?",
							"ES": "Heeft uw bedrijf een NIF/NIE/DNI?",
							"NZ": "Is dit bedrijf geregistreerd voor GST?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "We kunnen uw bedrijfsgegevens gemakkelijker controleren als u een btw-nummer heeft.",
							"ES": "We kunnen uw bedrijfsgegevens gemakkelijker controleren als u een NIF/NIE/DNI-nummer heeft.",
							"NZ": "We kunnen uw bedrijfsgegevens gemakkelijker controleren als u een GST-nummer heeft."
						},
						"managed": {
							"default": "We gebruiken het btw-nummer om de bedrijfsgegevens te bevestigen.",
							"ES": "We kunnen uw bedrijfsgegevens gemakkelijker controleren als u een NIF/NIE/DNI-nummer heeft.",
							"NZ": "We gebruiken het GST-nummer om de bedrijfsgegevens te bevestigen."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Voer uw btw-nummer in",
							"ES": "Voer de NIF/NIE/DNI van uw bedrijf in",
							"NZ": "Voer uw GST-nummer in"
						},
						"managed": {
							"default": "Voer het btw-nummer in",
							"ES": "Voer de NIF/NIE/DNI van uw bedrijf in",
							"NZ": "Voer uw GST-nummer in"
						}
					},
					"vat_id": {
						"label": {
							"default": "Btw-nummer",
							"ES": "NIF/NIE/DNI van bedrijf",
							"NZ": "GST-nummer"
						}
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"optional_vat_registration_widget": {
					"title": {
						"unmanaged": "Is uw bedrijf geregistreerd voor btw?",
						"managed": "Is dit bedrijf geregistreerd voor btw?"
					},
					"subtitle": {
						"unmanaged": "We kunnen uw bedrijfsgegevens gemakkelijker controleren als u een btw-nummer heeft.",
						"managed": "We gebruiken het btw-nummer om de bedrijfsgegevens te bevestigen."
					},
					"form_title": {
						"unmanaged": "Voer uw btw-nummer in",
						"managed": "Voer het btw-nummer in"
					},
					"vat_id": {
						"label": {
							"default": "Btw-nummer",
							"NZ": "GST-nummer"
						}
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"partnership_details": {
					"title": {
						"unmanaged": "Wat is uw bedrijfsadres?",
						"managed": "Wat is het zakelijke adres van het bedrijf?"
					},
					"subtitle": {
						"unmanaged": "We moeten weten waar uw bedrijf zich bevindt.",
						"managed": "We moeten weten waar het bedrijf zich bevindt."
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					},
					"fields": {
						"partnership_name": {
							"label": "Naam partnerschap",
							"errors": {
								"general": "Voer een partnerschapsnaam in"
							}
						},
						"street": {
							"label": "Adres",
							"errors": {
								"general": "Voer een geldig adres in"
							}
						},
						"postal_code": {
							"label": "Postcode",
							"errors": {
								"general": "Voer een geldige postcode in"
							}
						},
						"city": {
							"label": "Woonplaats",
							"errors": {
								"general": "Voer een geldige stad in"
							}
						},
						"country": {
							"label": "Land",
							"errors": {
								"general": "Voer een geldig land in"
							}
						}
					}
				},
				"partners_and_principals": {
					"title": {
						"default": "Wie is de eigenaar van het bedrijf?",
						"GB": "Wie beheert het bedrijf?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Wij zijn wettelijk verplicht door de anti-witwasrichtlijn van de EU ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") wettelijk verplicht om deze informatie te verzamelen."
							}
						],
						"AU": [
							{
								"text": "Als financiële instelling zijn wij wettelijk verplicht deze informatie te verzamelen."
							}
						]
					},
					"infobox": "Vul de persoonlijke gegevens en het woonadres in van alle partners en opdrachtgevers die zeggenschap hebben over het bestuur van uw bedrijf.",
					"buttons": {
						"add_person": "+ Persoon toevoegen",
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"payouts_summary": {
					"title": "Bankrekeningen",
					"default_bank_accounts": {
						"no_elements": "Geen standaard bankrekening beschikbaar"
					},
					"additional_bank_accounts": {
						"no_elements": "U hebt geen extra bankrekeningen ingediend"
					}
				},
				"pre_assessment_company_details": {
					"title": "Voer meer gegevens over mogelijkheden in.",
					"subtitle": "Geef het aandeel kaartvolume en de bedrijfsgegevens voor deze handelaar door. Geef ook aan of het bedrijf opereert vanuit een andere markt dan het land van registratie, aangezien dit is vereist voor risico-inschatting.",
					"fields": {
						"volume_by_card": {
							"label": "Aandeel kaartvolume van totaal volume (%)",
							"errors": {
								"invalid": "Kaartvolume moet een cijfer zijn tussen 0 en 100",
								"invalid_hint": "Voeg het aandeel van het volume van de kaarttransacties uit het totale Klarna-volume voor deze gelegenheid toe. Voer 0% in als uw gelegenheid geen kaartbetalingen heeft."
							}
						},
						"average_order_value": {
							"label": "Gemiddelde bestelwaarde (in SEK)",
							"tooltip": "Moet een positief bedrag in SEK zijn",
							"errors": {
								"invalid": "Moet een positief bedrag in SEK zijn"
							}
						},
						"registration_country": {
							"label": "Land van registratie",
							"errors": {
								"required": "Land van registratie is verplicht"
							}
						},
						"operating_country": {
							"label": "Land van uitvoering",
							"errors": {
								"required": "Land van uitvoering is vereist"
							}
						},
						"registration_number": {
							"label": {
								"default": "Registratienummer (verplicht voor geregistreerde bedrijven)",
								"AU": "ACN (verplicht voor geregistreerde bedrijven)",
								"ES": "NIF/NIE/DNI van bedrijf (verplicht voor geregistreerde bedrijven)",
								"GR": "G.E.MI-nummer (Γ.Ε.ΜΗ.) (verplicht voor geregistreerde bedrijven)",
								"NZ": "Ondernemingsnummer (verplicht voor geregistreerde bedrijven)",
								"US": "TIN/EIN (verplicht voor geregistreerde bedrijven)"
							}
						},
						"vat_number": {
							"label": "ABN",
							"errors": {
								"required": "Voer ACN of ABN in",
								"invalid": "ABN moet uit 11 cijfers bestaan"
							}
						},
						"registration_authority": {
							"label": "Autoriteit van registratie",
							"errors": {
								"required": "Selecteer uw autoriteit van registratie"
							}
						},
						"company_name": {
							"label": "",
							"errors": {
								"required": ""
							}
						},
						"sales_contact": {
							"label": "E-mail verkoper",
							"errors": {
								"invalid": "Voer een geldig e-mailadres in"
							}
						},
						"store_url": {
							"label": "URL winkel",
							"errors": {
								"required": "URL winkel is vereist",
								"invalid": "Voer een geldige website-URL in"
							}
						},
						"goods_category": {
							"label": "Hoofdcategorie verkochte goederen",
							"errors": {
								"invalid": "U moet een van de opties selecteren"
							}
						},
						"is_managed": {
							"label": "Gaat de beheerdersfunctie live?"
						}
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"pre_assessment_products": {
					"title": "Vermeld alle producten",
					"subtitle": "Voor de risico-inschatting zijn alle producten per land waar u verkoopt vereist",
					"select": {
						"label": "Product zoeken"
					},
					"selected": {
						"label": "Geselecteerde producten:"
					},
					"clear": "Alles wissen",
					"errors": {
						"invalid": "Er moet ten minste één product per land worden geselecteerd"
					},
					"channels": {
						"ONLINE": "Online",
						"IN_STORE": "In de winkel",
						"TELESALES": "Televerkoop",
						"SELLER_APP": "Verkoper-app"
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"wrong_prefill_data": {
					"title": "Ongeldige gegevens ingevoerd",
					"subtitle": "Ongeldige of ongeschikte vooraf ingevulde informatie geleverd door SalesForce.",
					"details": "Details: ",
					"fields": {
						"goodsCategory": "Goederencategorie",
						"paymentInterval": "Betalingsinterval",
						"paymentDelay": "Betalingsvertraging",
						"registrationCountry": "Land van registratie",
						"storeUrl": "URL winkel",
						"mainSellingCountry": "Belangrijkste verkoopland",
						"products": "Producten",
						"products_item": "Product {index}",
						"products_item_yearlyAcquiredVolume": "Jaarlijks verkregen volume product {index}",
						"products_item_sellingCountry": "Verkoopland product {index}",
						"products_item_productName": "Naam product {index}",
						"products_item_channels": "Kanalen product {index}",
						"products_item_channels_item": "Kanaal product {index}"
					},
					"error_types": {
						"fallback": "is ongeldig",
						"any": {
							"required": "is verplicht en er is er geen ingevoerd"
						}
					}
				},
				"selling_countries": {
					"title": "Vermeld alle verkooplanden",
					"subtitle": "De volledige lijst met landen is vereist voor risico-inschatting",
					"select": {
						"label": "Land zoeken"
					},
					"selected": {
						"label": "Geselecteerde landen:"
					},
					"fields": {
						"selling_countries": {
							"label": "Land selecteren",
							"errors": {
								"invalid": "U moet ten minste één land selecteren"
							}
						}
					},
					"clear": "Alles wissen",
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"main_selling_country": {
					"title": "Wat is de belangrijkste Klarna-markt voor de verkoper?",
					"subtitle": "Selecteer de markt met het hoogste verwachte Klarna-volume",
					"errors": {
						"invalid": "U moet een land selecteren"
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"fca_number": {
					"title": "Voer het FCA-nummer in",
					"subtitle": "We zijn wettelijk verplicht om de vergunning van de kredietmakelaar te verifiëren.",
					"fields": {
						"fca_number": {
							"label": "FCA-nummer",
							"errors": {
								"general": "Voer een geldig FCA-nummer in"
							}
						}
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"sole_trader": {
					"title": "Wie is de eigenaar van het bedrijf?",
					"subtitle": {
						"default": [
							{
								"text": "Wij zijn wettelijk verplicht door de anti-witwasrichtlijn van de EU ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") wettelijk verplicht om deze informatie te verzamelen."
							}
						]
					},
					"infobox": {
						"unmanaged": "Vul je persoonlijke gegevens en woonadres.",
						"managed": "Vul de persoonlijke gegevens en het woonadres van de eigenaar in."
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					},
					"fields": {
						"are_you_the_sole_trader": {
							"label": "De persoon die de aanvraag doet, is dezelfde persoon als de zelfstandige handelaar",
							"error": "Sorry, maar u kunt alleen doorgaan als u deze aanvraag doet als zelfstandige handelaar."
						}
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Werkt u op een ander adres?",
								"managed": "Werkt dit bedrijf vanaf een ander adres?"
							},
							"subtitle": {
								"unmanaged": "Kies alleen Ja als uw bedrijf een ander adres dan uw woonadres heeft.",
								"managed": "Kies alleen Ja als dit bedrijf werkt vanaf een ander adres dan het woonadres van de enige handelaar."
							}
						},
						"title": "Voer het bedrijfsadres in",
						"fields": {
							"street": {
								"label": "Adres",
								"errors": {
									"general": "Voer een geldig adres in"
								}
							},
							"postal_code": {
								"label": "Postcode",
								"errors": {
									"general": "Voer een geldige postcode in"
								}
							},
							"city": {
								"label": "Woonplaats",
								"errors": {
									"general": "Voer een geldige stad in"
								}
							},
							"country": {
								"label": "Land",
								"errors": {
									"general": "Voer een geldig land in"
								}
							}
						}
					}
				},
				"sole_trader_confirmation": {
					"title": "Kunt u nog twee dingen bevestigen?",
					"subtitle": "",
					"fields": {
						"are_you_the_sole_trader": {
							"title": "U bent de zelfstandige handelaar",
							"label": "De persoon die de aanvraag doet, is dezelfde persoon als de zelfstandige handelaar"
						},
						"are_you_the_only_with_financial_control": {
							"title": "U heeft als enige financiële controle",
							"label": "De eigenaar is de enige persoon die financiële controle heeft over de bankrekening(en) van uw bedrijf"
						}
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					},
					"robot_message": "Sorry, maar we moeten deze twee dingen bevestigen"
				},
				"underwriting_info": {
					"title": "Specificeer het volume en de betalingsvertraging van de mogelijkheid",
					"subtitle": "Vermeld het totale verwachte jaarlijkse Klarna-volume voor deze mogelijkheid voor alle markten en de betalingsvertraging. Als de betalingsvertraging per land verschilt, gebruik dan degene voor het geselecteerde belangrijkste verkoopland.",
					"fields": {
						"yearly_acquired_volume": {
							"label": "Totaal marktvolume per jaar (in SEK)",
							"errors": {
								"invalid": "Totaal marktvolume per jaar moet een positief bedrag in SEK zijn",
								"too_long": "Totaal marktvolume per jaar mag niet meer dan 16 cijfers bevatten"
							}
						},
						"payment_delay": {
							"label": "Betalingsvertraging",
							"errors": {
								"general": "Voer een waarde voor betalingsvertraging in",
								"invalid": "Betalingsvertraging moet een getal tussen {min} en {max} zijn"
							}
						},
						"payment_interval": {
							"label": "Betalingsinterval",
							"errors": {
								"invalid": "U moet een van de opties selecteren"
							}
						},
						"volume_by_card": {
							"label": "Aandeel in checkout (%)",
							"errors": {
								"invalid": "Aandeel in checkout moet een cijfer zijn tussen 0 en 100",
								"invalid_hint": "Voeg het aandeel van het volume van de kaarttransacties uit het totale Klarna-volume voor deze gelegenheid toe. Voer 0% in als uw gelegenheid geen kaartbetalingen heeft."
							}
						},
						"average_order_value": {
							"label": "Gemiddelde bestelwaarde (in SEK)"
						}
					},
					"buttons": {
						"back": "Terug",
						"next": "Volgende"
					}
				},
				"store_details": {
					"title": {
						"unmanaged": {
							"default": "Wat zijn je winkelgegevens?"
						},
						"managed": "Wat zijn de winkelgegevens?"
					},
					"subtitle": {
						"unmanaged": {
							"US": "We gebruiken deze informatie om je bedrijfsrekening aan te maken.",
							"default": "We zullen de aangeleverde gegevens gebruiken als uw primaire contactgegevens en om een kijkje te nemen in uw winkel."
						},
						"managed": "We zullen de aangeleverde gegevens gebruiken als de primaire contactgegevens voor klanten en om een kijkje te nemen in de winkel."
					},
					"fields": {
						"store_name": {
							"label": {
								"CA": "Merknaam / DBA",
								"MX": "Merknaam / DBA",
								"US": "Merknaam / DBA",
								"default": "Naam webwinkel"
							},
							"errors": {
								"required": "Winkelnaam is verplicht",
								"required_us": "Merknaam / DBA is verplicht",
								"invalid": "Gelieve een winkelnaam van minimaal 2 tekens in te voeren",
								"invalid_us": "Gelieve een merknaam / DBA van minimaal 2 tekens in te voeren",
								"invalid_characters": "De naam van de winkel mag de volgende tekens niet bevatten: < >",
								"invalid_characters_us": "De merknaam/DBA mag de volgende tekens niet bevatten: < >"
							}
						},
						"website": {
							"label": "Website online winkel",
							"errors": {
								"required": "Website is verplicht",
								"invalid": "Voer een geldige website-URL in"
							}
						},
						"goods_category": {
							"label": "Hoofdcategorie verkochte goederen",
							"errors": {
								"required": "Goederencategorie is verplicht"
							}
						},
						"email": {
							"label": "E-mail klantenservice",
							"errors": {
								"required": "E-mail klantenservice is verplicht",
								"invalid": "Voer een geldig e-mailadres in"
							}
						}
					},
					"buttons": {
						"next": "Volgende",
						"back": "Producten wijzigen"
					}
				},
				"uk_company_details": {
					"title": {
						"unmanaged": "Wat is uw geregistreerde bedrijfsadres?",
						"managed": "Wat is het geregistreerde zakelijke adres van het bedrijf?"
					},
					"subtitle": {
						"unmanaged": "We moeten weten op welk adres uw bedrijf is geregistreerd.",
						"managed": "We moeten weten op welk adres het bedrijf is geregistreerd."
					},
					"question": {
						"title": {
							"unmanaged": "Werkt u op een ander adres?",
							"managed": "Werkt dit bedrijf vanaf een ander adres?"
						},
						"subtitle": {
							"unmanaged": "Kies alleen Ja als uw bedrijf een ander adres dan uw geregistreerde bedrijfsadres heeft.",
							"managed": "Kies alleen Ja als dit bedrijf een ander adres dan het geregistreerde bedrijfsadres heeft."
						}
					},
					"toggle": {
						"title": "Voeg het adres van de primaire vestiging toe"
					},
					"fields": {
						"company_name": {
							"label": "Wettelijke naam van het bedrijf",
							"errors": {
								"general": "Voer een bedrijfsnaam in"
							}
						},
						"street": {
							"label": "Adres",
							"errors": {
								"general": "Voer een adres in"
							}
						},
						"postal_code": {
							"label": "Postcode",
							"errors": {
								"general": "Voer een postcode in"
							}
						},
						"city": {
							"label": "Woonplaats",
							"errors": {
								"general": "Voer een stad in"
							}
						},
						"country": {
							"label": "Land",
							"errors": {
								"general": "Voer een land in"
							}
						}
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					},
					"messages": {
						"lookup": "Is dit uw bedrijf? Kijk goed en bevestig indien juist."
					}
				},
				"uk_sole_trader": {
					"title": "Wie is de eigenaar van dit bedrijf?",
					"subtitle": {
						"unmanaged": "U staat op het punt een contract met Klarna af te sluiten. Daarom moeten we uw persoonsgegevens verzamelen.",
						"managed": "We zijn verplicht om de persoonsgegevens van de eigenaar te verzamelen en te bevestigen."
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Werkt u op een ander adres?",
								"managed": "Werkt dit bedrijf vanaf een ander adres?"
							},
							"subtitle": {
								"unmanaged": "Kies alleen Ja als uw bedrijf een ander adres dan uw woonadres heeft.",
								"managed": "Kies alleen Ja als dit bedrijf werkt vanaf een ander adres dan het woonadres van de enige handelaar."
							}
						},
						"title": "Voer het bedrijfsadres in",
						"fields": {
							"street": {
								"label": "Adres",
								"errors": {
									"general": "Voer een geldig adres in"
								}
							},
							"postal_code": {
								"label": "Postcode",
								"errors": {
									"general": "Voer een geldige postcode in"
								}
							},
							"city": {
								"label": "Woonplaats",
								"errors": {
									"general": "Voer een geldige stad in"
								}
							},
							"country": {
								"label": "Land",
								"errors": {
									"general": "Voer een geldig land in"
								}
							}
						}
					}
				},
				"us_sole_proprietorship": {
					"title": "Wie is de eigenaar van het bedrijf?",
					"subtitle": {
						"default": "Als financiële instelling zijn wij wettelijk verplicht deze informatie te verzamelen."
					},
					"infobox": {
						"unmanaged": "Vul je persoonlijke gegevens en woonadres.",
						"managed": "Vul de persoonlijke gegevens en het woonadres van de eigenaar in."
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Werkt u op een ander adres?",
								"managed": "Werkt dit bedrijf vanaf een ander adres?"
							},
							"subtitle": {
								"unmanaged": "Kies alleen Ja als uw bedrijf een ander adres dan uw woonadres heeft.",
								"managed": "Kies alleen Ja als dit bedrijf werkt vanaf een ander adres dan het woonadres van de enige handelaar."
							}
						},
						"title": "Voer het bedrijfsadres in",
						"fields": {
							"street": {
								"label": "Adres",
								"errors": {
									"general": "Voer een geldig adres in"
								}
							},
							"postal_code": {
								"label": "Postcode",
								"errors": {
									"general": "Voer een geldige postcode in"
								}
							},
							"city": {
								"label": "Woonplaats",
								"errors": {
									"general": "Voer een geldige stad in"
								}
							},
							"country": {
								"label": "Land",
								"errors": {
									"general": "Voer een geldig land in"
								}
							},
							"region": {
								"label": "Staat/Provincie",
								"errors": {
									"general": "Voer een staat/provincie in"
								}
							}
						}
					}
				},
				"ultimate_beneficial_owner": {
					"title": {
						"default": "Zijn er mensen die meer dan 25% van het bedrijf bezitten?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Als financiële instelling zijn wij wettelijk verplicht deze informatie te verzamelen."
							}
						],
						"default": [
							{
								"text": "We willen weten welke mensen meer dan 25% van de aandelen of het stemrecht van het bedrijf bezitten of een soortgelijke controle hebben. Wij zijn volgens de EU-richtlijn inzake witwaspraktijken ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") wettelijk verplicht om deze informatie te verzamelen."
							}
						]
					},
					"infobox": {
						"default": "Vul de persoonlijke gegevens en het woonadres van elk individu in.",
						"AU": "Vul de persoonlijke gegevens en het woonadres van elke persoon in. Voor bedrijven met complexe eigendomsstructuren moeten dit natuurlijke personen zijn."
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug",
						"add_person": "+ Persoon toevoegen"
					},
					"messages": {
						"lookup": "Hebben deze mensen meer dan 25% van uw bedrijf in hun bezit? Kijk goed en bevestig indien juist."
					}
				},
				"us_company_details": {
					"title": {
						"unmanaged": "Wat is je bedrijfsadres?",
						"managed": "Wat is het geregistreerde zakelijke adres van het bedrijf?"
					},
					"subtitle": {
						"unmanaged": "Dit is waar je bedrijf wettelijk geregistreerd is, en dit adres verschijnt op de facturen van je Klarna-klanten.",
						"managed": "We moeten weten op welk adres het bedrijf is geregistreerd."
					},
					"question": {
						"title": {
							"unmanaged": "Werkt u op een ander adres?",
							"managed": "Werkt dit bedrijf vanaf een ander adres?"
						},
						"subtitle": {
							"unmanaged": "Kies alleen Ja als uw bedrijf een ander adres dan uw geregistreerde bedrijfsadres heeft.",
							"managed": "Kies alleen Ja als dit bedrijf een ander adres dan het geregistreerde bedrijfsadres heeft."
						}
					},
					"toggle": {
						"title": "Voeg het adres van de primaire vestiging toe"
					},
					"fields": {
						"company_name": {
							"label": "Geregistreerde bedrijfsnaam",
							"errors": {
								"general": "Voer een bedrijfsnaam in"
							}
						},
						"street": {
							"label": "Adres",
							"errors": {
								"general": "Voer een adres in"
							}
						},
						"postal_code": {
							"label": "Postcode",
							"errors": {
								"general": "Voer een postcode in"
							}
						},
						"city": {
							"label": "Woonplaats",
							"errors": {
								"general": "Voer een stad in"
							}
						},
						"country": {
							"label": "Land",
							"errors": {
								"general": "Voer een land in"
							}
						},
						"state_of_incorporation": {
							"label": "Staat/provincie van oprichting",
							"errors": {
								"general": "Voer een staat/provincie van oprichting in"
							}
						},
						"state": {
							"label": "Staat/Provincie",
							"errors": {
								"general": "Voer een staat/provincie in"
							}
						},
						"region": {
							"label": "Provincie",
							"errors": {
								"puerto_rico": "Puerto Rico niet toegestaan"
							}
						}
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"select_products": {
					"title": "Onze diensten",
					"title_kco_hidden": "Betaalmethoden die de verkoop verhogen.",
					"subtitle": "Kies de diensten waarin u geïnteresseerd bent.",
					"subtitle_kco_hidden": "Verhoog de shoppower van uw klant. Bied meer betaalmogelijkheden, zodat ze zelf kunnen bepalen wanneer en hoe ze betalen.",
					"platform_alert": null,
					"buttons": {
						"next": "Volgende"
					}
				},
				"signup_products": {
					"title_line_1": "Klarna-producten voor je winkel.",
					"title_kco_hidden_line_1": "Betaalmethoden die",
					"title_kco_hidden_line_2": "verkopen verhogen.",
					"subtitle": "Door Klarna-betaalmethoden aan te bieden, krijg je een gemiddelde stijging van 30% in conversie, 41% in AOV, en 36% in aankoopfrequentie.",
					"subtitle_kco_hidden": "Verhoog de shoppower van uw klant. Bied meer betaalmogelijkheden, zodat ze zelf kunnen bepalen wanneer en hoe ze betalen.",
					"info_block": "Beschikbare producten tonen voor",
					"special_offer": "Speciale aanbieding: {percentageFee}% + {fixedFee} per transactie. Geldig tot {validUntil}.",
					"buttons": {
						"contact_sales": "Neem contact op met Sales",
						"next": "Maak een account aan",
						"back": "Terug"
					}
				},
				"questionnaire": {
					"buttons": {
						"back": "Terug",
						"next": "Volgende"
					}
				},
				"business_concepts": {
					"title": "Selecteer de toepasselijke bedrijfsconcepten.",
					"subtitle": "Selecteer alleen degene die van toepassing zijn. Dit kunnen er meerdere zijn.",
					"errors": {
						"select_at_least_one": "Selecteer minstens één bedrijfsconcept."
					},
					"buttons": {
						"next": "Volgende",
						"back": "Terug"
					}
				},
				"confirm_copy": {
					"title": "Bevestig kopie",
					"disclaimer": "Alle bestaande informatie in de huidige MID wordt overschreven met gegevens uit",
					"merchant_id": "{mid}",
					"buttons": {
						"skipCopy": "Niet kopiëren",
						"confirmCopy": "Kopieer gegevens"
					}
				},
				"pre_assessment_summary": {
					"title": "Samenvatting",
					"subtitle": "Controleer de gegevens zorgvuldig voordat u deze indient voor acceptatie",
					"banner": {
						"mcc_deal": "Dit is een MCC-deal, volg de MCC-/ECC-escalatieroutine"
					},
					"selling_countries": {
						"title": "Selecteer de markt met het hoogste verwachte volume.",
						"main_selling_country": "Belangrijkste verkoopland"
					},
					"pre_assessment_products": {
						"title": "Producten"
					},
					"company_details": {
						"title": "Bedrijfsgegevens"
					},
					"fca_number": {
						"title": "FCA-nummer"
					},
					"high_exposure_questionnaires": {
						"title": "Vragenlijsten over hoge blootstelling"
					},
					"mia_questionnaires": {
						"title": "MIA-vragenlijsten"
					},
					"buttons": {
						"back": "Terug",
						"edit": "Bewerken",
						"submit": "Verzenden"
					}
				},
				"pre_assessment_overview": {
					"title": "Pre-beoordelingsoverzicht",
					"subtitle_APPROVED": "Hieronder vindt u de goedgekeurde voorwaarden voor deze mogelijkheid.",
					"subtitle_REJECTED": "Hieronder vindt u de geweigerde voorwaarden voor deze mogelijkheid.",
					"subtitle_UNRESOLVED": "U kunt de ingediende informatie wijzigen als u fouten ziet. Dit zal geen nieuwe casus activeren.",
					"status": {
						"APPROVED": "De casus is goedgekeurd",
						"REJECTED": "De casus is afgewezen",
						"UNRESOLVED": "We wachten op een acceptatie...",
						"UNRESOLVED_TIMED_OUT": "De zaak zal handmatig worden geaccepteerd. Houd er rekening mee dat dit meerdere dagen kan duren.",
						"UNRESOLVED_TIMED_OUT_LINK_LABEL": "Bekijk de zaak in de GUI voor Webwinkelbeoordeling",
						"STARTED": "De casus is ter beoordeling ingediend"
					},
					"buttons": {
						"change": "Wijzigen",
						"new_case": "Nieuwe casus"
					}
				},
				"recollection_introduction": {
					"title": {
						"default": "Hallo!"
					},
					"subtitle": {
						"default": [
							{
								"text": "Als gereguleerde onderneming onder toezicht van de Zweedse financiële toezichthouder is Klarna verplicht om het witwassen van geld te voorkomen, zoals bepaald in de EU-richtlijn EU 2015/849 (zoals gewijzigd of vervangen). Voor u als handelaar betekent deze richtlijn dat Klarna informatie verzamelt over de personen die uw bedrijf beheren (uiteindelijk gerechtigden) voordat u gebruik kunt maken van de diensten van Klarna. Bestaande handelaren zullen dergelijke informatie regelmatig verstrekken om ervoor te zorgen dat deze actueel is. Meer informatie vindt u in de EU-richtlijn"
							},
							{
								"text": "hier",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "."
							}
						]
					},
					"buttons": {
						"next": "Volgende"
					}
				},
				"recollection_confirmation": {
					"title": "Bevestiging",
					"subtitle": "Controleer de gegevens zorgvuldig voordat u deze indient voor acceptatie",
					"stakeholder": "Belanghebbende {index}",
					"buttons": {
						"back": "Terug",
						"submit": "Verzenden"
					}
				},
				"recollection_overview": {
					"title": "Dank u wel!",
					"subtitle": "Hier is een overzicht van de door u ingediende informatie.",
					"stakeholder": "Belanghebbende {index}",
					"notice": "Uw informatie is met succes ingediend."
				},
				"volume_separation": {
					"title_line_1": "Wat is de omvang van uw online bedrijf?",
					"subtitle": "Klarna biedt de beste oplossingen voor je bedrijf - groot of klein.",
					"selector_title": "Jaarlijkse opbrengst",
					"below": "Minder dan {threshold}",
					"between": "Tussen {belowThreshold} en {aboveThreshold}",
					"over": "Meer dan {threshold}",
					"buttons": {
						"back": "Terug"
					}
				},
				"basic_info": {
					"title_line_1": "Gebruik Klarna",
					"title_line_2": "voor je bedrijf.",
					"subtitle": "We hebben wat standaard informatie nodig om je naar de juiste plek te verwijzen.",
					"fields": {
						"email": {
							"label": "Zakelijk e-mailadres",
							"field_link": "Geen bedrijf?",
							"errors": {
								"required": "E-mailadres is verplicht",
								"invalid": "Voer een geldig e-mailadres in"
							}
						},
						"email_confirmation": {
							"label": "Bevestig zakelijk e-mailadres",
							"tooltip": "Uw zakelijke e-mail is de belangrijkste manier van communicatie met Klarna. Zorg dus dat het klopt",
							"errors": {
								"required": "E-mailadres ter bevestiging is vereist",
								"invalid": "Zorg ervoor dat u twee keer hetzelfde e-mailadres invoert"
							}
						},
						"website": {
							"label": "E-commerce URL",
							"errors": {
								"required": "E-commerce URL is verplicht",
								"invalid": "Voer een geldige URL in"
							}
						},
						"country": {
							"label": "Land van registratie",
							"errors": {
								"general": "Selecteer een van de beschikbare landen"
							}
						}
					},
					"buttons": {
						"continue": "Verder"
					}
				},
				"contact_details": {
					"title_line_1": "Laten we even praten.",
					"subtitle": "Vul dit formulier in en we nemen zo snel mogelijk contact met je op voor gepersonaliseerde oplossingen voor je bedrijf.",
					"fields": {
						"full_name": {
							"label": "Volledige naam",
							"errors": {
								"required": "Volledige naam is vereist"
							}
						},
						"phone": {
							"label": "Telefoonnummer",
							"tooltip": "Je moet de landcode invoeren, bijv. +1 541 754 3010",
							"errors": {
								"required": "Telefoonnummer is verplicht",
								"invalid": "Ongeldig telefoonnummer"
							}
						},
						"tell_us_more": {
							"label": "Vertel ons iets meer over je bedrijf (optioneel)"
						}
					},
					"buttons": {
						"back": "Terug",
						"submit": "Contactgegevens indienen"
					}
				},
				"contact_received": {
					"title": "We spreken je snel!",
					"message_1": "Ons salesteam zal zo snel mogelijk contact met je opnemen.",
					"message_2": "Ons team neemt zo spoedig mogelijk contact met je op. We hebben ook een bevestiging van de door jou verstrekte informatie gestuurd naar "
				},
				"we_are_sorry": {
					"title": "Onze excuses. We zijn niet in de mogelijkheid om uw aanmelding te accepteren.",
					"message_1_unsupported_country": "Klarna biedt momenteel geen ondersteuning voor het door u geselecteerde land:",
					"message_1_sensitive_goods": "Klarna ondersteunt de volgende product categorieen niet:",
					"message_1_platform": "Klarna ondersteunt het door jou geselecteerde e-commerce platform niet:",
					"message_2": "We zijn altijd op zoek naar nieuwe samenwerkingen. Zodra dit mogelijk is, nemen wij contact met je op.",
					"platform_alert": {
						"jtl4": [
							{
								"text": "U kunt nog steedsgebruik maken van de"
							},
							{
								"text": "plug-in",
								"link": "https://www.mollie.com/de/integrations/jtl"
							},
							{
								"text": "van onze partner Mollie."
							}
						]
					}
				},
				"platform": {
					"title_line_1": "Welk platform gebruik je?",
					"subtitle": "Kies je e-commerce platform en wij zorgen ervoor dat je bedrijf in een mum van tijd geïntegreerd is.",
					"custom": "Eigen integratie",
					"other_platform": "Andere integratie-oplossingen",
					"platform_search": {
						"label": "E-commerce oplossing",
						"no_match": "Geen resultaten gevonden voor \"{input}\""
					},
					"buttons": {
						"back": "Terug"
					}
				},
				"partner": {
					"title_line_1": "Met welke betaalservicepartner wilt u graag samenwerken?",
					"subtitle": "Kies de betaalservicepartner die het beste bij uw behoeften past."
				},
				"account_creation_loading": {
					"title": "Je account wordt aangemaakt...",
					"message": "Je bedrijfs-ID wordt ingesteld..."
				},
				"application_checking": {
					"title": "Je aanvraag wordt gecontroleerd..",
					"message": "Winkelgegevens worden geanalyseerd"
				},
				"application_review": {
					"title": "We beoordelen je aanvraag.",
					"title_approved": "Uw aanvraag is goedgekeurd!",
					"message": "Dit is een handmatig proces, dus de verwerkingstijd kan variëren, maar we zullen het zo snel mogelijk verwerken.",
					"email_info_1": "We hebben u een e-mail gestuurd met als onderwerp \"{subject}\".",
					"email_info_2": "Volg de stappen die hierin staan vermeld om in te loggen en de status van uw aanvraag te volgen.",
					"email_info_2_approved": "Volg de stappen die hierin staan vermeld om in te loggen en Klarna in uw e-commerce winkel te integreren.",
					"email_subject": "Welkom bij Klarna's Merchant Portal",
					"resend_email": "Verstuur e-mail opnieuw"
				},
				"user_already_exists": {
					"title": "Log in op de Merchant Portal om verder te gaan.",
					"message_1": "Dit e-mailadres is al gekoppeld aan een Merchant Portal-account. Om wijzigingen aan te brengen in je bestaande account, moet je inloggen",
					"log_in": "Log in op de Merchant Portal",
					"forgot_password": "Wachtwoord vergeten?"
				},
				"otherPlatform": {
					"info": "We hebben al een integratie voor {platform}",
					"link": "Start hier met de integratie",
					"title": "Smoooth, u kunt direct integreren!",
					"info2": "Goed nieuws! U kunt Klarna direct in uw e-commerce integreren vanuit <strong>{platform}</strong>.",
					"link2": "Ga naar {platform} + Klarna Integratie"
				},
				"noLandingPagePlatform": {
					"text": {
						"one": {
							"default": "Neem rechtstreeks contact op met ons salesteam",
							"SE": "Neem rechtstreeks contact op met ons salesteam op"
						}
					}
				},
				"sensitive_goods": {
					"title_2": "Biedt u een van de volgende producten of diensten aan?",
					"subtitle_2": "Klarna definieert bepaalde artikelen mogelijk als beperkt op basis van de markt, wetgeving, verkoopvolume, risicobereidheid en andere beperkingen die mogelijk zijn toegestaan. Deze mogen niet worden verwerkt zonder goedkeuring van Klarna.",
					"titleV2": "Kies welke van de dingen hieronder voor jouw bedrijf geldt.",
					"goodsCategories": {
						"CBD_HEMP_TOBACCO_ECIGARETTES_VAPE": {
							"title_2": "Producten met leeftijdsbeperkingen",
							"description_2": "Tabak, e-sigaretten, vape, cannabisproducten, alcohol, inhoud bestemd voor volwassenen"
						},
						"EVENTS_TICKETS_TOURISM_TRAVEL_VOUCHERS": {
							"title_2": "Reizen, excursies en evenementen",
							"description_2": "Vervoer, evenementen, ticketplatform, hotels of accommodaties, verhuur, reisbureaus"
						},
						"WEAPONS_AMMUNITION": {
							"title_2": "Wapens met vergunning",
							"description_2": "Munitie, vechtmessen, jachtuitrusting, knuppels, pepperspray"
						},
						"MARKETPLACE": {
							"title_2": "Rechtstreekse markt",
							"description_2": "Diensten die derde partijen de mogelijkheid bieden om hun goederen door te verkopen of diensten aan te bieden via hun online platform"
						},
						"PHARMACEUTICALS": {
							"title_2": "Farmaceutisch en medische diensten",
							"description_2": "Distributie van geneesmiddelen op voorschrift, medische procedures inclusief esthetica en tatoeages"
						},
						"SERVICES_SUBSCRIPTIONS_MEMBERSHIPS_RENTALS_CONTENT": {
							"title_2": "Lidmaatschappen, abonnementen en diensten",
							"description_2": "Abonnementen voor fysieke goederen, digitale inhoud, streamingdiensten, datingsites, enz."
						},
						"NONE": {
							"title_2": "Ik bied een ander soort product/dienst aan"
						}
					},
					"link": "Meer over beperkte items",
					"buttons": {
						"next": "Volgende",
						"continue": "Verder"
					}
				}
			},
			"address_form_component": {
				"postal_code": {
					"tooltip": {
						"default": "Voer je postcode in om andere delen van je adres automatisch in te vullen",
						"US": "Voer je postcode in om andere delen van je adres automatisch in te vullen"
					},
					"label": {
						"default": "Postcode",
						"US": "Postcode"
					},
					"error": {
						"default": "Voer een geldige postcode in",
						"US": "Voer een geldige postcode in"
					}
				},
				"city": {
					"label": "Woonplaats",
					"error": "Voer een stad in"
				},
				"street": {
					"label": "Adres",
					"error": "Voer een adres in",
					"tooltip": "Begin met typen om meer straatsuggesties te zien",
					"no_suggestion_found": "Geen resultaten voor {input}"
				},
				"country": {
					"label": "Land",
					"error": "Selecteer een land"
				},
				"region": {
					"label": "Staat/provincie (optioneel)"
				},
				"state": {
					"label": "Staat/Provincie",
					"error": "Voer een staat/provincie in"
				}
			},
			"platforms": {
				"custom": "API-integratie",
				"other": "Ik kan mijn platform niet vinden"
			},
			"buttons": {
				"back": "Terug"
			},
			"products": {
				"not_available": "Niet beschikbaar op {reason}",
				"not_available_country": "Niet beschikbaar in uw land",
				"not_available_platform": "Niet beschikbaar op {platform}",
				"why_product": "Waarom Klarna {name}",
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Vervang de betaalomgeving van uw winkel door Klarna’s complete betaalservices."
					},
					"description_expanded": {
						"default": "Vervang de betaalomgeving van uw winkel door Klarna’s complete betaalservices."
					},
					"options": {
						"kco_one-pay-now": {
							"name": {
								"default": "Betaal nu"
							},
							"description": {
								"default": "Bied directe betalingen aan via bankoverschrijving of SEPA direct debit"
							}
						},
						"kco_one-pay-later": {
							"name": {
								"default": "Betalen in 30 dagen"
							},
							"description": {
								"default": "Betalen in 30 dagen aanbieden. Geen rente."
							}
						},
						"kco_one-slice-it": {
							"name": {
								"default": "Financiering"
							},
							"description": {
								"default": "Betalen in 6-36 maanden aanbieden.",
								"DE": "Betalen in 6-24 maanden aanbieden",
								"AT": "Betalen in 6-24 maanden aanbieden."
							}
						},
						"kco_one-slice-it-in-3": {
							"name": {
								"default": "Afbetalingstermijnen"
							},
							"description": {
								"default": "3 rentevrije afbetalingstermijnen aanbieden.",
								"GB": "3 rentevrije afbetalingstermijnen aanbieden."
							}
						},
						"kco_one-slice-it-in-4": {
							"name": {
								"default": "Slice it in 4",
								"US": "Afbetalingstermijnen",
								"AU": "Betaal in 4 delen"
							},
							"description": {
								"default": "4 rentevrije afbetalingstermijnen aanbieden.",
								"GB": "4 rentevrije afbetalingstermijnen aanbieden."
							}
						}
					},
					"features": {
						"other_payment_options": {
							"name": {
								"default": "Andere betaalopties"
							},
							"description": {
								"default": "Creditcards, debitcards en meer"
							}
						},
						"on_site_messaging": {
							"name": {
								"default": "Berichtgeving op website"
							}
						},
						"billing": {
							"name": {
								"default": "Automatische identificatie en facturering"
							}
						},
						"shipping": {
							"name": {
								"default": "Gepersonaliseerde verzendopties"
							}
						},
						"post_purchase": {
							"name": {
								"default": "Ondersteuning na aankoop"
							}
						}
					}
				},
				"kp_one": {
					"name": {
						"default": "Betaalmethode"
					},
					"description": {
						"default": "Voeg Klarna betaalmethoden toe aan uw betaalomgeving"
					},
					"description_expanded": {
						"default": "Door Klarna-betaalmethoden aan te bieden, stijgt de conversie tot gemiddeld 30%, de AOV 41% en de aankoopfrequentie 36%."
					},
					"options": {
						"kp_one-pay-now": {
							"name": {
								"default": "Betaal nu"
							},
							"description": {
								"default": "Bied directe betalingen aan via bankoverschrijving of SEPA direct debit"
							}
						},
						"kp_one-pay-later": {
							"name": {
								"default": "Betalen in 30 dagen"
							},
							"description": {
								"default": "Klanten betalen 30 dagen na aankoop, zonder rente."
							}
						},
						"kp_one-slice-it": {
							"name": {
								"default": "Financiering"
							},
							"description": {
								"default": "Klanten kunnen in 6 tot 36 maanden betalen.",
								"DE": "Klanten kunnen in 6 tot 24 maanden betalen",
								"AT": "Klanten kunnen in 6 tot 24 maanden betalen."
							}
						},
						"kp_one-slice-it-in-3": {
							"name": {
								"default": "Afbetalingstermijnen"
							},
							"description": {
								"default": "3 rentevrije afbetalingstermijnen aanbieden.",
								"GB": "3 rentevrije afbetalingstermijnen aanbieden."
							}
						},
						"kp_one-slice-it-in-4": {
							"name": {
								"default": "Slice it in 4",
								"US": "4 Betalingen",
								"CA": "4 betalingen",
								"AU": "Betaal in 4 delen"
							},
							"description": {
								"default": "4 rentevrije afbetalingstermijnen aanbieden.",
								"GB": "4 rentevrije afbetalingstermijnen aanbieden.",
								"US": "Bestellingen van $35 tot $1000 kunnen worden opgesplitst in 4 rentevrije betalingen, die elke 2 weken moeten worden voldaan.",
								"CA": "Bestellingen van € 35 tot € 1000 kunnen worden opgesplitst in 4 rentevrije betalingen, elke 2 weken te voldoen."
							}
						},
						"kp_one-pay-by-card": {
							"name": {
								"default": "Betalen met kaart"
							},
							"description": {
								"default": "Bied directe betalingen aan via creditcard of bankoverschrijving"
							}
						}
					}
				}
			}
		},
		"fields": {
			"enm": {
				"product_channel": {
					"label": "Hoe wil je je verkopen doen?",
					"options": {
						"IN_STORE": "Fysieke winkel",
						"TELESALES": "Televerkoop"
					},
					"description": {
						"IN_STORE": "De verkoop gebeurt voornamelijk persoonlijk en de klant krijgt de artikelen meteen mee.",
						"TELESALES": "De verkoop gebeurt voornamelijk via de telefoon vanuit inkomende klantengesprekken. De klant krijgt de artikelen niet meteen."
					}
				},
				"country": {
					"label": "Land"
				},
				"organization_category": {
					"label": "Type rechtspersoon",
					"options": {
						"SOLE_TRADER": "Zelfstandige handelaar",
						"PARTNERSHIP": "Partnerschap",
						"UNDEFINED": "ONBEPAALD",
						"BV": "BV",
						"CV": "CV",
						"CVOA": "CVOA",
						"EEN": "EEN",
						"MTS": "MTS",
						"NV": "NV",
						"SE": "SE",
						"VOF": "VOF",
						"C_CORP": "C-bedrijf",
						"S_CORP": "S-bedrijf",
						"TRUST_ESTATE": "Trust/nalatenschap",
						"INDIVIDUAL": "Individu",
						"SOLE_PROPRIETORSHIP": "Eenmanszaak",
						"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Naamloze vennootschap met enkel lid",
						"LIMITED_LIABILITY_COMPANY": "Naamloze vennootschap",
						"PUBLIC_LISTED_COMPANY": "Beursgenoteerd bedrijf",
						"PRIVATE_COMPANY": "PRIVAAT_BEDRIJF"
					}
				},
				"store_category": {
					"label": "Hoofdcategorie verkochte goederen",
					"options": {
						"ADULT_SHOES_AND_CLOTHING": "Kleding en schoenen - Schoenen en kleding voor volwassenen",
						"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Automobielproducten - Auto-onderdelen en accessoires",
						"BAGS_AND_WALLETS": "Sieraden en accessoires - Tassen en portemonnees",
						"BODY_AND_HAIR_CARE": "Gezondheid en schoonheid - Lichaams- en haarverzorging",
						"BOOK_AND_MAGAZINES": "Entertainment - Boeken en tijdschriften",
						"CANDY": "Voedsel en drank - Snoep",
						"CAR_ELECTRONICS": "Elektronica - Auto-elektronica",
						"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Kinderproducten - Kinderkleding en verzorgingsproducten",
						"CHILDREN_TOYS": "Kinderproducten - Speelgoed voor kinderen",
						"CLEANING_AND_SANITARY": "Huis en tuin - Schoonmaak en hygiëne",
						"COLLECTIBLES": "Vrije tijd, sport en hobby - Verzamelobjecten",
						"CONCEPT_STORES_AND_MISCELLANEOUS": "Vrije tijd, sport en hobby - Conceptwinkels en diverse",
						"COSMETICS": "Gezondheid en schoonheid - Cosmetica",
						"COSTUMES_AND_PARTY_SUPPLIES": "Vrije tijd, sport en hobby - Kostuums en feestspullen",
						"DATING_SERVICES": "Immateriële producten - Datingservices",
						"DECORATION_AND_ART": "Huis en tuin - Decoratie en kunst",
						"DIETARY_SUPPLEMENTS": "Gezondheid en schoonheid - Voedingssupplementen",
						"DIGITAL_SERVICES": "Immateriële producten - Digitale diensten",
						"DIVERSIFIED_CHILDREN_PRODUCTS": "Kinderproducten - Diverse kinderproducten",
						"DIVERSIFIED_ELECTRONICS": "Elektronica - Diverse elektronica",
						"DIVERSIFIED_ENTERTAINMENT": "Entertainment - Divers entertainment",
						"DIVERSIFIED_EROTIC_MATERIAL": "Erotische materialen - Divers erotisch materiaal",
						"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Gezondheid en schoonheid - Diverse gezondheids- en schoonheidsproducten",
						"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Huis en tuin - Diverse huis- en tuinproducten",
						"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Sieraden en accessoires - Diverse juwelen en accessoires",
						"EDUCATION": "Immateriële producten - Onderwijs",
						"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Elektronica - Elektronische apparatuur en bijbehorende accessoires",
						"EROTIC_CLOTHING_AND_ACCESSORIES": "Erotische materialen - Erotische kleding en accessoires",
						"EVENT_TICKETS": "Immateriële producten - Evenementtickets",
						"FOOD_AND_BEVERAGE": "Voedsel en drank - Voedsel en drank",
						"FRAGRANCES": "Gezondheid en schoonheid - Geuren",
						"FURNITURE": "Huis en tuin - Meubilair",
						"GENERAL_SHOES_AND_CLOTHING": "Kleding en schoenen - Algemene schoenen en kleding",
						"HOBBY_ARTICLES": "Vrije tijd, sport en hobby - Hobby-artikelen",
						"HOUSEHOLD_ELECTRONICS": "Elektronica - Elektronica voor in huis",
						"JEWELRY_AND_WATCHES": "Sieraden en accessoires - Sieraden en horloges",
						"KITCHENWARE": "Huis en tuin - Keukengerei",
						"MARKETPLACES": "Immateriële producten - Marktplaatsen",
						"MUSIC_AND_MOVIES": "Entertainment - Muziek en films",
						"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Vrije tijd, sport en hobby - Muziekinstrumenten en apparatuur",
						"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Sieraden en accessoires - Zonnebrillen en lenzen zonder recept",
						"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Elektronica - Kantoormachines en bijbehorende accessoires",
						"OTHER_SERVICES": "Immateriële producten - Overige diensten",
						"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Gezondheid en schoonheid - Persoonlijke verzorging en lichaamsverbetering",
						"PET_SUPPLIES": "Huis en tuin - Huisdierbenodigdheden",
						"PHARMACEUTICAL_PRODUCTS": "Gezondheid en schoonheid - Farmaceutische producten",
						"PLANTS_AND_FLOWERS": "Huis en tuin - Planten en bloemen",
						"PRESCRIPTION_OPTICS": "Gezondheid en schoonheid - Voorgeschreven optica",
						"PRINTS_AND_PHOTOS": "Vrije tijd, sport en hobby - Prints en foto's",
						"SAFETY_PRODUCTS": "Huis en tuin - Veiligheidsproducten",
						"SEX_TOYS": "Erotische materialen - Seksspeeltjes",
						"SPORTS_GEAR_AND_OUTDOOR": "Vrije tijd, sport en hobby - Sportuitrusting en outdoor",
						"TOBACCO": "Voedsel en drank - Tabak",
						"TOOLS_AND_HOME_IMPROVEMENT": "Huis en tuin - Gereedschap en doe-het-zelven",
						"TRAVEL_SERVICES": "Immateriële producten - Reisdiensten",
						"UNDERWEAR": "Kleding en schoenen - Ondergoed",
						"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Entertainment - Videogames en bijbehorende accessoires",
						"WHEELS_AND_TIRES": "Automobielproducten - Wielen en banden",
						"WINE_BEER_AND_LIQUOR": "Voedsel en drank - Wijn, bier en drank",
						"YOUTHFUL_SHOES_AND_CLOTHING": "Kleding en schoenen - Schoenen en kleding voor jongeren"
					}
				},
				"currency": {
					"label": "Valuta"
				},
				"account_type": {
					"label": "Type bankrekening",
					"options": {
						"IBAN": "IBAN",
						"LOCAL_SE": "Lokaal Zweden",
						"LOCAL_US": "Lokaal VS",
						"LOCAL_GENERIC": "Lokaal Noorwegen/Denemarken",
						"SPECIAL": "Speciaal",
						"BANKGIRO": "Lokaal Zweden Bankgiro",
						"PLUSGIRO": "Lokaal Zweden Plusgiro"
					}
				},
				"person_role": {
					"label": "Rol",
					"options": {
						"LEGAL_REPRESENTATIVE": "Juridisch vertegenwoordiger",
						"ALTERNATIVE_BENEFICIAL_OWNER": "Alternatieve begunstigde eigenaar",
						"ULTIMATE_BENEFICIAL_OWNER": "Uiteindelijke begunstigde eigenaar",
						"OWNER": "Eigenaar"
					}
				},
				"business_size": {
					"label": "Grootte bedrijf",
					"options": {
						"LARGE": "groot",
						"MEDIUM": "middel",
						"small": "klein"
					}
				},
				"sensitive_good_category": {
					"label": "Biedt u een van de volgende producten of diensten aan in uw fysieke winkel?",
					"options": {
						"AGE_RESTRICTED_PRODUCTS": "Producten met leeftijdsbeperkingen",
						"LICENSED_WEAPONS": "Wapens met vergunning",
						"PHARMA_AND_MEDICAL_SERVICES": "Farmaceutisch en medische diensten",
						"TRAVEL_TOURS_EVENTS": "Reizen, excursies en evenementen",
						"PEER_TO_PEER_MARKETPLACE": "Rechtstreekse markt",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Lidmaatschappen, abonnementen en diensten",
						"NONE": "Ik bied een ander soort product/dienst aan"
					},
					"description": {
						"AGE_RESTRICTED_PRODUCTS": "Tabak, e-sigaretten, vape, cannabisproducten, alcohol, inhoud bestemd voor volwassenen",
						"LICENSED_WEAPONS": "Munitie, vechtmessen, jachtuitrusting, knuppels, pepperspray",
						"PHARMA_AND_MEDICAL_SERVICES": "Distributie van geneesmiddelen op voorschrift, medische procedures inclusief esthetica en tatoeages",
						"TRAVEL_TOURS_EVENTS": "Vervoer, evenementen, ticketplatform, hotels of accommodaties, verhuur, reisbureaus",
						"PEER_TO_PEER_MARKETPLACE": "Diensten die derde partijen de mogelijkheid bieden om hun goederen door te verkopen of diensten aan te bieden via hun online platform",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Abonnementen voor fysieke goederen, digitale inhoud, streamingdiensten, datingsites, enz.",
						"NONE": "Ik bied een ander soort product/dienst aan"
					},
					"error_message": "Wat vervelend. We kunnen niet verder gaan met uw aanvraag omdat we momenteel het type product of diensten dat u hebt geselecteerd niet ondersteunen."
				}
			},
			"common": {
				"country": {
					"label": "Land"
				},
				"address": {
					"city": {
						"label": "Woonplaats"
					},
					"postal_code": {
						"label": "Postcode"
					},
					"region": {
						"label": "Staat/regio"
					},
					"street_address": {
						"label": "Adres van de fysieke winkel"
					},
					"street_address2": {
						"label": "Adresregel 2"
					}
				}
			},
			"payload": {
				"business_information": {
					"company_name": {
						"label": "Bedrijfsnaam"
					},
					"registration_authority": {
						"label": "Autoriteit van registratie"
					},
					"registration_id": {
						"label": "Registratienummer"
					},
					"subject_to_vat": {
						"label": "Is uw bedrijf geregistreerd voor btw?"
					},
					"vat_id": {
						"label": "Btw-nummer"
					},
					"persons": {
						"date_of_birth": {
							"label": "Geboortedatum"
						},
						"first_name": {
							"label": "Voornaam"
						},
						"last_name": {
							"label": "Achternaam"
						},
						"person_identity_document": {
							"label": "Identiteitsbewijs"
						},
						"person_proof_of_address": {
							"label": "Bewijs van adres"
						},
						"personal_identifier": {
							"label": "Persoonlijk ID"
						}
					},
					"should_auto_capture_orders": {
						"label": "Wilt u bestellingen automatisch activeren?",
						"tooltip": "Bestellingen moeten worden geactiveerd wanneer ze in de winkel worden afgegeven of wanneer ze vanuit een magazijn worden verzonden. Als u automatisch activeren selecteert, wordt de bestelling automatisch geactiveerd wanneer de klant de aankoop bevestigt."
					}
				},
				"contract_entity": {
					"label": "Contractuele entiteit"
				},
				"contract_onboarding_type": {
					"label": "Type onboarding van zakenpartners"
				},
				"underwriting_inquiry_email": {
					"label": "E-mail voor acceptatie"
				},
				"bank_accounts": {
					"account_holder": {
						"label": "Naam rekeninghouder"
					},
					"account_number": {
						"label": "Rekeningnummer"
					},
					"bic": {
						"label": "BIC-code"
					},
					"iban": {
						"label": "Rekeningnummer (IBAN)"
					},
					"is_default": {
						"label": "Gebruik deze rekening voor niet-gespecificeerde valuta's"
					},
					"routing_number": {
						"label": "Routingnummer"
					}
				},
				"in_stores": {
					"contact_email": {
						"label": "E-mailadres voor contact"
					},
					"name": {
						"label": "Naam webwinkel"
					},
					"support_email": {
						"label": "E-mail klantenservice"
					},
					"support_phone": {
						"label": "Telefoonnummer voor support"
					},
					"business_concepts": {
						"options": {
							"TRADITIONAL_SALE_OF_GOODS": "Traditionele verkoop van goederen",
							"VOUCHER": "Voucher",
							"MEMBERSHIP": "Lidmaatschap",
							"SUBSCRIPTION": "Abonnement",
							"PHARMACIES": "Apotheken",
							"US_PHARMACIES": "Apotheken in de VS",
							"MEDICAL_SERVICES": "Medische diensten",
							"MARKETPLACES": "Marktplaatsen",
							"FIREARM_DEALERS": "Wapenhandelaar",
							"AUCTIONS": "Veilingen",
							"ALCOHOL": "Alcohol",
							"TOBACCO": "Tabak",
							"HEMP_CBD_THC": "Hennep, CBD of THC",
							"DONATIONS_CHARITY": "Donaties en liefdadigheidsinstellingen",
							"TRAVEL": "Reizen",
							"EVENTS": "Evenementen",
							"COURSES": "Cursussen",
							"EDUCATIONAL_COURSES": "",
							"FOOD_DELIVERY": "",
							"CUSTOMISED_PRE_ORDER_FURNITURE": "",
							"DIGITAL_CONTENT": "",
							"GAMING_INDUSTRY": ""
						}
					}
				},
				"terms_and_conditions": {
					"default": "Algemene voorwaarden",
					"UPSELL_WEBSTORE_TO_KPOS": "Voorwaarden voor Klarna In-store"
				},
				"pricing_terms": {
					"default": "Prijsvoorwaarden",
					"UPSELL_WEBSTORE_TO_KPOS": "Prijzen voor Klarna In-store"
				}
			}
		},
		"group": {
			"title": {
				"additional_data": "Aanvullende informatie",
				"bank_account": "Wat zijn uw bankgegevens?",
				"business_size": "Wat is uw verwachte jaarlijkse volume via het Klarna Verkooppunt?",
				"in_store_get_started": "Ga aan de slag met Klarna.",
				"in_store_legal_form": "Welke soort bedrijf hebt u?",
				"in_store_registered_address": "Wat is uw geregistreerde adres?",
				"in_store_registration": "Is uw bedrijf een geregistreerd bedrijf?",
				"in_store_stakeholder": "Wie beheert het bedrijf?",
				"in_store_stores": "Wat zijn uw winkelgegevens van het Klarna Verkooppunt?",
				"in_store_vat": "Is uw bedrijf geregistreerd voor btw?",
				"product_channel": "Hoe gaat uw bedrijf het Klarna Verkooppunt gebruiken?",
				"sensitive_goods": "Welke categorie producten gaat u verkopen met het Klarna Verkooppunt?",
				"ads_manager_get_started": "Je bent er bijna.",
				"content_store_get_started": "Je bent er bijna."
			},
			"subtitle": {
				"additional_data": "Wij behandelen uw aanvraag en hebben meer informatie nodig om verder te kunnen gaan.",
				"bank_account": "Klarna-transacties worden naar deze bankrekening overgemaakt.",
				"business_size": "Wij hebben enkele basisgegevens over uw bedrijf nodig om uw aanvraag te verwerken.",
				"in_store_get_started": "Wij hebben wat basisinformatie nodig om u naar de juiste plaats te brengen",
				"in_store_legal_form": "We zijn verplicht bepaalde specifieke vragen te stellen op basis van uw bedrijfstype.",
				"in_store_registered_address": "Dit is waar uw bedrijf wettelijk is geregistreerd, en verschijnt op de facturen van uw Klarna-klanten.",
				"in_store_registration": "We hebben uw bedrijfsregistratienummer nodig om uw bedrijfsgegevens te bevestigen.",
				"in_store_stakeholder": "Als financiële instelling zijn wij verplicht deze informatie te vergaren",
				"in_store_stores": "We gebruiken de informatie om uw nieuwe Klarna Verkoopunt-account op te zetten.",
				"in_store_vat": "We kunnen uw bedrijfsgegevens gemakkelijker controleren als u een btw-nummer heeft.",
				"product_channel": "Kies het verkoopkanaal van uw voorkeur. U kunt het Klarna Verkoopunt voor beide kanalen gebruiken.",
				"sensitive_goods": "Met de self-service onboarding voor Klarna Verkooppunt kunt u geen artikelen verkopen die door Klarna als beperkt zijn gedefinieerd.",
				"ads_manager_get_started": "Geef een e-mailadres op waar de campagnefacturen naartoe worden gestuurd. Je moet een admin-gebruiker zijn om het account te activeren. De beheerder kan dan machtigingen toekennen aan andere gebruikers.",
				"content_store_get_started": "Lees en accepteer onze Algemene voorwaarden voordat je toegang krijgt tot de Content Manager."
			},
			"summary": {
				"title": "Controleer uw gegevens voordat u uw aanvraag indient"
			},
			"status": {
				"UNDERWRITING_INITIATED": {
					"title": {
						"default": "We verwerken uw aanvraag. Dit kan even duren.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Een moment geduld...",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Een moment geduld..."
					},
					"paragraphs": {
						"default": [
							{
								"text": "Uw aanvraag wordt verwerkt en we maken uw nieuwe Webwinkel-ID aan."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "We bereiden alles voor voor uw Ads Manager-account."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "We maken alles klaar voor uw Content Manager-account."
							}
						]
					}
				},
				"ONBOARDING_COMPLETED": {
					"title": {
						"default": "Gefeliciteerd! Uw aanvraag is goedgekeurd.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "U bent helemaal klaar!",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "U bent helemaal klaar!"
					},
					"paragraphs": {
						"default": [
							{
								"text": "Laten we nu Klarna in uw online winkel integreren. Ga naar het tabblad Producten in uw Webshop portaal-account voor uw integratiegegevens en voor het gebruik ervan."
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Laten we nu uw winkel opzetten zodat u meteen betalingen kunt ontvangen."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Ga naar Ads Manager en begin met het maken van je eerste campagne."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Ga naar de Content Manager en publiceer vandaag nog je eerste aanbieding."
							}
						]
					},
					"second_title": {
						"default": "Raadpleeg de Klarna-documenten voor meer informatie over de integratie met Klarna",
						"UPSELL_WEBSTORE_TO_KPOS": "Hulp nodig bij het opzetten van uw winkel? Wij staan voor u klaar",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Heb je hulp nodig bij het gebruik van de Ads Manager? Lees onze veelgestelde vragen of neem contact op met onze bedrijfssupport, we helpen je graag verder.",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Heb je hulp nodig bij het gebruik van de Content Manager? Lees onze veelgestelde vragen of neem contact op met onze bedrijfssupport, we helpen je graag verder."
					},
					"second_paragraphs": {
						"default": [
							{
								"text": "Onze richtlijnen voor beste praktijken kunnen u helpen het meeste te halen uit uw nieuwe partnerschap met ons."
							},
							{
								"text": "Klarna-betaling",
								"link": "#"
							},
							{
								"text": "Klarna Payments",
								"link": "#"
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Neem contact op met onze Webwinkel support, wij helpen u graag."
							},
							{
								"text": "Neem contact op met Support",
								"link": "https://www.klarna.com/se/foretag/butikssupport/"
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Lees de veelgestelde vragen.",
								"link": "https://portal.klarna.com/?help-page=topic%3Aads-manager"
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Lees de veelgestelde vragen.",
								"link": "https://portal.klarna.com/?help-page=topic%3Acontent-manager"
							}
						]
					},
					"button_text": {
						"default": "Aan de slag.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Aan de slag",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Aan de slag",
						"UPSELL_WEBSTORE_TO_KPOS": "Begin met verkopen"
					}
				},
				"MANUAL_UNDERWRITING_INITIATED": {
					"title": "Hartelijk dank! Wij hebben uw aanvraag ontvangen.",
					"badge": "Ongeveer 5 tot 7 dagen",
					"paragraphs": [
						{
							"text": "U ontvangt een e-mail wanneer onze beoordeling is voltooid, of wanneer wij extra gegevens nodig hebben."
						}
					],
					"second_title": "Controleer ondertussen uw e-mail",
					"second_paragraphs": [
						{
							"text": "We hebben u een e-mail gestuurd met als onderwerp-link ‘Welkom bij het Webshop portaal van Klarna’. Volg deze stappen om in te loggen en uw account te activeren."
						}
					]
				},
				"SUSPENDED": {
					"title": "Uw aanvraag is helaas niet goedgekeurd.",
					"paragraphs": [
						{
							"text": "Na controle van uw bedrijfsgegevens kunnen wij uw aanvraag voor <strong>{businessName}</strong> niet in behandeling nemen."
						},
						{
							"text": "Dit zijn enkele van de meest voorkomende redenen:"
						},
						{
							"list": [
								{
									"text": "Uw winkel voldoet niet aan de ethische richtlijnen van Klarna."
								},
								{
									"text": "Uw klantenservice is onbereikbaar."
								},
								{
									"text": "Andere administratieve redenen."
								}
							]
						},
						{
							"text": "Bedankt voor uw interesse in <strong>Klarna [In-store]</strong>. We hopen dat we in de toekomst samen kunnen werken."
						}
					],
					"second_title": "Als u nog vragen heeft",
					"second_paragraphs": [
						{
							"text": "met betrekking tot onze beslissing of een ander Klarna-product kunt u contact met ons opnemen, wij helpen u graag verder."
						}
					]
				}
			},
			"stakeholders": {
				"LEGAL_REPRESENTATIVE": {
					"title": {
						"default": "Wie tekent de contracten voor uw bedrijf?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Uw bedrijf staat op het punt om een contract te sluiten met Klarna. We moeten nagaan wie wettelijk bevoegd is om contracten te ondertekenen."
							}
						]
					}
				},
				"OWNER": {
					"title": {
						"default": "Zijn er mensen die meer dan 25% van het bedrijf bezitten?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Als financiële instelling zijn wij wettelijk verplicht deze informatie te verzamelen."
							}
						],
						"default": [
							{
								"text": "We willen weten welke mensen meer dan 25% van de aandelen of het stemrecht van het bedrijf bezitten of een soortgelijke controle hebben. Wij zijn volgens de EU-richtlijn inzake witwaspraktijken ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") wettelijk verplicht om deze informatie te verzamelen."
							}
						]
					}
				},
				"ALTERNATIVE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Wie beheert het bedrijf?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Wij zijn wettelijk verplicht door de anti-witwasrichtlijn van de EU ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") wettelijk verplicht om deze informatie te verzamelen."
							}
						],
						"US": [
							{
								"text": "Als financiële instelling zijn wij wettelijk verplicht deze informatie te verzamelen."
							}
						],
						"CA": [
							{
								"text": "Als financiële instelling zijn wij wettelijk verplicht deze informatie te verzamelen."
							}
						],
						"AU": [
							{
								"text": "Als financiële instelling zijn wij wettelijk verplicht deze informatie te verzamelen."
							}
						]
					}
				},
				"ULTIMATE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Zijn er mensen die meer dan 25% van het bedrijf bezitten?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Als financiële instelling zijn wij wettelijk verplicht deze informatie te verzamelen."
							}
						],
						"default": [
							{
								"text": "We willen weten welke mensen meer dan 25% van de aandelen of het stemrecht van het bedrijf bezitten of een soortgelijke controle hebben. Wij zijn volgens de EU-richtlijn inzake witwaspraktijken ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") wettelijk verplicht om deze informatie te verzamelen."
							}
						]
					}
				}
			}
		},
		"product-selection-container": {
			"products": {
				"products_block": {
					"title_1": "Oplossingen",
					"title_2": "Betaalmethoden",
					"note": "Alle prijzen zijn per transactie.",
					"per_transaction": "per transactie",
					"cross_border_notice": "Er kunnen aanvullende tarieven voor transacties naar het buitenland van toepassing zijn",
					"cross_border_notice_pricing_annex_suffix": {
						"before_link": "raadpleeg",
						"link_text": "prijsbijlage"
					},
					"not_available_for_business": "Niet beschikbaar voor jouw bedrijf",
					"not_available_for_country": "U kunt alleen verkopen aan andere landen",
					"not_compatible_with_platform": "Niet beschikbaar voor uw platform",
					"installed": "Geïnstalleerd"
				},
				"buttons": {
					"next": "Volgende"
				}
			}
		}
	}
};